// Code generated by tygo. DO NOT EDIT.
/* eslint-disable */
/* prettier-ignore */

//////////
// source: auth.go

/**
 * The frame types of the aichat.auth session.
 */
export const FrameAuthWant = "aichat.auth.want";
/**
 * The frame types of the aichat.auth session.
 */
export const FrameAuthConnect = "aichat.auth.connect";
/**
 * The frame types of the aichat.auth session.
 */
export const FrameLogin = "aichat.login";
/**
 * A login's id is 26 characters of lower-case base32: 128 random bits, opaque, the broker's file
 * name for its token and the key every grant, meter and row names it by. A member holds at most
 * MaxLoginsPerMember logins that are not disconnected, and a machine holds at most
 * MaxLoginsPerMachine tokens.
 */
export const LoginIDPattern = `^[a-z2-7]{26}\$`;
/**
 * A login's id is 26 characters of lower-case base32: 128 random bits, opaque, the broker's file
 * name for its token and the key every grant, meter and row names it by. A member holds at most
 * MaxLoginsPerMember logins that are not disconnected, and a machine holds at most
 * MaxLoginsPerMachine tokens.
 */
export const MaxLoginsPerMember = 5;
/**
 * A login's id is 26 characters of lower-case base32: 128 random bits, opaque, the broker's file
 * name for its token and the key every grant, meter and row names it by. A member holds at most
 * MaxLoginsPerMember logins that are not disconnected, and a machine holds at most
 * MaxLoginsPerMachine tokens.
 */
export const MaxLoginsPerMachine = 64;
/**
 * DefaultLoginLabel is the label of a login nobody named: an adoption whose operator gave none (the
 * adopt verb's default, teamBase's reading of an adoption without one, and the fake machine's).
 */
export const DefaultLoginLabel = "work";
/**
 * MaxLoginLabel bounds a login's label, the member's own word for it ("work"), in bytes.
 */
export const MaxLoginLabel = 40;
/**
 * The bounds of a token as `claude setup-token` prints it: printable ASCII without a space, so it can
 * travel as a header value as it stands, of a length no real token falls outside.
 */
export const MinTokenBytes = 20;
/**
 * The bounds of a token as `claude setup-token` prints it: printable ASCII without a space, so it can
 * travel as a header value as it stands, of a length no real token falls outside.
 */
export const MaxTokenBytes = 512;
/**
 * AuthWant is aichat.auth.want: every turn that may spend a login now, the cut-offs in force, every
 * login teamBase keeps a token for, and the adoptions it refused. The broker takes each want whole —
 * a binding whose grant went away ends, a cut-off starts and stops with it, a stored token no login
 * names any more is deleted — so a lost want is healed by the next one rather than by a replay.
 */
export interface AuthWant {
	grants: AuthGrant[];
	cutoff: AuthCutoff[];
	/**
	 * Logins are the logins whose rows are connected or refused: the tokens the machine keeps. An
	 * expired or disconnected login drops out, and the broker deletes its token.
	 */
	logins: WantLogin[];
	/**
	 * AdoptRefused answers the adoptions teamBase will not take (AdoptReasons); the broker deletes
	 * their files.
	 */
	adoptRefused?: AdoptRefusal[];
}
/**
 * AuthGrant lets the turn TurnID (the turn's uuid) of the chat Chat (its key) bind to the login Login
 * (its id) until Until. teamBase grants from the delivery's commit until the turn ends; Until is the
 * delivery plus the turn's wall clock plus a margin, so a grant that outlives a lost want still ends.
 * The broker knows a caller's chat from the line the session host writes first on the chat's own
 * socket, never from anything the container sends, so a grant cannot be spent by another chat.
 * Login is the login of the member whose request the turn is (or of the turn before, for one Claude
 * began by itself), written with the turn's delivery; a turn's grant names one login for its whole
 * life. A grant without one is refused at the bind (login_unknown): no turn ever runs on a login
 * nobody chose.
 */
export interface AuthGrant {
	chat: string;
	turnId: string;
	until: number /* int64 */;
	login: string;
}
/**
 * WantLogin is one login teamBase keeps: its id, the account it belongs to and when its token
 * expires. The broker names the account in its picture and status, and counts the machine's tokens
 * over these.
 */
export interface WantLogin {
	id: string;
	account: number /* int64 */;
	expiresAt: number /* int64 */;
}
/**
 * AdoptRefusal is teamBase's no to an adoption (S17 §6): the id the adopt verb minted and why.
 */
export interface AdoptRefusal {
	id: string;
	reason: string;
}
/**
 * The reasons an adoption ends without a login. The broker's own: Claude refused the token at the
 * probe, the request's files do not hold, the machine holds MaxLoginsPerMachine tokens, nobody took
 * the request within a day. teamBase's (AdoptRefusal): no account has the e-mail, the account is not
 * active or not admitted to AI chats, the member holds MaxLoginsPerMember logins, or one of theirs
 * already has the label.
 */
export const AdoptTokenRefused = "token_refused";
/**
 * The reasons an adoption ends without a login. The broker's own: Claude refused the token at the
 * probe, the request's files do not hold, the machine holds MaxLoginsPerMachine tokens, nobody took
 * the request within a day. teamBase's (AdoptRefusal): no account has the e-mail, the account is not
 * active or not admitted to AI chats, the member holds MaxLoginsPerMember logins, or one of theirs
 * already has the label.
 */
export const AdoptBad = "bad";
/**
 * The reasons an adoption ends without a login. The broker's own: Claude refused the token at the
 * probe, the request's files do not hold, the machine holds MaxLoginsPerMachine tokens, nobody took
 * the request within a day. teamBase's (AdoptRefusal): no account has the e-mail, the account is not
 * active or not admitted to AI chats, the member holds MaxLoginsPerMember logins, or one of theirs
 * already has the label.
 */
export const AdoptMachineFull = "machine_full";
/**
 * The reasons an adoption ends without a login. The broker's own: Claude refused the token at the
 * probe, the request's files do not hold, the machine holds MaxLoginsPerMachine tokens, nobody took
 * the request within a day. teamBase's (AdoptRefusal): no account has the e-mail, the account is not
 * active or not admitted to AI chats, the member holds MaxLoginsPerMember logins, or one of theirs
 * already has the label.
 */
export const AdoptStale = "stale";
/**
 * The reasons an adoption ends without a login. The broker's own: Claude refused the token at the
 * probe, the request's files do not hold, the machine holds MaxLoginsPerMachine tokens, nobody took
 * the request within a day. teamBase's (AdoptRefusal): no account has the e-mail, the account is not
 * active or not admitted to AI chats, the member holds MaxLoginsPerMember logins, or one of theirs
 * already has the label.
 */
export const AdoptAccountUnknown = "account_unknown";
/**
 * The reasons an adoption ends without a login. The broker's own: Claude refused the token at the
 * probe, the request's files do not hold, the machine holds MaxLoginsPerMachine tokens, nobody took
 * the request within a day. teamBase's (AdoptRefusal): no account has the e-mail, the account is not
 * active or not admitted to AI chats, the member holds MaxLoginsPerMember logins, or one of theirs
 * already has the label.
 */
export const AdoptNotAdmitted = "not_admitted";
/**
 * The reasons an adoption ends without a login. The broker's own: Claude refused the token at the
 * probe, the request's files do not hold, the machine holds MaxLoginsPerMachine tokens, nobody took
 * the request within a day. teamBase's (AdoptRefusal): no account has the e-mail, the account is not
 * active or not admitted to AI chats, the member holds MaxLoginsPerMember logins, or one of theirs
 * already has the label.
 */
export const AdoptTooMany = "too_many";
/**
 * The reasons an adoption ends without a login. The broker's own: Claude refused the token at the
 * probe, the request's files do not hold, the machine holds MaxLoginsPerMachine tokens, nobody took
 * the request within a day. teamBase's (AdoptRefusal): no account has the e-mail, the account is not
 * active or not admitted to AI chats, the member holds MaxLoginsPerMember logins, or one of theirs
 * already has the label.
 */
export const AdoptLabelTaken = "label_taken";
/**
 * AuthCutoff stops every login's use for every chat (scope all) or for one chat (scope chat, ID its
 * key). It is an admin's audited act on teamBase; the broker refuses every request and every bind in
 * its scope while it is in the want.
 */
export interface AuthCutoff {
	scope: string;
	id?: string;
}
/**
 * The scopes of a cut-off.
 */
export const CutoffAll = "all";
/**
 * The scopes of a cut-off.
 */
export const CutoffChat = "chat";
/**
 * MaxGrantTurnID bounds a grant's turn id: a uuid, with room.
 */
export const MaxGrantTurnID = 64;
/**
 * AuthConnect is aichat.auth.connect without its token: Nonce is teamBase's own word for this one
 * attempt, which the picture's answer repeats; Login the login's id (minted for a new one, the same
 * for a new token of an old one); Account the member's; ExpiresAt the day the member entered, as its
 * end. The token travels beside these fields in the frame and nowhere else.
 */
export interface AuthConnect {
	nonce: string;
	login: string;
	account: number /* int64 */;
	expiresAt: number /* int64 */;
}
/**
 * ConnectNoncePattern is a connect's nonce: 32 lower-case hex characters (NewConnectNonce).
 */
export const ConnectNoncePattern = `^[0-9a-f]{32}\$`;
/**
 * Revealer is what holds a token in memory: teamBase's core.Secret, which this leaf cannot name. Its
 * Reveal is the one way to the bytes.
 */
export type Revealer = any;
/**
 * LoginPicture is aichat.login: every login the broker holds or the want names, with how it is doing;
 * the answers to the connects and the adoptions of the last minutes; the counts of what it refused;
 * the doctor's facts. It is sent on every change and every minute, and never names or carries a
 * token. teamBase keeps the newest in memory and reads it for the queue's hold, the status bar's plan
 * usage, the connect's answer and the doctor; the broker also writes it, without Health, to its state
 * file for the operator's verbs.
 */
export interface LoginPicture {
	/**
	 * Logins are the logins in id order: those the want lists, and those the broker stored that no
	 * want listed yet (a connect a moment ago). At most MaxLoginsPerMachine plus the connects and
	 * adoptions within their grace.
	 */
	logins: LoginState[];
	/**
	 * Connects answer the connects of the last ConnectAnswerFor, newest last, at most MaxConnectAnswers.
	 */
	connects?: ConnectAnswer[];
	/**
	 * Adopts are the adoptions the broker read from its adopt folder, at most MaxAdopts: those it
	 * probes, those that wait for teamBase's word, and those that ended without a login in the last
	 * ConnectAnswerFor.
	 */
	adopts?: AdoptAnswer[];
	/**
	 * Refused counts, by reason, the requests and binds the broker refused in the last 24 hours
	 * (LoginRefusals).
	 */
	refused?: { [key: string]: number /* int */};
	/**
	 * Health is the doctor's facts about the broker, in the shape AuthHealth prints.
	 */
	health?: AuthHealth;
}
/**
 * LoginState is one login as the broker knows it: its id, the account the want names it for (0 before
 * a want named it), its state (LoginStates) and since when, when the upstream last answered on it,
 * when its token expires, the limit it is under while limited, its plan windows once an answer showed
 * them, and whether the account allows extra usage — billing past the plan at API rates — which the
 * broker never lets a turn spend (S07 §5.3): a login that reaches it stops as limited.
 */
export interface LoginState {
	id: string;
	account?: number /* int64 */;
	state: string;
	since: number /* int64 */;
	checkedAt?: number /* int64 */;
	expiresAt?: number /* int64 */;
	limited?: LoginLimit;
	windows?: PlanMeter;
	overage?: boolean;
}
/**
 * The login's states (S17 §4.4, S07 §6.4). A turn binds only while its login is connected, or limited
 * in a scope its model is outside of.
 */
export const LoginConnected = "connected"; // the probe or the last upstream answer succeeded
/**
 * The login's states (S17 §4.4, S07 §6.4). A turn binds only while its login is connected, or limited
 * in a scope its model is outside of.
 */
export const LoginLimited = "limited"; // a plan window is used up, or the login reached extra usage
/**
 * The login's states (S17 §4.4, S07 §6.4). A turn binds only while its login is connected, or limited
 * in a scope its model is outside of.
 */
export const LoginRefused = "refused"; // the upstream refused the token twice in a row
/**
 * The login's states (S17 §4.4, S07 §6.4). A turn binds only while its login is connected, or limited
 * in a scope its model is outside of.
 */
export const LoginMissing = "missing"; // the want names the login and the broker holds no token for it
/**
 * ConnectAnswer is the broker's answer to one connect: the nonce teamBase sent, the login, the result
 * (ConnectResults) and when.
 */
export interface ConnectAnswer {
	nonce: string;
	login: string;
	result: string;
	at: number /* int64 */;
}
/**
 * The results of a connect: Claude took the token and the broker keeps it; Claude refused it; the
 * connect did not hold (its fields, the token's shape, or a machine at MaxLoginsPerMachine). An
 * upstream the broker could not reach gets no answer: teamBase says the machine did not confirm.
 */
export const ConnectConnected = "connected";
/**
 * The results of a connect: Claude took the token and the broker keeps it; Claude refused it; the
 * connect did not hold (its fields, the token's shape, or a machine at MaxLoginsPerMachine). An
 * upstream the broker could not reach gets no answer: teamBase says the machine did not confirm.
 */
export const ConnectRefused = "refused";
/**
 * The results of a connect: Claude took the token and the broker keeps it; Claude refused it; the
 * connect did not hold (its fields, the token's shape, or a machine at MaxLoginsPerMachine). An
 * upstream the broker could not reach gets no answer: teamBase says the machine did not confirm.
 */
export const ConnectBad = "bad";
/**
 * AdoptAnswer is one adoption as the broker read it from its adopt folder: the id the verb minted, the
 * member's e-mail and label the operator gave, the token's expiry, the state (AdoptStates) and, for
 * one that ended without a login, why (AdoptReasons).
 */
export interface AdoptAnswer {
	id: string;
	email: string;
	label: string;
	expiresAt: number /* int64 */;
	state: string;
	reason?: string;
}
/**
 * The states of an adoption: the broker probes the token; Claude took it and it waits for teamBase,
 * which lists the id among its logins (the broker then stores it) or refuses it; it ended without a
 * login.
 */
export const AdoptProbing = "probing";
/**
 * The states of an adoption: the broker probes the token; Claude took it and it waits for teamBase,
 * which lists the id among its logins (the broker then stores it) or refuses it; it ended without a
 * login.
 */
export const AdoptReady = "ready";
/**
 * The states of an adoption: the broker probes the token; Claude took it and it waits for teamBase,
 * which lists the id among its logins (the broker then stores it) or refuses it; it ended without a
 * login.
 */
export const AdoptRefused = "refused";
/**
 * The bounds of the picture's answers: at most MaxConnectAnswers connects, each kept for
 * ConnectAnswerFor (ms) — teamBase waits for its answer far less —, and at most MaxAdopts adoptions.
 */
export const MaxConnectAnswers = 16;
/**
 * The bounds of the picture's answers: at most MaxConnectAnswers connects, each kept for
 * ConnectAnswerFor (ms) — teamBase waits for its answer far less —, and at most MaxAdopts adoptions.
 */
export const ConnectAnswerFor = 10 * 60 * 1000;
/**
 * The bounds of the picture's answers: at most MaxConnectAnswers connects, each kept for
 * ConnectAnswerFor (ms) — teamBase waits for its answer far less —, and at most MaxAdopts adoptions.
 */
export const MaxAdopts = 16;
/**
 * LoginLimit is a limit of one login: which window (LimitWindows), until when, and whom it holds —
 * every model (LimitScopeAll), or one model family (opus, sonnet) when the upstream limited only that
 * family's weekly use.
 */
export interface LoginLimit {
	window: string;
	until: number /* int64 */;
	scope?: string;
}
/**
 * The windows a limit is in.
 */
export const LimitFiveHour = "five_hour";
/**
 * The windows a limit is in.
 */
export const LimitSevenDay = "seven_day";
/**
 * The windows a limit is in.
 */
export const LimitExtraUsage = "extra_usage";
/**
 * LimitScopeAll is the scope of a limit that holds every model.
 */
export const LimitScopeAll = "all";
/**
 * AuthHealth is what the doctor reads of the broker (S15 §7), bounded like every picture: the
 * upstream's recent answers, how many turns are bound against the machine's cap, and the counts of
 * what should never happen.
 */
export interface AuthHealth {
	build?: string;
	upstream: UpstreamHealth;
	/**
	 * BoundTurns are the turns bound on every login; MaxBoundTurns is max_bound_turns for each login
	 * the machine holds.
	 */
	boundTurns: number /* int */;
	maxBoundTurns: number /* int */;
	/**
	 * MaxBoundPerLogin is max_bound_turns, which holds per login, and BoundByLogin the turns bound on
	 * each login that has any, by id.
	 */
	maxBoundPerLogin?: number /* int */;
	boundByLogin?: { [key: string]: number /* int */};
	/**
	 * ExtraUsageStops24h counts the times extra usage stopped a login; UnreadableLimits1h the plan
	 * answers that carried no limit headers, which put their turns on the hard cut.
	 */
	extraUsageStops24h?: number /* int */;
	unreadableLimits1h?: number /* int */;
	/**
	 * The counts of refusals the doctor names on their own.
	 */
	urlUnexpected24h?: number /* int */;
	agentAfterUnbind24h?: number /* int */;
	peerRefused24h?: number /* int */;
	grantMismatch24h?: number /* int */;
	/**
	 * CutoffAll and CutoffChats (the keys) are the cut-offs in force.
	 */
	cutoffAll?: boolean;
	cutoffChats?: string[];
}
/**
 * UpstreamHealth is how the model API has been answering: the last success, the last status, and the
 * server errors and transport failures of the last hour.
 */
export interface UpstreamHealth {
	lastOkAt?: number /* int64 */;
	lastStatus?: number /* int */;
	s5xx1h?: number /* int */;
	requests1h?: number /* int */;
	transportErr1h?: number /* int */;
}
/**
 * TurnUsage is what one turn spent on its login, as the broker metered it on the wire: the billing
 * truth, independent of what the CLI says about itself. Units weigh the four token counters by price
 * (input + cache writes + output + a tenth of cache reads), which is what the per-turn ceilings count.
 * The broker sends it every half minute while a turn's requests flow (usage) and once when the
 * binding ends (usage_final); the host relays the final one in aichat.turn.
 */
export interface TurnUsage {
	units: number /* int64 */;
	input: number /* int64 */;
	output: number /* int64 */;
	cacheRead: number /* int64 */;
	cacheWrite: number /* int64 */;
	/**
	 * Requests counts the turn's model requests; Retries those the CLI marked as a retry; S401, S429
	 * and S5xx the answers of each kind.
	 */
	requests: number /* int */;
	retries?: number /* int */;
	s401?: number /* int */;
	s429?: number /* int */;
	s5xx?: number /* int */;
	/**
	 * Seconds is how long the binding has lasted.
	 */
	seconds: number /* int64 */;
	/**
	 * Unreadable says a plan answer came without its limit headers, so the turn ran under the hard
	 * cut (S07 §5.3).
	 */
	unreadable?: boolean;
	/**
	 * Agents counts the subagents that made requests; ByAgent is the busiest of them, at most
	 * MaxUsageAgents.
	 */
	agents?: number /* int */;
	byAgent?: AgentUsage[];
}
/**
 * AgentUsage is one subagent's share of a turn, by the CLI's agent id.
 */
export interface AgentUsage {
	agentId: string;
	units: number /* int64 */;
	requests: number /* int */;
	lastStatus?: number /* int */;
}
/**
 * MaxUsageAgents bounds TurnUsage.ByAgent, so a turn's usage stays within the turn row's bound.
 */
export const MaxUsageAgents = 16;

//////////
// source: blobs.go

/**
 * BlobCodec is the encoding of every class but the exact ones: gzip.
 */
export const BlobCodec = "gzip";
/**
 * BlobClass is one class of blob.
 */
export interface BlobClass {
	name: string;
	up: boolean;
	down: boolean;
	/**
	 * Masked classes are decoded, masked with core/secretscan (JSON line by line where the class
	 * is NDJSON), encoded and hashed again as they arrive; the stored sha differs from the
	 * uploaded one, and no unmasked byte of them touches teamBase's disk. Exact classes are stored
	 * as uploaded and must hash to their name.
	 */
	masked: boolean;
	/**
	 * Lines says the decoded bytes are NDJSON, validated and masked line by line.
	 */
	lines: boolean;
	/**
	 * Gzip says the bytes are BlobCodec-encoded.
	 */
	gzip: boolean;
	/**
	 * MaxBytes bounds the uploaded bytes and, for a gzip class, the decoded bytes as well.
	 */
	maxBytes: number /* int64 */;
}
/**
 * The classes' caps.
 */
export const BundleMax = 512 << 20;
/**
 * The classes' caps.
 */
export const OverflowMax = 16 << 20;
/**
 * The classes' caps.
 */
export const OutputMax = 16 << 20;
/**
 * The classes' caps.
 */
export const StepsMax = 128 << 20; // per agent
/**
 * The classes' caps.
 */
export const StepsChatMax = 2 << 30; // per chat
/**
 * The classes' caps.
 */
export const ItemBlobMax = 64 << 10;
/**
 * DigestMax bounds the agent's instructions, decoded: the most the host writes for the CLI. The
 * builder keeps every digest within it (agentprompt), however far the parts' CLAUDE.md files grow.
 */
export const DigestMax = 128 << 10;
/**
 * The classes' caps.
 */
export const UploadMax = 100_000_000; // core's attachment limit: 100 MB per file
/**
 * SessionPackMax bounds a pack of Claude's session, decoded and uploaded.
 */
export const SessionPackMax = 2 << 30;
/**
 * KeepPackMax bounds a pack of the keep folder: its 1 GiB of content (KeepLimitBytes, spelt out
 * because the browser's generated constants are declared in file order) and the tar's framing.
 */
export const KeepPackMax = (1 << 30) + (64 << 20);
/**
 * The class names.
 */
export const BlobBundle = "bundle";
/**
 * The class names.
 */
export const BlobOverflow = "overflow";
/**
 * The class names.
 */
export const BlobOutput = "output";
/**
 * The class names.
 */
export const BlobSteps = "steps";
/**
 * The class names.
 */
export const BlobItem = "item";
/**
 * The class names.
 */
export const BlobSession = "session";
/**
 * The class names.
 */
export const BlobKeep = "keep";
/**
 * The class names.
 */
export const BlobDigest = "digest";
/**
 * The class names.
 */
export const BlobUpload = "upload";
/**
 * The class names.
 */
export const BlobUp = "up";

//////////
// source: calls.go

/**
 * SetArgsMax bounds a call's arguments: one JSON object, as Claude sent it.
 */
export const SetArgsMax = 262_144;
/**
 * SetRequestMax bounds a set call's request line on the tools socket: the arguments and the
 * request's own fields. A request that is no set call keeps the tools' 16 KiB.
 */
export const SetRequestMax = 264 << 10;
/**
 * SetFilesMax bounds the files one call uploads, and the files one reply hands back.
 */
export const SetFilesMax = 10;
/**
 * SetCallsPerTurn bounds the set calls of one turn, the catalogue ops not counted: past it the
 * host answers SetTurnCalls. It stands beside ToolCallsPerTurn, which counts the paired calls.
 */
export const SetCallsPerTurn = 500;
/**
 * SetReplyMax bounds a reply's text. The sets keep an answer far below it (S-14-D7: 28 000
 * characters, 9 000 for a refusal); it is half the reply frame's bound because the frame's JSON
 * escapes every quote of the JSON answer it carries.
 */
export const SetReplyMax = 256 << 10;
/**
 * The words of a call's set and tool fields that are no set's: `tb-chat sets` names every set and
 * so no set (SetAll), and a set's `help` and `guide` are core's catalogue, which every set has.
 */
export const SetAll = "*";
/**
 * The words of a call's set and tool fields that are no set's: `tb-chat sets` names every set and
 * so no set (SetAll), and a set's `help` and `guide` are core's catalogue, which every set has.
 */
export const OpSets = "sets";
/**
 * The words of a call's set and tool fields that are no set's: `tb-chat sets` names every set and
 * so no set (SetAll), and a set's `help` and `guide` are core's catalogue, which every set has.
 */
export const OpHelp = "help";
/**
 * The words of a call's set and tool fields that are no set's: `tb-chat sets` names every set and
 * so no set (SetAll), and a set's `help` and `guide` are core's catalogue, which every set has.
 */
export const OpGuide = "guide";
/**
 * FrontCLI is the one front end of the tool sets in this release: the command `tb-chat`. The field
 * is there so that a later MCP face can say it is one.
 */
export const FrontCLI = "cli";
/**
 * CallFrame is the data of an aichat.call frame: one call, named by the host's id.
 */
export interface CallFrame {
	/**
	 * ID is the host's: 32 lowercase hex, unique in the session. A call the host sends again after a
	 * resume keeps its id, and a write sent again under the same id is answered from its record.
	 */
	id: string;
	/**
	 * Turn is the open turn's uuid as the host knows it — the delivery's, or Claude Code's prompt id
	 * for a turn typed in the terminal. Empty for a catalogue op, which needs no turn.
	 */
	turn?: string;
	/**
	 * Set and Tool name the call: a set's name and a tool's, or SetAll with OpSets, or a set with
	 * OpHelp or OpGuide.
	 */
	set: string;
	tool: string;
	/**
	 * Args is one JSON object of at most SetArgsMax bytes, as Claude sent it; absent is {}.
	 */
	args?: unknown;
	/**
	 * Front is the front end the call came through (CallFronts).
	 */
	front: string;
	/**
	 * Files are the uploads the arguments name, in the order the arguments name them, each already
	 * offered as a blob of class up under its sha256.
	 */
	files?: CallFile[];
	/**
	 * Resent says the host sent the call again after a resume, because no reply came before it.
	 */
	resent?: boolean;
}
/**
 * ReplyFrame is the data of an aichat.reply frame: the answer to the call of the same id, exactly as
 * the command prints it, and the files it hands back, each a blob teamBase granted the session.
 */
export interface ReplyFrame {
	id: string;
	/**
	 * Text is the answer: one JSON line for a call, plain text for a catalogue op.
	 */
	text: string;
	/**
	 * Exit is the command's exit status (ReplyExits): done, refused or unavailable.
	 */
	exit: number /* int */;
	files?: CallFile[];
}
/**
 * CallFile is one file a call uploads or a reply hands back. N is the file's number, which the
 * arguments' `<tb-file:N>` placeholder and the upload's place name; Name is its base name, for
 * display and for the download's own name.
 */
export interface CallFile {
	n: number /* int */;
	name: string;
	bytes: number /* int64 */;
	sha256: string;
}
/**
 * The exit statuses a reply carries (A3-D3). The command's own refusals of a malformed command exit
 * 2, and never reach teamBase.
 */
export const ReplyDone = 0;
/**
 * The exit statuses a reply carries (A3-D3). The command's own refusals of a malformed command exit
 * 2, and never reach teamBase.
 */
export const ReplyRefused = 1;
/**
 * The exit statuses a reply carries (A3-D3). The command's own refusals of a malformed command exit
 * 2, and never reach teamBase.
 */
export const ReplyUnavailable = 4;
/**
 * SetRefusal is an answer the session host gives a set call by itself, because teamBase cannot be
 * asked or has not answered: each is a refusal of S-14's envelope with its reason, its problem and the
 * exit status the command prints.
 */
export type SetRefusal = string;
/**
 * SetBusy: the chat's session is not attached, or an upload was not stored in time. Nothing was
 * sent; the call may be sent again after the wait it names.
 */
export const SetBusy: SetRefusal = "busy";
/**
 * SetNoTurn: a set's tool was called while no turn of the chat is open. Nothing was sent.
 */
export const SetNoTurn: SetRefusal = "no_turn";
/**
 * SetUnknown: no reply came within the host's wait, so whether the call took effect is unknown.
 */
export const SetUnknown: SetRefusal = "unknown";
/**
 * SetTurnCalls: the turn made SetCallsPerTurn set calls already. Nothing was sent.
 */
export const SetTurnCalls: SetRefusal = "turn_calls";
/**
 * SetBusyRetryMs is how long a busy answer asks Claude to wait before it sends the call again.
 */
export const SetBusyRetryMs = 5000;
/**
 * SetRefusalText is the sentence a host refusal carries and what to do about it: model-facing
 * English, fixed like every text the host says (hosttexts.go).
 */
export interface SetRefusalText {
	reason: string;
	exit: number /* int */;
	detail: string;
	hint: string;
}

//////////
// source: checks.go

/**
 * CheckStatus is how one step of a run ended.
 */
export type CheckStatus = string;
export const CheckPass: CheckStatus = "pass";
export const CheckFail: CheckStatus = "fail";
/**
 * CheckError is a step the runner could not run: killed for memory, a tool missing, the export
 * or the permit lost. It says nothing about the code, and a run with one is tried once more.
 */
export const CheckError: CheckStatus = "error";
export const CheckTimeout: CheckStatus = "timeout";
/**
 * CheckSkipped is a step with nothing to do for this change.
 */
export const CheckSkipped: CheckStatus = "skipped";
/**
 * CheckClass is where a run waits in the build permit's queue, after the platforms' own builds: a
 * run of a chat somebody is looking at (seen) before the rest (other).
 */
export type CheckClass = string;
export const CheckSeen: CheckClass = "seen";
export const CheckOther: CheckClass = "other";
/**
 * CheckCommand is `aichat.check`: run a part's suite at Heads, repository id → commit, for the paths
 * the revision Touched. RunID names teamBase's run, which the result echoes. Cancel asks the host to
 * stop the run instead; the other fields are then empty.
 */
export interface CheckCommand {
	runId: number /* int64 */;
	part?: string;
	suite?: string;
	heads?: { [key: string]: string};
	touched?: string[];
	class?: CheckClass;
	cancel?: boolean;
}
/**
 * CheckResult is `aichat.check.result`, up and reliable: the run, the heads and touched paths it ran
 * for (echoed from the command), and either Running (the permit is held and the steps have started)
 * or the Results, one per step of the suite in the suite's order.
 */
export interface CheckResult {
	runId: number /* int64 */;
	heads: { [key: string]: string};
	touched?: string[];
	running?: boolean;
	results?: CheckStepResult[];
}
/**
 * CheckStepResult is one step of a run: its status, its time, the diagnostics it printed as
 * "path:message" (the path relative to the chat's src directory, line and column stripped, so the
 * same warning reads the same at the base and at the head) and, for tests, each package's outcome
 * (ok | fail | none).
 */
export interface CheckStepResult {
	id: string;
	status: CheckStatus;
	ms: number /* int64 */;
	diag?: string[];
	packages?: { [key: string]: string};
	/**
	 * DiagCut says Diag was cut to fit — by the host to fit the frame, or by teamBase to fit the
	 * stored result: a comparison over it could call a moved warning new, so none is made.
	 */
	diagCut?: boolean;
}
/**
 * The bounds of a result: the diagnostics one step keeps, each one's bytes, and the packages one
 * test step reports. The host cuts to them before it sends; teamBase refuses a result over them.
 */
export const MaxCheckDiag = 500;
/**
 * The bounds of a result: the diagnostics one step keeps, each one's bytes, and the packages one
 * test step reports. The host cuts to them before it sends; teamBase refuses a result over them.
 */
export const MaxCheckDiagLine = 400;
/**
 * The bounds of a result: the diagnostics one step keeps, each one's bytes, and the packages one
 * test step reports. The host cuts to them before it sends; teamBase refuses a result over them.
 */
export const MaxCheckPackages = 2000;
/**
 * The bounds of a run's touched paths: how many a run names — past it the revision's other paths are
 * not tested, and its diagnostics are compared everywhere — and the bytes of one.
 */
export const MaxCheckTouched = 64;
/**
 * The bounds of a run's touched paths: how many a run names — past it the revision's other paths are
 * not tested, and its diagnostics are compared everywhere — and the bytes of one.
 */
export const MaxCheckTouchedPath = 1024;
/**
 * MaxCheckResult bounds the JSON of one result frame's data, well inside the frame's catalogue
 * bound: the host halves the longest diagnostics list until a result fits.
 */
export const MaxCheckResult = 192 << 10;

//////////
// source: cli.go

/**
 * CLIRelease is one Claude Code release binary as its signed manifest names it: the version, and
 * the size and sha256 of its linux-x64 binary. Its JSON is the worker's release-facts' claudeCode,
 * which `make release` writes into the MANIFEST.
 */
export interface CLIRelease {
	version: string;
	size: number /* int64 */;
	sha256: string;
}

//////////
// source: commands.go

/**
 * Mechanism is how a command reaches its effect.
 */
export type Mechanism = string;
/**
 * MechControl is a control request to the CLI (or the host's interrupt).
 */
export const MechControl: Mechanism = "control";
/**
 * MechText is delivered to the CLI as a command turn, queued like a prompt.
 */
export const MechText: Mechanism = "text";
/**
 * MechNative is done by teamBase (and the browser) alone; the CLI never sees it.
 */
export const MechNative: Mechanism = "native";
/**
 * Placement is where the browser offers a command.
 */
export type Placement = string;
export const PlaceButton: Placement = "button";
export const PlacePicker: Placement = "picker";
export const PlaceToggle: Placement = "toggle";
export const PlacePalette: Placement = "palette";
export const PlacePopover: Placement = "popover";
export const PlaceBand: Placement = "band";
export const PlaceReview: Placement = "review";
/**
 * PlaceSettings is the chat's Settings → Environment.
 */
export const PlaceSettings: Placement = "settings";
export const PlaceHidden: Placement = "hidden";
/**
 * Group is the palette group of a command: the chat's own commands, Claude's (the review skills),
 * or the repositories' own commands the CLI reports.
 */
export type Group = string;
export const GroupAichat: Group = "aichat";
export const GroupClaude: Group = "claude";
export const GroupRepos: Group = "repos";
/**
 * ArgKind is what a command takes after its name.
 */
export type ArgKind = string;
export const ArgsNone: ArgKind = "none";
export const ArgsFree: ArgKind = "free";
export const ArgsModel: ArgKind = "model";
export const ArgsEffort: ArgKind = "effort";
/**
 * Command is one row of the catalogue.
 */
export interface Command {
	/**
	 * Name is the command without its slash.
	 */
	name: string;
	aliases?: string[];
	/**
	 * Down is what goes to the worker machine: a control op, `deliver.command` for a command turn,
	 * `deliver.plan_first` for the plan toggle, `interrupt` for stop; "" when teamBase acts alone.
	 */
	down?: string;
	/**
	 * Action is the policy action a person needs to run the row; "" for a blocked row.
	 */
	action?: string;
	mechanism: Mechanism;
	places: Placement[];
	group: Group;
	args: ArgKind;
	/**
	 * Modes are the chat modes that offer the row. The palette hides the others; teamBase and the
	 * host refuse them (wrong_mode).
	 */
	modes: ModeSet;
}
/**
 * The policy actions commands name (their cells are the policy's).
 */
export const ActionCommandRun = "aichat.command.run";
/**
 * The policy actions commands name (their cells are the policy's).
 */
export const ActionMessagePost = "aichat.message.post";
/**
 * The policy actions commands name (their cells are the policy's).
 */
export const ActionChatRead = "aichat.chat.read";
/**
 * The policy actions commands name (their cells are the policy's).
 */
export const ActionRunRevoke = "aichat.run.revoke";
/**
 * ResolutionKind is what a typed line turned out to be.
 */
export type ResolutionKind = string;
/**
 * ResolveNone: not a command, a message.
 */
export const ResolveNone: ResolutionKind = "none";
/**
 * ResolveKnown: a row of the catalogue, offered in this chat's mode.
 */
export const ResolveKnown: ResolutionKind = "known";
/**
 * ResolveWrongMode: a row the chat's mode does not offer (a read chat's /plan).
 */
export const ResolveWrongMode: ResolutionKind = "wrong_mode";
/**
 * ResolveDynamic: a command of the repositories the CLI reported; sent as text.
 */
export const ResolveDynamic: ResolutionKind = "dynamic";
/**
 * ResolveCLIBlocked: a command the CLI knows and an AI chat does not run.
 */
export const ResolveCLIBlocked: ResolutionKind = "cli_blocked";
/**
 * ResolveUnknown: a slash word nobody knows; "Send as a message" delivers it escaped.
 */
export const ResolveUnknown: ResolutionKind = "unknown";
/**
 * CLINames are the commands the running CLI reported: Dynamic are the repositories' own (no
 * builtin flag), Listed every other name it knows.
 */
export interface CLINames {
	Dynamic: string[];
	Listed: string[];
}
/**
 * Resolution is what Resolve found.
 */
export interface Resolution {
	Kind: ResolutionKind;
	/**
	 * Command is the catalogue row for known and wrong_mode.
	 */
	Command?: Command;
	/**
	 * Name is the typed name without its slash, Args the rest of the line.
	 */
	Name: string;
	Args: string;
}

//////////
// source: data.go

/**
 * ProseData is a main-thread text block of Claude's; the text is the envelope's body.
 */
export interface ProseData {
	model?: string;
	msgId?: string;
	/**
	 * Thought counts the empty thinking blocks before this text, which are never rows of their own.
	 */
	thought?: ThoughtCount;
}
/**
 * ThoughtCount counts thinking blocks and their tokens.
 */
export interface ThoughtCount {
	blocks: number /* int */;
	tokens: number /* int64 */;
}
/**
 * ThinkingData is a thinking block with text; one with only a signature is counted, not stored.
 */
export interface ThinkingData {
	text: string;
	tokens?: number /* int64 */;
}
/**
 * ToolData is one tool call, from its tool_use block to its result.
 */
export interface ToolData {
	name: string;
	verb: Verb;
	label?: string;
	detail?: string;
	/**
	 * Input is the tool's input as the CLI sent it, with a Write's content replaced by its size
	 * (ContentBytes): the change itself is in Patch, and the file is in the capture.
	 */
	input?: unknown;
	contentBytes?: number /* int64 */;
	startedAt?: number /* int64 */;
	endedAt?: number /* int64 */;
	exitCode?: number /* int */;
	returnCode?: string;
	counts?: ToolCounts;
	patch?: PatchHunk[];
	/**
	 * PatchTruncated says Patch stopped at its bound; the whole change is in the capture.
	 */
	patchTruncated?: boolean;
	output?: OutputExcerpt;
	taskId?: string;
	backgrounded?: boolean;
	denial?: ToolDenial;
	/**
	 * ReadOnly marks a write the host's guard refused because the chat is read only (guard
	 * read_only in a read process). It stays in state denied and is drawn as a neutral step, never
	 * as a failure.
	 */
	readOnly?: boolean;
	/**
	 * Title is the value of a set_title call, as the host validated it (verb title only).
	 */
	title?: string;
	/**
	 * TitleKept marks a set_title teamBase did not take: the chat's title was no longer the first
	 * message's (Claude names a chat once, and a person's title stays), or nothing was left of the
	 * value once masked. teamBase sets it on the call's closing put; the host never does.
	 */
	titleKept?: boolean;
	/**
	 * Call is set on a Bash command that is exactly one call of teamBase's tool sets (verb teambase):
	 * what the command named, and the id teamBase's answer carried. A pipe, a loop or two calls stay a
	 * plain run, never a wrong label.
	 */
	call?: SetCall;
}
/**
 * SetCall is what the reducer reads of a Bash command that is one call of `tb-chat <set> <tool>`:
 * the set, the tool and the arguments as the command's word or here-document held them, cut to
 * MaxSetCallArgs and masked like a tool's input, and — once the result came — the call's id from the
 * answer, which names the `call` item teamBase wrote for it. The page folds the command into that item
 * as its opened detail; a command whose id names no item (a shadowed tb-chat, an answer made up)
 * stays a command row.
 */
export interface SetCall {
	set: string;
	tool: string;
	args?: unknown;
	id?: string;
}
/**
 * ToolCounts are what a tool's result counted.
 */
export interface ToolCounts {
	lines?: number /* int */;
	files?: number /* int */;
	matches?: number /* int */;
	added?: number /* int */;
	removed?: number /* int */;
	results?: number /* int */;
}
/**
 * PatchHunk is one hunk of an Edit or a Write, as the CLI's structuredPatch gives it.
 */
export interface PatchHunk {
	oldStart: number /* int */;
	oldLines: number /* int */;
	newStart: number /* int */;
	newLines: number /* int */;
	lines: string[];
}
/**
 * OutputExcerpt is a tool's output: whole up to MaxExcerpt, else its first and last ExcerptHalf
 * bytes, with the whole output in a blob of role output.
 */
export interface OutputExcerpt {
	head: string;
	tail?: string;
	bytes: number /* int64 */;
	lines?: number /* int */;
	truncated?: boolean;
	stderr?: boolean;
	isImage?: boolean;
}
/**
 * ToolDenial is the reason a tool ended denied; the denial item beside it says more.
 */
export interface ToolDenial {
	reasonType: DenialReason;
}
/**
 * DenialData is a refused tool call.
 */
export interface DenialData {
	toolSrc: string;
	name: string;
	verb: Verb;
	label?: string;
	reasonType: DenialReason;
	code?: GuardCode;
	reason?: string;
	consecutive?: number /* int */;
	agentId?: string;
}
/**
 * Usage is what an agent or a workflow spent.
 */
export interface Usage {
	tokens?: number /* int64 */;
	toolUses?: number /* int */;
	durationMs?: number /* int64 */;
}
/**
 * StepCounts count an agent's steps; its steps themselves are one blob of role steps.
 */
export interface StepCounts {
	count: number /* int */;
	failed?: number /* int */;
	denied?: number /* int */;
	truncated?: boolean;
}
/**
 * AgentData is a subagent: one row, its calls in its steps blob.
 */
export interface AgentData {
	taskId?: string;
	subagentType?: string;
	description?: string;
	background?: boolean;
	model?: string;
	prompt?: string;
	activity?: string;
	usage?: Usage;
	result?: string;
	steps?: StepCounts;
	error?: string;
}
/**
 * WorkflowData is a workflow run: its phases and the counts of its agents; each agent is a wfagent
 * item under it.
 */
export interface WorkflowData {
	taskId?: string;
	runId?: string;
	name?: string;
	description?: string;
	script?: string;
	resumes?: string;
	phases?: WorkflowPhase[];
	agents: AgentCounts;
	usage?: Usage;
	reported?: string;
	error?: string;
	result?: string;
	/**
	 * Large is set above WorkflowLargeAgents agents or WorkflowLargeTokens tokens.
	 */
	large?: boolean;
	/**
	 * CanContinue is set on a run the CLI stopped with the session, which the same session can
	 * resume.
	 */
	canContinue?: boolean;
}
/**
 * WorkflowPhase is one phase of a workflow.
 */
export interface WorkflowPhase {
	index: number /* int */;
	title: string;
}
/**
 * AgentCounts count a workflow's agents by state.
 */
export interface AgentCounts {
	total: number /* int */;
	queued?: number /* int */;
	running?: number /* int */;
	done?: number /* int */;
	error?: number /* int */;
	cancelled?: number /* int */;
	skipped?: number /* int */;
}
/**
 * WfAgentData is one agent of a workflow, keyed by its index in the run (a queued agent has no id).
 */
export interface WfAgentData {
	index: number /* int */;
	agentId?: string;
	label?: string;
	phaseIndex: number /* int */;
	phaseTitle?: string;
	model?: string;
	attempt?: number /* int */;
	cached?: boolean;
	fallbackModel?: string;
	tokens?: number /* int64 */;
	toolCalls?: number /* int */;
	durationMs?: number /* int64 */;
	startedAt?: number /* int64 */;
	lastToolName?: string;
	lastToolSummary?: string;
	promptPreview?: string;
	resultPreview?: string;
	error?: string;
	/**
	 * StepsFrom names the earlier wfagent whose steps a cached agent reuses.
	 */
	stepsFrom?: string;
}
/**
 * TaskData is a background shell or monitor.
 */
export interface TaskData {
	taskId: string;
	toolSrc?: string;
	monitor?: boolean;
	description?: string;
	command?: string;
	exitCode?: number /* int */;
	summary?: string;
	events?: TaskEvent[];
	outputTail?: string;
}
/**
 * TaskEvent is one notice of a monitor.
 */
export interface TaskEvent {
	at: number /* int64 */;
	text: string;
}
/**
 * TodoData is Claude's task list of a turn.
 */
export interface TodoData {
	tasks: TodoTask[];
}
/**
 * TodoTask is one entry of it; the status is the CLI's word.
 */
export interface TodoTask {
	id: string;
	subject: string;
	status: string;
}
/**
 * CardData is a card: a question, a plan, or Claude's request to change code.
 */
export interface CardData {
	type: CardType;
	requestId?: string;
	agentId?: string;
	questions?: Question[];
	plan?: PlanText;
	/**
	 * Sent is what went back to the CLI for a question or a plan card.
	 */
	sent?: CardSent;
	/**
	 * Reason is a modify card's reason, masked, at most ReasonMax characters.
	 */
	reason?: string;
	/**
	 * Code is a refused modify request's tool code.
	 */
	code?: ToolCode;
	/**
	 * Where is ViaTerminal for a question or a plan Claude asked in the chat's terminal: it is
	 * answered there, never in the chat view (teamBase's own cards never carry it).
	 */
	where?: string;
}
/**
 * Question is one question of a question card.
 */
export interface Question {
	header?: string;
	question: string;
	multiSelect?: boolean;
	options: Option[];
}
/**
 * Option is one option of a question.
 */
export interface Option {
	label: string;
	description?: string;
}
/**
 * PlanText is a plan card's plan.
 */
export interface PlanText {
	text?: string;
	path?: string;
}
/**
 * CardSent is the answer the host sent the CLI.
 */
export interface CardSent {
	answers?: SentAnswer[];
	approved?: boolean;
	feedback?: string;
}
/**
 * SentAnswer is one question and the label (or the Other text) it was answered with.
 */
export interface SentAnswer {
	question: string;
	answer: string;
}
/**
 * CompactData is a compaction of the conversation.
 */
export interface CompactData {
	trigger?: string;
	preTokens?: number /* int64 */;
	postTokens?: number /* int64 */;
	durationMs?: number /* int64 */;
	state: string;
	error?: string;
	summary?: string;
}
/**
 * ResetData is the CLI starting its conversation afresh.
 */
export interface ResetData {
	trigger: string;
	sessionId?: string;
	/**
	 * By is the member who typed /clear in the terminal (the Enter mark it consumed); 0 for the CLI's
	 * own resets.
	 */
	by?: number /* int64 */;
}
/**
 * FollowupData marks a turn the CLI started itself, after a background task.
 */
export interface FollowupData {
	origin?: string;
	taskSrcs?: string[];
}
/**
 * TurnEndData closes a turn: how it ended, what it cost, in which chat mode it ran.
 */
export interface TurnEndData {
	uuids?: string[];
	origin?: string;
	results?: TurnResult[];
	interrupted?: boolean;
	cause?: string;
	chatMode: ChatMode;
	models?: { [key: string]: ModelUsage};
	/**
	 * CostListUsd is the turn's list-price equivalent. It is stored and never drawn: the shared
	 * plan login pays no list price.
	 */
	costListUsd?: number /* float64 */;
	/**
	 * ContextEnd is how full the context was when the turn ended; ContextWindow and ContextThreshold
	 * are the model's window and where the CLI compacts, as the CLI last said them — the meter of a
	 * chat whose Claude Code has stopped draws from these.
	 */
	contextEnd?: number /* int64 */;
	contextWindow?: number /* int64 */;
	contextThreshold?: number /* int64 */;
	thinking?: ThoughtCount;
	counts?: TurnCounts;
	durationMs?: number /* int64 */;
	ttftMs?: number /* int64 */;
	cliVersion?: string;
	localCommand?: string;
	localOutput?: string;
}
/**
 * TurnResult is one `result` frame of a turn.
 */
export interface TurnResult {
	index: number /* int */;
	origin?: string;
	subtype?: string;
	isError?: boolean;
	terminalReason?: string;
	numTurns?: number /* int */;
	durationMs?: number /* int64 */;
	apiMs?: number /* int64 */;
}
/**
 * ModelUsage is one model's tokens in a turn.
 */
export interface ModelUsage {
	in?: number /* int64 */;
	out?: number /* int64 */;
	cacheRead?: number /* int64 */;
	cacheWrite?: number /* int64 */;
}
/**
 * TurnCounts count a turn's calls.
 */
export interface TurnCounts {
	tools?: number /* int */;
	failed?: number /* int */;
	denied?: number /* int */;
	readOnly?: number /* int */;
	agents?: number /* int */;
	workflows?: number /* int */;
}
/**
 * ErrorData is an error or a warning of the CLI's.
 */
export interface ErrorData {
	code: ErrorCode;
	level: string;
	/**
	 * Text is the CLI's own words, shown at Full density only.
	 */
	text?: string;
	status?: number /* int */;
	resetsAt?: number /* int64 */; // epoch seconds
	scope?: string;
	relatedSrc?: string;
}
/**
 * UnknownData stands for frames the reducer does not know, or an item teamBase could not validate
 * (cliType "item", subtype its kind; the item itself is kept in a blob of role item).
 */
export interface UnknownData {
	cliType: string;
	subtype?: string;
	keys?: string[];
	count: number /* int */;
	sample?: string;
}

//////////
// source: data_teambase.go

/**
 * TurnData marks a delivery: the turn begins here, with the prompts it carries (by src, in order).
 * Sent is what Claude was handed beside the people's own words — teamBase's notes and the text of a
 * door a person pressed, as rendered at the delivery — so the transcript's Full density shows what
 * Claude read even after a later release changed the wording, and the command that carries the
 * delivery is built from this row alone.
 */
export interface TurnData {
	uuid: string;
	kind: string;
	template?: string;
	prompts?: string[];
	sent?: TurnSent;
	/**
	 * Outcome is how the turn ended (TurnOutcomes) and StoppedBy who stopped it, written on the turn's
	 * item when the turn ends: the page draws a done or an outcome card from the items alone.
	 */
	outcome?: string;
	stoppedBy?: number /* int64 */;
	/**
	 * OwnLogin says the turn runs on the chat's own Claude login, not on a member's token: a login
	 * Claude refuses under it is no token's owner's to mend, and the page words it so.
	 */
	ownLogin?: boolean;
	/**
	 * Driver is cli for a turn that ran in the chat's terminal — typed there, or begun there by Claude
	 * itself — and empty for the chat view's: the turn's head says "in the terminal". Such a turn's
	 * Sent holds the notes the terminal handed Claude beside the typed line, by id.
	 */
	driver?: Driver;
}
/**
 * TurnSent is teamBase's own text of a delivery: its notes, in delivery order, and the rendered text
 * of a template or command turn.
 */
export interface TurnSent {
	preambles?: SentText[];
	text?: string;
}
/**
 * SentText is one note as it was sent: the note's id and its text.
 */
export interface SentText {
	id: string;
	text: string;
}
/**
 * PromptData is a person's message to Claude; the text is the body.
 */
export interface PromptData {
	planFirst?: boolean;
	/**
	 * Template names the S17 text a door press queued (an Ask, Continue, modify_allowed, …).
	 */
	template?: string;
	/**
	 * Jump marks a head that passes a hold (Stop and send, a door press).
	 */
	jump?: boolean;
	/**
	 * Exits names the pause a door press ends when its turn starts (Continue, a parked card's answer):
	 * such a head passes that pause, and any hold but a close.
	 */
	exits?: string;
	/**
	 * CrossedAck is the newest seq of another person's message the author sent this one without having
	 * seen ("Send anyway"): Claude is told, without names, that the two may conflict.
	 */
	crossedAck?: number /* int64 */;
	/**
	 * Via says the line was typed in the chat's terminal rather than sent from the chat view
	 * (PromptVias): a line for Claude (terminal), or a shell command (`!`) or its output (shell),
	 * which belongs to no turn and is drawn as the typist's "ran in the terminal". Empty for the chat
	 * view's messages.
	 */
	via?: string;
	/**
	 * ByUnknown says nobody can be named for a line typed in the terminal: no typist's Enter stood
	 * behind it (the item is then the system's), or the turn's asker is not its typist (the item keeps
	 * the asker as its author, and the page names nobody).
	 */
	byUnknown?: boolean;
}
/**
 * Where a person's line came from, beside the chat view's composer: typed in the terminal for Claude,
 * or a shell command typed there and its output.
 */
export const ViaTerminal = "terminal";
/**
 * Where a person's line came from, beside the chat view's composer: typed in the terminal for Claude,
 * or a shell command typed there and its output.
 */
export const ViaShell = "shell";
/**
 * SteerData is a message given to the running turn; the text is the body. Via is ViaTerminal for a
 * line typed in the terminal while Claude worked, empty for the chat view's.
 */
export interface SteerData {
	turnRef: string;
	via?: string;
}
/**
 * NoteData is a message for the team that is never sent to Claude; the text is the body.
 */
export interface NoteData {
}
/**
 * AnswerData is the answer to a card: the first one inserted wins.
 */
export interface AnswerData {
	cardSrc: string;
	/**
	 * Choice is empty while the answer records no decision: a question or plan parked, set aside or
	 * superseded before anybody chose.
	 */
	choice?: AnswerChoice;
	answers?: SentAnswer[];
	feedback?: string;
	how: AnswerHow;
	/**
	 * Reason says why a request was set aside while the chat stayed open: SetAsideTooSoon, Claude
	 * asked again too soon (a closed chat's set-aside needs no word).
	 */
	reason?: string;
}
/**
 * SetAsideTooSoon is AnswerData.Reason for a request to change code Claude made too soon after the
 * last ones (the pace rule of S01 §7).
 */
export const SetAsideTooSoon = "too_soon";
/**
 * CommandData is a command that runs as a turn of its own, such as a compaction.
 */
export interface CommandData {
	command: string;
	args?: string;
}
/**
 * NoticeData is something the chat tells its readers: a pause, a refused reshape, a change the git
 * flow had to make, what the machine discarded or could not keep. Fields beyond the code are ids,
 * words, paths and counts that let the copy name what it is about — never a file's content.
 */
export interface NoticeData {
	code: NoticeCode;
	pause?: string;
	reason?: string;
	to?: ChatMode;
	part?: string;
	op?: string;
	repos?: string[];
	/**
	 * Paths and N are also reactivated's: the uncommitted files the record never held, under their
	 * repositories, and how many in all.
	 */
	paths?: string[];
	/**
	 * Commits are import_refused's for ImportForeignCommit: the full ids of the commits made outside
	 * the chat, oldest first, at most gitflow's limit, with N how many there were.
	 */
	commits?: string[];
	n?: number /* int */;
	/**
	 * UserId is the person the notice is about where it is somebody's: the author of a message that
	 * went back into the queue (steer_requeued), the member whose Claude login was signed out of the
	 * chat (native_dropped), and the signer of the own login a reactivation did not keep (NativeLogin).
	 */
	userId?: number /* int64 */;
	/**
	 * Moment and Strays are stray_discarded's: when the switch check ran (a switch to Can change code)
	 * and what it put back, per repository.
	 */
	moment?: string;
	strays?: NoticeStray[];
	/**
	 * Files, Bytes and More are the files a notice names with their sizes, the bytes they hold
	 * together, and how many more there were than it names: reactivated's keep files left out at the
	 * pack or the unpack (Bytes the keep bytes put back).
	 */
	files?: NoticeFile[];
	bytes?: number /* int64 */;
	more?: number /* int */;
	/**
	 * Since, Session, SessionTurn, SessionLeftOut, Keep and WorkLost are reactivated's, beside Reason
	 * (the environment's cause): when the environment went (the deactivation's record; for a lost
	 * one, when the loss was found), what came back of Claude's session (with older, the last turn the
	 * resumed session holds, and the side files its pack left out), what came back of the keep folder,
	 * and whether uncommitted work after the last capture was lost.
	 */
	since?: number /* int64 */;
	session?: SessionOutcome;
	sessionTurn?: number /* int */;
	sessionLeftOut?: number /* int */;
	keep?: KeepOutcome;
	workLost?: boolean;
	/**
	 * NativeLogin is reactivated's too: the chat held its own Claude login, which went with the
	 * container, and UserId is the member who had signed it in (0: signed in inside the container).
	 */
	nativeLogin?: boolean;
	/**
	 * PreviewsBack is reactivated's too: the chat's previews file came back with the keep folder;
	 * without it the list starts again from the defaults.
	 */
	previewsBack?: boolean;
}
/**
 * NoticeStray is one repository of a stray_discarded notice: up to MaxNoticePaths of its paths, how
 * many were changed, added and removed in all, how many more paths there were than named, and how
 * many commits the branch had moved by.
 */
export interface NoticeStray {
	repo: string;
	paths?: string[];
	changed?: number /* int */;
	added?: number /* int */;
	removed?: number /* int */;
	more?: number /* int */;
	commits?: number /* int */;
}
/**
 * NoticeFile is one file a notice names: its path under the chat's home and its size.
 */
export interface NoticeFile {
	path: string;
	bytes: number /* int64 */;
}
/**
 * MaxNoticePaths is how many paths a notice names per list; the rest is counted.
 */
export const MaxNoticePaths = 20;
/**
 * EventData is a shared act. Via says how a mode change came about (create, owner, card or
 * refused — a refused switch draws nothing); Preview names the preview the act was about by its name,
 * never its title (access_requested, access_dismissed, preview_added, preview_changed,
 * preview_removed, preview_public, preview_private) — its JSON key stays "platform", which the
 * access requests of the permanent record already hold; From is the model id a chat's model word ran before it
 * moved to a newer one (model_changed, reason moved), Model the id it runs now; the other fields name
 * what the act touched.
 */
export interface EventData {
	event: EventKind;
	to?: ChatMode;
	via?: string;
	part?: string;
	groupId?: string;
	userId?: string;
	platform?: PreviewName;
	model?: string;
	from?: string;
	effort?: string;
	n?: number /* int */;
	reason?: string;
}
/**
 * RevisionData is a new revision of a modifying chat's work.
 */
export interface RevisionData {
	n: number /* int */;
	cause: string;
	turn?: string;
	/**
	 * RestoredFrom is the revision a restore went back to: the marker names it ("Restored to r2"),
	 * not the new revision the restore became.
	 */
	restoredFrom?: number /* int */;
}
/**
 * BaseData is a base update: the repositories whose main moved under the chat.
 */
export interface BaseData {
	repos: BaseRepo[];
	conflict?: boolean;
	n?: number /* int */;
}
/**
 * BaseRepo is one repository of a base update.
 */
export interface BaseRepo {
	repo: string;
	from: string;
	to: string;
}
/**
 * CallData is one call of teamBase's tool sets that teamBase answered (A3-D16): core's record of it,
 * written by the module after the answer, one item a call. It names what the call was about and how
 * it ended, and nothing more: never an argument beyond its target, never a word of the answer, and
 * never the cause of a refusal — the page asks for that as it stands now, for a viewer who may know
 * it. The catalogue ops (sets, help, guide) leave no item.
 */
export interface CallData {
	/**
	 * Call is the host's id of the call, which the answer carried and the Bash row names.
	 */
	call: string;
	set: string;
	tool: string;
	/**
	 * Row is the tool's kind of row (CallRows), from which the page takes its words.
	 */
	row: string;
	/**
	 * Target is what the call was about, where its arguments named it: the page labels it for each
	 * viewer, so a rename shows and a level lowered hides.
	 */
	target?: CallTarget;
	/**
	 * Verdict is the answer's (CallVerdicts); Code and Problem are a refusal's reason and problem.
	 */
	verdict: string;
	code?: string;
	problem?: string;
	/**
	 * Bytes is the answer's size.
	 */
	bytes?: number /* int */;
	/**
	 * Suggested says a write landed as a suggestion people decide, not as an edit.
	 */
	suggested?: boolean;
}
/**
 * CallTarget is what a call was about: a kind of reference and, where the call named one thing, its
 * id — a document's key, a conversation's id, an AI chat's key, a user's or a group's id.
 */
export interface CallTarget {
	kind: string;
	id?: string;
}
/**
 * LandingData is a publish attempt and how it ended.
 */
export interface LandingData {
	landingId: string;
	n: number /* int */;
	attempt?: number /* int */;
	state: string;
}

//////////
// source: driver.go

/**
 * Driver is the kind of the process that holds the chat's session.
 */
export type Driver = string;
/**
 * DriverGUI is the chat view's headless process, or no process at all.
 */
export const DriverGUI: Driver = "gui";
/**
 * DriverCLI is the interactive Claude Code in the chat's terminal, while it lives.
 */
export const DriverCLI: Driver = "cli";
/**
 * DriverCommand is `aichat.driver`: an owner's press of "Start Claude Code here" (DriverCLI) or of the
 * way back to the chat view (DriverGUI). The host runs it at the session's next quiet point, never
 * under a running turn. Restart starts a running terminal again; it is a press for the terminal only.
 * By is the owner who pressed.
 */
export interface DriverCommand {
	driver: Driver;
	restart?: boolean;
	by: number /* int64 */;
}
/**
 * DriverDone is the done data of `aichat.driver`: the driver now in force.
 */
export interface DriverDone {
	driver: Driver;
}
/**
 * DriverFailShowFor is how long a chat's row still says that a switch failed after its command was
 * refused, failed or lost, unless an owner pressed again. Spelt in nanoseconds (ten minutes) because
 * the browser's generated copy of this package can name no constant of another package.
 */
export const DriverFailShowFor: any /* time.Duration */ = 600_000_000_000;

//////////
// source: env.go

/**
 * EnvCause is why a chat's environment went away (aichat_chat.env_cause; "" is none).
 */
export type EnvCause = string;
export const EnvCauseInactive: EnvCause = "inactive"; // the capacity sweep: unused for long while the pool is short of space
export const EnvCauseOperator: EnvCause = "operator"; // teambase aichat deactivate
export const EnvCauseArchive: EnvCause = "archive"; // the chat was archived
export const EnvCauseReset: EnvCause = "reset"; // an owner's Reset environment: deactivated and reactivated at once
export const EnvCauseLost: EnvCause = "lost"; // the container was found missing or foreign; never a deactivation's cause
/**
 * DeactivateCommand is `aichat.deactivate`: capture the work first, pack Claude's session (always)
 * and the keep folder, upload both, and answer. The host deletes nothing: the relay deletes the
 * container after teamBase acknowledged the answer. Without Force any failure refuses and the
 * container stays; with Force each loss is recorded in the answer and the deactivation goes on.
 */
export interface DeactivateCommand {
	cause: EnvCause;
	force?: boolean;
}
/**
 * DeactivateDone is the data of a done `aichat.deactivate`: the session pack teamBase now holds (nil
 * only with Force, when Lost names the session), the keep pack's stored sha and bytes before
 * compression ("" when the folder was empty or lost), the files each pack left out in path order
 * (at most MaxPackLeftOut per list, the rest counted in *More), the cap id of the final capture ("" in
 * a read chat) and, with Force, what was lost.
 */
export interface DeactivateDone {
	session?: SessionPack;
	sessionLeftOut?: PackFile[];
	sessionMore?: number /* int */;
	keep?: string;
	keepBytes?: number /* int64 */;
	keepLeftOut?: PackFile[];
	keepMore?: number /* int */;
	capturedRev?: string;
	lost?: string[];
}
/**
 * PackFile is a file a pack left out: its path relative to the chat's home, and its size.
 */
export interface PackFile {
	path: string;
	bytes: number /* int64 */;
}
/**
 * MaxPackLeftOut bounds each left-out list on the wire; the chat's record and the notice keep
 * MaxNoticePaths of them.
 */
export const MaxPackLeftOut = 50;
/**
 * What a forced deactivation may lose: the work after the last capture, the Claude session, the keep
 * folder.
 */
export const LostWork = "work";
/**
 * What a forced deactivation may lose: the work after the last capture, the Claude session, the keep
 * folder.
 */
export const LostSession = "session";
/**
 * What a forced deactivation may lose: the work after the last capture, the Claude session, the keep
 * folder.
 */
export const LostKeep = "keep";
/**
 * SessionOutcome is what came back of Claude's session at a reactivation; the owners' notice and
 * Claude's note read the same word, so the two never tell different stories.
 */
export type SessionOutcome = string;
/**
 * SessionWhole: the resumed pack holds the session's last turn.
 */
export const SessionWhole: SessionOutcome = "whole";
/**
 * SessionOlder: the pack ends earlier, and teamBase's record tells Claude the turns after it.
 */
export const SessionOlder: SessionOutcome = "older";
/**
 * SessionNone: no pack; the primer stands for the session.
 */
export const SessionNone: SessionOutcome = "none";
/**
 * KeepOutcome is what came back of the keep folder at a reactivation.
 */
export type KeepOutcome = string;
/**
 * KeepOutcomeWhole: every file is back.
 */
export const KeepOutcomeWhole: KeepOutcome = "whole";
/**
 * KeepOutcomePartial: the pack or the unpack left files out (the notice names them).
 */
export const KeepOutcomePartial: KeepOutcome = "partial";
/**
 * KeepOutcomeEmpty: the folder was empty, and no pack was kept.
 */
export const KeepOutcomeEmpty: KeepOutcome = "empty";
/**
 * KeepOutcomeLost: a forced deactivation lost it, a lost container had none to give, or its pack
 * was missing.
 */
export const KeepOutcomeLost: KeepOutcome = "lost";
/**
 * EnvBrokenHold is how long the session host holds a container broken after its forced restart failed
 * (it then tries one plain start); teamBase holds a broken chat's deliveries as long. It is spelt in
 * nanoseconds, not as 10 * time.Minute, because the browser's generated copy of this package can name
 * no constant of another package.
 */
export const EnvBrokenHold: any /* time.Duration */ = 600_000_000_000;
/**
 * The states of a chat's container, the machine's words. They travel in the host picture only;
 * teamBase derives the people's word from them and never stores them.
 */
export const ContainerAbsent = "absent";
/**
 * The states of a chat's container, the machine's words. They travel in the host picture only;
 * teamBase derives the people's word from them and never stores them.
 */
export const ContainerCreating = "creating";
/**
 * The states of a chat's container, the machine's words. They travel in the host picture only;
 * teamBase derives the people's word from them and never stores them.
 */
export const ContainerStopped = "stopped";
/**
 * The states of a chat's container, the machine's words. They travel in the host picture only;
 * teamBase derives the people's word from them and never stores them.
 */
export const ContainerStarting = "starting";
/**
 * The states of a chat's container, the machine's words. They travel in the host picture only;
 * teamBase derives the people's word from them and never stores them.
 */
export const ContainerRunning = "running";
/**
 * The states of a chat's container, the machine's words. They travel in the host picture only;
 * teamBase derives the people's word from them and never stores them.
 */
export const ContainerStopping = "stopping";
/**
 * The states of a chat's container, the machine's words. They travel in the host picture only;
 * teamBase derives the people's word from them and never stores them.
 */
export const ContainerBroken = "broken";
/**
 * The steps of a container's setting up, waking, reactivation or deactivation, which the run line and
 * Settings name while one runs: making or starting the container, laying out the repositories, putting
 * back the keep folder and Claude's session, and saving before a deactivation.
 */
export const EnvStepContainer = "container";
/**
 * The steps of a container's setting up, waking, reactivation or deactivation, which the run line and
 * Settings name while one runs: making or starting the container, laying out the repositories, putting
 * back the keep folder and Claude's session, and saving before a deactivation.
 */
export const EnvStepRepositories = "repositories";
/**
 * The steps of a container's setting up, waking, reactivation or deactivation, which the run line and
 * Settings name while one runs: making or starting the container, laying out the repositories, putting
 * back the keep folder and Claude's session, and saving before a deactivation.
 */
export const EnvStepKeep = "keep";
/**
 * The steps of a container's setting up, waking, reactivation or deactivation, which the run line and
 * Settings name while one runs: making or starting the container, laying out the repositories, putting
 * back the keep folder and Claude's session, and saving before a deactivation.
 */
export const EnvStepSession = "session";
/**
 * The steps of a container's setting up, waking, reactivation or deactivation, which the run line and
 * Settings name while one runs: making or starting the container, laying out the repositories, putting
 * back the keep folder and Claude's session, and saving before a deactivation.
 */
export const EnvStepSaving = "saving";
/**
 * Why a chat waits in the session host's start line: the running budget is full, or the bridge's
 * firewall table is not loaded. The module's in-line words are these.
 */
export const LineWhyMachine = "machine";
/**
 * Why a chat waits in the session host's start line: the running budget is full, or the bridge's
 * firewall table is not loaded. The module's in-line words are these.
 */
export const LineWhyNetwork = "network";
/**
 * The states of a chat's additional container.
 */
export const ExtraNone = "none";
/**
 * The states of a chat's additional container.
 */
export const ExtraRunning = "running";
/**
 * The states of a chat's additional container.
 */
export const ExtraStopped = "stopped";

//////////
// source: follow.go

/**
 * FocusWant is `aichat.focus`: the agents whose live tail somebody reads, by their item src
 * (`t:<tool_use_id>` for a helper, `w:<task>:<index>` for a workflow's agent). The host sends an
 * `aichat.agent` picture for each — at once, then at most two a second while its steps change.
 */
export interface FocusWant {
	agents: string[];
}
/**
 * TailWant is `aichat.tail`: the background tasks whose output somebody has open, by their task id.
 * The host reads each running one's output file at most once a second and writes its newest
 * MaxTail bytes into the task's item (outputTail) when they changed.
 */
export interface TailWant {
	tasks: string[];
}
/**
 * PresenceWant is `aichat.presence`: whether an owner has the chat on screen, whether an owner has it
 * open at all, which preview panels an owner has open (the server's panel lease is the one store of
 * "open"), and the terminal while somebody has it open (nil: nobody, and the host sends none of its
 * output). It is sent after every attach and on every change, but never to a dormant session unless
 * somebody looks, has a panel or the terminal open: that would wake a host only to say nobody looks,
 * or that the chat is merely open in a background tab, and a host reads "nobody" when its session
 * detaches anyway. The host keeps a looked-at container running and reads the panels' files while a
 * panel is open; presence never starts a container.
 * The two levels are the chat's active and passive use as the page sees it. Looking is active: an
 * owner's tab shows the chat on screen (a window that only lost focus to another window still does),
 * and the host holds the container while it is true. Open is passive: an owner's tab shows the chat,
 * visible or hidden (a tab behind another tab, a minimised window), so Looking implies Open. The host
 * takes Open as a passive stamp of its idle rule only, never as a hold, so a forgotten tab keeps a
 * container at most idle_max after its last active use.
 */
export interface PresenceWant {
	looking: boolean;
	open: boolean;
	panels: PreviewName[];
	terminal?: TerminalWant;
}
/**
 * The bounds of the wants: how many agents and tasks one chat's readers may follow at once (more are
 * not followed), and how long a read keeps a name wanted.
 */
export const MaxFocusAgents = 16;
/**
 * The bounds of the wants: how many agents and tasks one chat's readers may follow at once (more are
 * not followed), and how long a read keeps a name wanted.
 */
export const MaxTailTasks = 4;
/**
 * The bounds of the wants: how many agents and tasks one chat's readers may follow at once (more are
 * not followed), and how long a read keeps a name wanted.
 */
export const FollowTTLSeconds = 30;

//////////
// source: frames.go

/**
 * SessionKindChat is one chat on the worker machine, in its container; its dev end is the
 * machine's session host, which hosts every chat.
 */
export const SessionKindChat = "aichat.chat";
/**
 * SessionKindAuth is the machine's Claude login broker, which holds the members' logins, one
 * session per worker; it carries wants and pictures only.
 */
export const SessionKindAuth = "aichat.auth";
/**
 * ChatKindVersion is 4 since Claude calls teamBase's tool sets through `tb-chat`: the call and its
 * reply are frames of two classes a worker of version 3 does not know, so a server and a worker of
 * those two releases open no chat session at all, and a message sent between the server's update
 * and the worker's waits in its queue until both run one release.
 */
export const ChatKindVersion = 4;
/**
 * AuthKindVersion is 2 since members connect their own logins: the want names logins by id, a
 * grant always names one, the connect carries a token, and the picture lists every login. A
 * server and a worker of different releases open no auth session, so no turn runs until both
 * are upgraded.
 */
export const AuthKindVersion = 2;
/**
 * FrameClass is how a frame travels, and with it which way.
 */
export type FrameClass = string;
/**
 * ClassReliable is up: sequenced, kept in the dev end's outbox until teamBase has committed it.
 */
export const ClassReliable: FrameClass = "reliable";
/**
 * ClassPicture is up: the newest state of something, lossy, never stored.
 */
export const ClassPicture: FrameClass = "picture";
/**
 * ClassCommand is down: a module row numbered in the transaction of its cause, sent in order.
 */
export const ClassCommand: FrameClass = "command";
/**
 * ClassWant is down: a desired state, sent after every attach and every change.
 */
export const ClassWant: FrameClass = "want";
/**
 * ClassFlow is up: one piece of a live byte stream, unsequenced, never stored, never coalesced,
 * and dropped whole when the way is full; the kind's own protocol heals the hole.
 */
export const ClassFlow: FrameClass = "flow";
/**
 * ClassCall is up: a question the worker machine waits for, unsequenced and never stored, handed
 * to teamBase's module only once every reliable frame sent before it is committed, so it is asked
 * of the state they made. A lost one is asked again under the same id.
 */
export const ClassCall: FrameClass = "call";
/**
 * ClassReply is down: teamBase's answer to one call, sent once to the stream that carries the
 * session, never stored and never re-sent.
 */
export const ClassReply: FrameClass = "reply";
/**
 * Frame declares one frame type.
 */
export interface Frame {
	type: string;
	kind: string;
	class: FrameClass;
	/**
	 * MaxBytes bounds the frame's data, the envelope aside.
	 */
	maxBytes: number /* int */;
}
/**
 * Down, commands.
 */
export const CmdMaterialise = "aichat.materialise";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdAdopt = "aichat.adopt";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdCapture = "aichat.capture";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdExport = "aichat.export";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdCheck = "aichat.check";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdMode = "aichat.mode";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdDeliver = "aichat.deliver";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdSteer = "aichat.steer";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdWithdraw = "aichat.withdraw";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdInterrupt = "aichat.interrupt";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdAnswer = "aichat.answer";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdControl = "aichat.control";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdFiles = "aichat.files";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdDeactivate = "aichat.deactivate";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdForget = "aichat.forget";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const CmdDriver = "aichat.driver";
/**
 * Down, wants.
 */
export const WantPreview = "aichat.preview.want";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const WantPresence = "aichat.presence";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const WantFocus = "aichat.focus";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const WantTail = "aichat.tail";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const WantTerminalInput = "aichat.terminal.input";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const WantNotes = "aichat.notes";
/**
 * Down, replies.
 */
export const ReplySet = "aichat.reply";
/**
 * Up, reliable.
 */
export const FrameItem = "aichat.item";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const FrameTurn = "aichat.turn";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const FrameCmd = "aichat.cmd";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const FrameCLI = "aichat.cli";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const FrameCard = "aichat.card";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const FrameCaptureReady = "aichat.capture.ready";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const FrameCheckResult = "aichat.check.result";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const FrameTyped = "aichat.typed";
/**
 * Up, flow.
 */
export const FlowTerminalOutput = "aichat.terminal.output";
/**
 * Up, calls.
 */
export const CallSet = "aichat.call";
/**
 * Up, pictures.
 */
export const PictureLive = "aichat.live";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const PictureWorkflow = "aichat.workflow";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const PictureAgent = "aichat.agent";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const PictureHost = "aichat.host";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const PicturePreview = "aichat.preview";
/**
 * The frame types of the chat kind, each named once: teamBase and the worker machine both use these,
 * and Frames below declares each one's class and bound.
 */
export const PicturePreviewPanel = "aichat.preview.panel";

//////////
// source: git.go

/**
 * CaptureCause is why the host took the copy.
 */
export type CaptureCause = string;
/**
 * CaptureTurnEnd is the capture at the end of every turn of a modifying chat.
 */
export const CaptureTurnEnd: CaptureCause = "turn_end";
/**
 * CaptureRestore takes the copy before a restore resets it.
 */
export const CaptureRestore: CaptureCause = "restore";
/**
 * CaptureDeactivate and CaptureClose take it before the chat's container goes or its session
 * closes: work that is not in teamBase never leaves the container.
 */
export const CaptureDeactivate: CaptureCause = "deactivate";
export const CaptureClose: CaptureCause = "close";
/**
 * CaptureAdopt takes the copy as it is after dev refused an adopt: its real state becomes the
 * latest revision, and the refused one stays in history.
 */
export const CaptureAdopt: CaptureCause = "adopt";
/**
 * CaptureResume is the first quiet point after a crash, and teamBase's ask for a capture that is
 * missing or failed.
 */
export const CaptureResume: CaptureCause = "resume";
/**
 * CaptureSwitch makes sure the last turn's work is in a revision before a switch to read.
 */
export const CaptureSwitch: CaptureCause = "switch";
/**
 * CaptureTerminal takes a modifying chat's copy after a shell command typed in the terminal ends
 * between turns, and at the terminal's quiet end, so work done there reaches Changes at once.
 */
export const CaptureTerminal: CaptureCause = "terminal";
/**
 * CaptureCommand is `aichat.capture`: take the copy at the next quiet point. Full asks for bundles
 * that leave out only each repository's base, for a teamBase whose clone lost a commit a regular
 * capture would assume it holds.
 */
export interface CaptureCommand {
	cause: CaptureCause;
	full?: boolean;
	/**
	 * Turn is the uuid of the turn whose work the capture secures, which the host echoes as the
	 * capture's turn: the work is that turn's asker's, whenever the frame arrives.
	 */
	turn?: string;
}
/**
 * The states of a capture.
 */
export const CaptureOK = "ok";
/**
 * The states of a capture.
 */
export const CaptureFailed = "failed";
/**
 * ImportForeignCommit refuses a capture whose work holds a commit neither Claude made in the chat,
 * nor teamBase made for it, nor main holds: another branch taken by merge, reset or checkout.
 */
export const ImportForeignCommit = "foreign_commit";
/**
 * CaptureMainUnreachable fails a capture whose import could not learn main as GitHub has it now —
 * the fetch failed or did not run — for longer than import_timeout.
 */
export const CaptureMainUnreachable = "main_unreachable";
/**
 * CaptureReady is `aichat.capture.ready`, up and reliable: one capture of every repository of the
 * copy, named `<epoch>:<n>` by the host — epoch its outbox incarnation, n counted within it — so that
 * an id is never reused across a rematerialise. Turn is the uuid of the turn whose end it closes, ""
 * for a capture outside a turn. A failed capture carries its GitResult in Code and no repository.
 */
export interface CaptureReady {
	cap: string;
	turn?: string;
	/**
	 * At is when the host took the capture (epoch ms): the time the turn's commits are dated, clamped
	 * by teamBase to the turn's delivery and the frame's arrival. It travels in the frame, so a frame
	 * replayed after a restore dates them the same and mints the same commit ids.
	 */
	at?: number /* int64 */;
	cause: CaptureCause;
	state: string;
	code?: string;
	repos?: CaptureRepo[];
	gitmetaRestored?: string[];
	locksRemoved?: string[];
}
/**
 * MaxCapLength bounds a capture id: an outbox epoch, a colon and a count.
 */
export const MaxCapLength = 64;
/**
 * CaptureRepo is one repository as the capture found it. Head is dev's HEAD; BranchOK says HEAD is
 * the chat's branch (false: detached); Op names an unfinished git operation. Wip is the host's commit
 * of the uncommitted work on Head and WipTree its tree, both empty when the work tree equals Head;
 * Excluded are the files the host left out of it to keep it under its cap, largest first. HeadTree is
 * Head's tree, which a restore holds the work tree to when there is no uncommitted work. Bundle is nil
 * when teamBase holds every commit named already.
 */
export interface CaptureRepo {
	repo: string;
	head: string;
	headTree?: string;
	branchOk: boolean;
	op?: GitOp;
	dirty?: boolean;
	wip?: string;
	wipTree?: string;
	excluded?: ExcludedFile[];
	bundle?: CaptureBundle;
}
/**
 * ExcludedFile is a file of the work tree the host left out of the uncommitted work.
 */
export interface ExcludedFile {
	path: string;
	size: number /* int64 */;
}
/**
 * CaptureBundle is one uploaded bundle: the sha the host uploaded it under, its size, and every ref
 * it carries with the commit the ref names — which teamBase holds the bundle's header to.
 */
export interface CaptureBundle {
	sha256: string;
	size: number /* int64 */;
	refs: BundleRef[];
}
/**
 * BundleRef is one ref of a bundle.
 */
export interface BundleRef {
	ref: string;
	commit: string;
}
/**
 * The roles of a capture's refs: `refs/aichat/cap/<epoch>/<n>/<role>` in dev's repository.
 */
export const CapRefHead = "head";
/**
 * The roles of a capture's refs: `refs/aichat/cap/<epoch>/<n>/<role>` in dev's repository.
 */
export const CapRefWip = "wip";
/**
 * CapRefPrefix is where the host names a capture's refs.
 */
export const CapRefPrefix = "refs/aichat/cap/";
/**
 * UpstreamRefPrefix is where a chat's copy shows every GitHub branch besides main, as
 * `upstream/<branch>`: refs teamBase rewrites from the worker's mirror and never reads back.
 */
export const UpstreamRefPrefix = "refs/remotes/upstream/";
/**
 * GitOp is an unfinished operation a capture found in a repository (the files `status` looks for).
 */
export type GitOp = string;
export const GitOpRebase: GitOp = "rebase";
export const GitOpMerge: GitOp = "merge";
export const GitOpCherryPick: GitOp = "cherry-pick";
export const GitOpRevert: GitOp = "revert";
export const GitOpBisect: GitOp = "bisect";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitOK = "ok";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitDiskFull = "disk_full";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitLocked = "locked";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitMissingObjects = "missing_objects";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitExpectMismatch = "expect_mismatch";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitTreeMismatch = "tree_mismatch";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitKeepRefused = "keep_refused";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitChangedSinceCapture = "changed_since_capture";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitTooLarge = "too_large";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitNotARepo = "not_a_repo";
/**
 * The result codes of a git verb on the worker machine (S08 §2), named once for both machines: the
 * host reports them, teamBase keys an action on each.
 */
export const GitInternal = "internal";
/**
 * GitStoreMissing is the machine's shared history gone from the container (the AI system unmounted
 * it): no git ran, and the host restarts the container once, which mounts it again.
 */
export const GitStoreMissing = "store_missing";
/**
 * AdoptMode is how the host moves a repository onto the head teamBase names.
 */
export type AdoptMode = string;
/**
 * AdoptMove moves the branch ref only: the head has the tree dev's HEAD has (canonical commits
 * of Claude's own).
 */
export const AdoptMove: AdoptMode = "move";
/**
 * AdoptKeep resets with --keep: the head is a base update's, and the work tree follows it.
 */
export const AdoptKeep: AdoptMode = "keep";
/**
 * AdoptHard resets and cleans the work tree: a restore.
 */
export const AdoptHard: AdoptMode = "hard";
/**
 * AdoptCommand is `aichat.adopt`: move each named repository onto revision N's canonical head, and
 * drop the capture refs up to DropCapsUpto (a cap id), which teamBase has taken in. Attempt counts
 * the sends of the same adopt: teamBase sends one again once after dev could not run it.
 */
export interface AdoptCommand {
	n: number /* int64 */;
	repos: AdoptRepo[];
	dropCapsUpto?: string;
	attempt?: number /* int */;
}
/**
 * AdoptRepo is one repository of an adopt. Expect are the heads dev may be at (its own head, the
 * previous canonical head); To is where it goes and Main the base teamBase's record puts it on.
 * Bundle is the stored sha of a granted bundle holding To's history, "" when dev holds it already.
 * ExpectTree, WipTree and KeepPaths serve a hard adopt: the tree the work tree must still be, the
 * uncommitted work to put back, and the untracked files the clean must leave.
 */
export interface AdoptRepo {
	repo: string;
	mode: AdoptMode;
	expect: string[];
	to: string;
	main: string;
	bundle?: string;
	expectTree?: string;
	wipTree?: string;
	keepPaths?: string[];
}
/**
 * AdoptDone is the data of an answered `aichat.adopt`: each repository's result and where its head
 * is now.
 */
export interface AdoptDone {
	n: number /* int64 */;
	repos: RepoResult[];
}
/**
 * RepoResult is one repository's outcome of a git verb.
 */
export interface RepoResult {
	repo: string;
	result: string;
	head?: string;
	movedAside?: string[];
}
/**
 * MaterialiseCause is why teamBase lays a chat's copy out: the first copy (or one rebuilt in a
 * container that keeps its home), a reactivation after a deactivation, the second half of Reset
 * environment, or a new or emptied container found under a chat that has one. The cause only names
 * what the notice and Claude's note say; the host lays the copy out the same way for each.
 */
export type MaterialiseCause = string;
export const MaterialiseCreate: MaterialiseCause = "create";
export const MaterialiseReactivate: MaterialiseCause = "reactivate";
export const MaterialiseReset: MaterialiseCause = "reset";
export const MaterialiseLost: MaterialiseCause = "lost";
/**
 * MaterialiseCommand is `aichat.materialise`: build the whole copy from teamBase's record, in the
 * chat's mode: every repository of the configuration, flat, in landing order. Attempt counts the
 * sends of a copy teamBase had to build again. Session and Keep name the session pack and the keep
 * pack a reactivation brings back, which teamBase grants for download with the command (Role names
 * the class: BlobSession or BlobKeep): the host unpacks the keep pack into src/.aichat/keep and the
 * session pack before Claude Code starts, and says in MaterialiseDone.Restored how that went.
 */
export interface MaterialiseCommand {
	cause: MaterialiseCause;
	mode: ChatMode;
	repos: MaterialiseRepo[];
	attempt?: number /* int */;
	session?: BlobRef;
	keep?: BlobRef;
}
/**
 * MaterialiseRepo is one repository: its head and the base it sits on (both the pin of a chat
 * without revisions), the stored sha of a granted bundle with the history between them, and the
 * tree of the uncommitted work to put back.
 */
export interface MaterialiseRepo {
	repo: string;
	head: string;
	main: string;
	bundle?: string;
	wipTree?: string;
}
/**
 * MaterialiseDone is the data of an answered `aichat.materialise`: each repository's result, and, when
 * the command named a session or a keep pack, how they came back.
 */
export interface MaterialiseDone {
	repos: RepoResult[];
	restored?: Restored;
}
/**
 * Restored is how a reactivation's packs came back: whether the session pack was unpacked, what
 * the keep pack's unpack did (KeepRestores) with the paths it left out, relative to the keep folder,
 * in path order (at most MaxPackLeftOut, the rest counted in KeepMore), and whether the chat's
 * previews file came back with the keep pack (a pack made before previews had a file carries none).
 */
export interface Restored {
	session: boolean;
	keep: string;
	keepLeftOut?: string[];
	keepMore?: number /* int */;
	previewsBack?: boolean;
}
/**
 * What the keep pack's unpack did. KeepOutcomes (env.go) is what the owners and Claude are told,
 * which also counts what the pack left out before.
 */
export const KeepWhole = "whole";
/**
 * What the keep pack's unpack did. KeepOutcomes (env.go) is what the owners and Claude are told,
 * which also counts what the pack left out before.
 */
export const KeepPartial = "partial";
/**
 * What the keep pack's unpack did. KeepOutcomes (env.go) is what the owners and Claude are told,
 * which also counts what the pack left out before.
 */
export const KeepNone = "none";

//////////
// source: health.go

/**
 * HealthVersion is the version of the aichat.chat picture's shape: 2 is the container machine's,
 * whose picture names no account, port block or slice. AuthHealthVersion is the aichat.auth
 * picture's: 2 since the picture lists the members' logins by id.
 */
export const HealthVersion = 2;
/**
 * HealthVersion is the version of the aichat.chat picture's shape: 2 is the container machine's,
 * whose picture names no account, port block or slice. AuthHealthVersion is the aichat.auth
 * picture's: 2 since the picture lists the members' logins by id.
 */
export const AuthHealthVersion = 2;
/**
 * MaxHealthPicture bounds one picture's JSON: the stream's bound of a health frame's data.
 */
export const MaxHealthPicture = 16 << 10;
/**
 * MaxHealthList bounds each list of a picture.
 */
export const MaxHealthList = 64;
/**
 * ChatHealth is the aichat.chat picture: the machine as the relay sees it.
 */
export interface ChatHealth {
	v: number /* int */;
	at: number /* int64 */;
	/**
	 * Builds are the versions of the worker binary (which the host and the launcher share), the root
	 * helper and the login broker.
	 */
	builds: HealthBuilds;
	machine: HealthMachine;
	disk: HealthDisk[];
	/**
	 * Pool is the containers' storage pool, nil until the root helper answered; Image the chat image
	 * the next container is made from.
	 */
	pool?: HealthPool;
	image?: HealthImage;
	capacity: HealthCapacity;
	chats: HealthChats;
	hosts: HealthHosts;
	cli: HealthCLIPin;
	units: HealthUnits;
	permits: HealthPermits;
	prov: HealthProv;
	walls: HealthWalls;
	/**
	 * Previews is the machine's preview gateway and the cuts it owes, nil on a machine that runs no
	 * previews (no domain in preview.toml).
	 */
	previews?: HealthPreviews;
	/**
	 * Terminals are the chats' terminals as the relay counts them from the hosts' newest pictures; nil
	 * only in a picture of a relay older than the terminal.
	 */
	terminals?: HealthTerminals;
	/**
	 * SetCalls are the calls of teamBase's tool sets the chats' hosts relayed over the last hour; nil
	 * only in a picture of a relay older than the tool sets.
	 */
	setCalls?: HealthSetCalls;
}
/**
 * HealthSetCalls are the calls of teamBase's tool sets the chats' hosts sent to teamBase over the last
 * hour, summed from their newest pictures of that hour, and how many of them no answer came for in
 * time: the worker's doctor row aichat_tools warns when that is more than one in ten.
 */
export interface HealthSetCalls {
	hour: number /* int */;
	hourUnknown: number /* int */;
}
/**
 * HealthTerminals are the chats' terminals as their hosts last pictured them: how many run now (from
 * the start to the end), how many the hosts hold broken and by which code, how many of the running
 * ones have been due a restart for over an hour, and how many times a second writer was seen on a
 * chat's Claude session over the last week.
 */
export interface HealthTerminals {
	running: number /* int */;
	broken: number /* int */;
	brokenCodes?: { [key: string]: number /* int */};
	restartsDueOverHour: number /* int */;
	secondWriters7d: number /* int */;
}
/**
 * HealthPreviews is the previews' part of the picture (S15 §7's gateway part): the preview gateway's
 * status as the relay last read it from its status socket — nil, with GatewayError saying why, when
 * the gateway did not answer. A cut the gateway owes is no fact of the picture: teamBase reads it from
 * a preview's want and the picture's answer to it.
 */
export interface HealthPreviews {
	gateway?: HealthGateway;
	gatewayError?: string;
}
/**
 * HealthGateway is what of the gateway's status the doctor judges: when the relay read it, the
 * gateway's build, and its last connection from the teamBase server's end of the tunnel.
 */
export interface HealthGateway {
	at: number /* int64 */;
	build?: string;
	peerOkAt?: number /* int64 */;
}
/**
 * HealthBuilds are the builds of the machine's AI chat processes, and incusd's version as the root
 * helper read it; "" is one that did not say.
 */
export interface HealthBuilds {
	worker: string;
	aiprov?: string;
	aiauth?: string;
	incus?: string;
}
/**
 * HealthPool is the containers' storage pool as the root helper read it: its name, whether it lives on
 * a device of its own or in a file on the system disk (PoolSources), its size and its use in bytes.
 */
export interface HealthPool {
	name: string;
	source: string;
	size: number /* int64 */;
	used: number /* int64 */;
}
/**
 * Where a pool lives.
 */
export const PoolDevice = "device";
/**
 * Where a pool lives.
 */
export const PoolFile = "file";
/**
 * HealthImage is the image a new container is made from: the alias (chat-current), the image it
 * points at (chat-<yyyymmdd-hhmm>) and when that was built.
 */
export interface HealthImage {
	alias: string;
	image: string;
	built: number /* int64 */;
}
/**
 * HealthMachine is the machine's memory and load. PSIMemSome10 is the percentage of the last ten
 * seconds some task waited for memory.
 */
export interface HealthMachine {
	cpus: number /* int */;
	memTotal: number /* int64 */;
	memAvailable: number /* int64 */;
	psiMemSome10: number /* float64 */;
	load5: number /* float64 */;
}
/**
 * HealthDisk is one filesystem of the host the AI chats write to, once per device; the first holds
 * /var/lib/teambase-aichat, where the session host spools the packs.
 */
export interface HealthDisk {
	path: string;
	total: number /* int64 */;
	free: number /* int64 */;
}
/**
 * HealthCapacity is the machine's machine.toml as far as teamBase acts on it, and the session host's
 * running budget now: how many units may run at once (a running container, a platform, an additional
 * container) and how many run, how many chats wait in the host's start line, the host's build permits,
 * the quiet after which a container stops, and the shares of the pool's free space below which no
 * container is made (FloorNew) and no turn starts (FloorTurn). teamBase keeps no copy: the picture is
 * the one source.
 */
export interface HealthCapacity {
	/**
	 * Error is why the machine's file could not be read; the numbers are then all zero.
	 */
	error?: string;
	profile?: string;
	maxRunning: number /* int */;
	running: number /* int */;
	inLine: number /* int */;
	maxBuilds: number /* int */;
	idleStopMs: number /* int64 */;
	floorNew: number /* float64 */;
	floorTurn: number /* float64 */;
}
/**
 * HealthChats are the machine's chats. Containers counts its chat containers (the drill's canary
 * left out), ContainersRunning those that run, Extras the additional containers, all from the root
 * helper's status; Broken the containers a host holds broken, Read and Modify the chats by the mode
 * their host last reported, and DiskFull the chats whose host reported a full quota, oldest first —
 * all from the hosts the relay has heard from since it started. Where a chat is otherwise —
 * deactivated, being reactivated — is teamBase's own record (aichat_chat).
 */
export interface HealthChats {
	containers: number /* int */;
	containersRunning: number /* int */;
	extras: number /* int */;
	broken: number /* int */;
	read: number /* int */;
	modify: number /* int */;
	diskFull?: HealthChatSince[];
	diskFullCount?: number /* int */;
}
/**
 * HealthHosts are the chats' hosts inside the one host process, as the relay saw them: Connected hold
 * a live control connection, Dormant unloaded quiet and wait for their next frame. Broken are the
 * troubles a host reported in the last day — a CLI it holds broken, a start canary that failed —
 * newest first, each with the moment the relay saw it. Modify are the chats whose host runs its CLI
 * in modify mode, with the moment the relay first saw it so, which is what lets teamBase tell a chat
 * it believes read-only from one whose host disagrees for longer than a switch takes.
 */
export interface HealthHosts {
	connected: number /* int */;
	dormant: number /* int */;
	broken?: HealthBroken[];
	brokenCount?: number /* int */;
	modify?: HealthChatSince[];
	modifyCount?: number /* int */;
	/**
	 * OldestBuild is the oldest build a connected host reported, when it is not the worker's own.
	 */
	oldestBuild?: string;
}
/**
 * HealthBroken is one trouble of one chat's host: Code is the CLI's broken code (launch,
 * launch_config, crash_loop, mode_drift, no_state_events, canary_<field>, …) or the start canary's
 * failed field.
 */
export interface HealthBroken {
	key?: string;
	code: string;
	at: number /* int64 */;
}
/**
 * HealthChatSince is one chat and since when the relay has seen it so.
 */
export interface HealthChatSince {
	key: string;
	since: number /* int64 */;
}
/**
 * HealthCLIPin is cli.toml and the Claude Code this worker build's release runs: the pinned Claude
 * Code version and when it was flipped to, whether the root helper's hourly check found the binary as
 * the pin describes it (nil until it could look), the version a drill is trying, whether the pin names
 * its drill report, and Release, aichatapi.ReleaseCLI's version of the worker's build — the version
 * the worker's update moves the pin to, which a doctor holds the pin to (a worker may lag the server,
 * so the server reads the worker's word rather than its own). Launch and Models are what the model
 * menu is drawn from (models.go): launch.toml's own list, and the rows the pinned Claude Code lists —
 * as a chat's Claude Code of that version last listed them, else as the pin's record gate listed them
 * when it drilled the pin. The relay bounds them at the source (MaxMachineModels rows and launch words,
 * each at most MaxModelBytes), so Bound never cuts them.
 */
export interface HealthCLIPin {
	pin?: string;
	pinShaOk?: boolean;
	flippedAt?: number /* int64 */;
	candidate?: string;
	drilled?: boolean;
	release?: string;
	/**
	 * Launch is launch.toml's [cli] models when it names any: the only words a start may ask for.
	 */
	launch?: string[];
	/**
	 * Models are the rows the pinned Claude Code lists: what a chat's Claude Code of the pinned version
	 * last listed, as the relay saw them pass since it started, or else the rows the pin's record gate
	 * wrote into its drill report; none before either, and none while launch.toml cannot be read.
	 */
	models?: CLIModel[];
}
/**
 * HealthUnits are the policy files' sha checks: the machine-wide Claude settings and the AI chats'
 * CLI settings against the digests the installer recorded when it placed them.
 */
export interface HealthUnits {
	managedShaOk?: boolean;
	settingsShaOk?: boolean;
}
/**
 * HealthPermits is the session host's build permit, a semaphore of machine.toml's max_builds that a
 * check of teamBase itself takes: its size, the permits held, the checks waiting.
 */
export interface HealthPermits {
	max: number /* int */;
	held: number /* int */;
	queued: number /* int */;
}
/**
 * HealthProv is whether the root helper answered its status: At is the answer the rest of the picture
 * was read from, Error why the last ask failed. Starting says the relay started moments ago: the
 * root helper — socket-activated, often restarted beside it — may not have answered since, or may
 * have answered as the build that was stopping. A doctor then warns, rather than fails, for a root
 * helper that has not answered, and does not compare the builds yet.
 */
export interface HealthProv {
	ok: boolean;
	at?: number /* int64 */;
	error?: string;
	starting?: boolean;
}
/**
 * HealthWalls are the network's walls and the separation's counters over the last day (S07 §2).
 * Table says the bridge's firewall table (inet teambase_aichat) is loaded, Bridge that the chat
 * profile's card on the containers' bridge carries its filters: without either no container starts.
 * The counters are the starts the launcher's configuration check refused, by code; what the hosts'
 * guard denied and what they could not validate; and the switch checks that undid a read chat's
 * stray changes (a route the guard does not parse, which is harmless and worth knowing).
 */
export interface HealthWalls {
	table: boolean;
	bridge: boolean;
	launchRefused24h?: { [key: string]: number /* int */};
	guardDenials24h?: number /* int */;
	validateFailures24h?: number /* int */;
	straysDiscarded24h?: number /* int */;
}
/**
 * AuthHealthPicture is the aichat.auth picture: the login broker's newest aichat.login picture as the relay
 * saw it pass, and when; Login is nil until the broker sent one since the relay started. LoginsCount
 * is the number of logins the broker listed, which Bound keeps when it cuts the list.
 */
export interface AuthHealthPicture {
	v: number /* int */;
	at?: number /* int64 */;
	login?: LoginPicture;
	loginsCount?: number /* int */;
}
/**
 * HealthFileName is the file the worker's relay leaves in its runtime directory, beside its status
 * file: both pictures as it last built them, which the machine's own doctor reads rather than ask a
 * running process.
 */
export const HealthFileName = "aichat-health.json";
/**
 * HealthFile is that file: when the relay last wrote it, and each picture as it last built it.
 */
export interface HealthFile {
	at: number /* int64 */;
	chat?: ChatHealth;
	auth?: AuthHealthPicture;
}
/**
 * The broken codes of a host (aichat.cli's code while its state is broken, and the start canary's
 * field) that mean the machine, not the CLI, refused: the launcher's account checks (BrokenLaunch,
 * in host.go) and its configuration checks. The canary codes share a prefix.
 */
export const BrokenLaunchConfig = "launch_config";
/**
 * The broken codes of a host (aichat.cli's code while its state is broken, and the start canary's
 * field) that mean the machine, not the CLI, refused: the launcher's account checks (BrokenLaunch,
 * in host.go) and its configuration checks. The canary codes share a prefix.
 */
export const BrokenCrashLoop = "crash_loop";
/**
 * The broken codes of a host (aichat.cli's code while its state is broken, and the start canary's
 * field) that mean the machine, not the CLI, refused: the launcher's account checks (BrokenLaunch,
 * in host.go) and its configuration checks. The canary codes share a prefix.
 */
export const BrokenCanaryPrefix = "canary_";

//////////
// source: host.go

/**
 * SessionOpen is the payload a chat's work session opens with (`sess.open.open`): enough for a host
 * to take the chat up from nothing — its mode, whether teamBase holds items of an earlier Claude
 * session of it (History: a host whose journal starts here must count past them), the Claude session
 * to start or resume, the session pack teamBase holds for it, and the settings of its next turn.
 */
export interface SessionOpen {
	chatKey: string;
	chatMode: ChatMode;
	history?: boolean;
	session: SessionStart;
	/**
	 * PackAt and PackBytes name the session pack teamBase holds for this session (0 when none). The
	 * host ships its next hourly pack only when this one is older than six hours or the new one is a
	 * quarter larger, so replaced packs do not pile up in teamBase's backed-up store; the host's own
	 * memory of its last pack does not survive a new container, teamBase's record does.
	 */
	packAt?: number /* int64 */;
	packBytes?: number /* int64 */;
	model: string;
	effort?: string;
	permissionMode: PermissionMode;
	timers: HostTimers;
}
/**
 * SessionStart names the Claude session a host runs: teamBase mints every uuid, and Start says
 * whether the CLI begins it (`--session-id`) or resumes it (`--resume`).
 */
export interface SessionStart {
	uuid: string;
	start: string;
}
/**
 * The two ways a Claude session starts.
 */
export const SessionNew = "new";
/**
 * The two ways a Claude session starts.
 */
export const SessionResume = "resume";
/**
 * HostTimers are the module's timers the host enforces, in milliseconds; the host clamps them by
 * its own launch.toml.
 */
export interface HostTimers {
	cliIdleStopMs: number /* int64 */;
	cardKeepaliveMs: number /* int64 */;
}
/**
 * The kinds of a delivery (the turn's kind, TurnKinds): a person's prompts, a text teamBase renders
 * for a door somebody pressed, or a slash command the CLI runs itself.
 */
export const TurnPrompt = "prompt";
/**
 * The kinds of a delivery (the turn's kind, TurnKinds): a person's prompts, a text teamBase renders
 * for a door somebody pressed, or a slash command the CLI runs itself.
 */
export const TurnTemplate = "template";
/**
 * The kinds of a delivery (the turn's kind, TurnKinds): a person's prompts, a text teamBase renders
 * for a door somebody pressed, or a slash command the CLI runs itself.
 */
export const TurnCommand = "command";
/**
 * The kinds of a delivery (the turn's kind, TurnKinds): a person's prompts, a text teamBase renders
 * for a door somebody pressed, or a slash command the CLI runs itself.
 */
export const TurnAuto = "auto";
/**
 * DeliverCommand is `aichat.deliver`: one turn. UUID is the CLI message's uuid — the head prompt's —
 * and UUIDs every prompt the message carries, in order; Preambles are teamBase's notes, rendered, and
 * Bodies the messages themselves, which the host joins behind them with a blank line each. The
 * credential is not here: the broker adds the turn's login to every request of a granted turn.
 */
export interface DeliverCommand {
	turnId: string;
	kind: string;
	uuid: string;
	uuids: string[];
	askerUserId: number /* int64 */;
	auth: string;
	preambles?: string[];
	bodies: string[];
	files?: DeliverFile[];
	planFirst?: boolean;
}
/**
 * DeliverFile is an attachment a delivery carries, fetched as a blob of class upload. Its Name is the
 * file's name in the chat's uploads folder: unique in the chat, and of UploadNamePattern's shape.
 */
export interface DeliverFile {
	name: string;
	sha256: string;
	mediaType?: string;
}
/**
 * The credential kinds a request runs on: a member's Claude token through the login broker (the
 * token a plan subscription gives), or the chat's own Claude login that a member signed in to in the
 * chat's terminal, which every request of the chat then runs on, directly, until it is signed out.
 */
export const AuthOAuth = "oauth";
/**
 * The credential kinds a request runs on: a member's Claude token through the login broker (the
 * token a plan subscription gives), or the chat's own Claude login that a member signed in to in the
 * chat's terminal, which every request of the chat then runs on, directly, until it is signed out.
 */
export const AuthNative = "native";
/**
 * SteerCommand is `aichat.steer`: a message into the running turn, which the CLI reads next.
 */
export interface SteerCommand {
	turnId: string;
	uuid: string;
	body: string;
}
/**
 * WithdrawCommand is `aichat.withdraw`: take back a delivery the CLI has not started.
 */
export interface WithdrawCommand {
	uuid: string;
}
/**
 * InterruptCommand is `aichat.interrupt`: stop the running turn — its background tasks too when All.
 * Reason is the refusal behind a cause refused or cutoff: what the turn's asker or the chat may not
 * spend.
 */
export interface InterruptCommand {
	turnId: string;
	all: boolean;
	cause: string;
	reason?: string;
}
/**
 * The causes of an interrupt: a person's Stop, a full disk, a turn typed in the terminal that its
 * typist may not run (refused), and an admin's cut-off of a turn on the chat's own login, which the
 * login broker cannot refuse (cutoff).
 */
export const InterruptStop = "stop";
/**
 * The causes of an interrupt: a person's Stop, a full disk, a turn typed in the terminal that its
 * typist may not run (refused), and an admin's cut-off of a turn on the chat's own login, which the
 * login broker cannot refuse (cutoff).
 */
export const InterruptDiskFull = "disk_full";
/**
 * The causes of an interrupt: a person's Stop, a full disk, a turn typed in the terminal that its
 * typist may not run (refused), and an admin's cut-off of a turn on the chat's own login, which the
 * login broker cannot refuse (cutoff).
 */
export const InterruptRefused = "refused";
/**
 * The causes of an interrupt: a person's Stop, a full disk, a turn typed in the terminal that its
 * typist may not run (refused), and an admin's cut-off of a turn on the chat's own login, which the
 * login broker cannot refuse (cutoff).
 */
export const InterruptCutoff = "cutoff";
/**
 * ControlCommand is `aichat.control`: a setting of the next turn, or an act on the CLI outside one.
 */
export interface ControlCommand {
	op: string;
	value?: string;
	taskId?: string;
	session?: string;
	/**
	 * SHA256 is the stored sha of the digest blob the op digest writes as the CLI's system prompt.
	 */
	sha256?: string;
}
/**
 * The control ops teamBase sends (S05 §2.4).
 */
export const ControlModel = "model";
/**
 * The control ops teamBase sends (S05 §2.4).
 */
export const ControlEffort = "effort";
/**
 * The control ops teamBase sends (S05 §2.4).
 */
export const ControlPermissionMode = "permission_mode";
/**
 * The control ops teamBase sends (S05 §2.4).
 */
export const ControlNewConversation = "new_conversation";
/**
 * The control ops teamBase sends (S05 §2.4).
 */
export const ControlTaskStop = "task_stop";
/**
 * The control ops teamBase sends (S05 §2.4).
 */
export const ControlStopCLI = "stop_cli";
/**
 * The control ops teamBase sends (S05 §2.4).
 */
export const ControlDigest = "digest";
/**
 * The control ops teamBase sends (S05 §2.4).
 */
export const ControlContext = "context";
/**
 * The control ops teamBase sends (S05 §2.4).
 */
export const ControlReset = "reset";
/**
 * ControlDropLogin ends the chat's own Claude login: its value says why (DropReasons).
 */
export const ControlDropLogin = "drop_login";
/**
 * Why the chat's own Claude login is dropped: an owner signed it out from the chat view, or the member
 * who signed it in lost the chat.
 */
export const DropLogout = "logout";
/**
 * Why the chat's own Claude login is dropped: an owner signed it out from the chat view, or the member
 * who signed it in lost the chat.
 */
export const DropDeparted = "departed";
/**
 * EffortDone is the data of a done effort control: the effort now in force, and whether it fell back
 * to the model's default because the model does not offer the one asked for (the CLI would take a
 * bogus effort in silence).
 */
export interface EffortDone {
	effort: string;
	effortReset?: boolean;
}
/**
 * FilesCommand is `aichat.files`: pack the chat's Claude session for teamBase (the answer is the
 * SessionPack teamBase now holds), or unpack the one teamBase holds (SHA256, a blob of class
 * session) before the CLI resumes it in a new container.
 */
export interface FilesCommand {
	op: string;
	sha256?: string;
}
/**
 * The ops of a FilesCommand.
 */
export const FilesPackSession = "pack_session";
/**
 * The ops of a FilesCommand.
 */
export const FilesUnpackSession = "unpack_session";
/**
 * ForgetCommand is `aichat.forget`: a purge. The host drops the items of these srcs from the frames
 * teamBase has committed and from its journal, so nothing of them outlives the purge on the worker
 * machine.
 */
export interface ForgetCommand {
	srcs: string[];
}
/**
 * NotesWant is `aichat.notes`: the notes teamBase owes Claude (what changed in the chat since its last
 * turn), rendered, which the host hands to the next turn typed in the terminal as context. A want, so
 * the newest list is sent after every attach and every change; a note leaves it once a turn frame names
 * it paid (TurnFrame.NotesPaid).
 */
export interface NotesWant {
	notes: OwedNote[];
}
/**
 * OwedNote is one note teamBase owes Claude: its id and its text.
 */
export interface OwedNote {
	id: string;
	text: string;
}
/**
 * SessionPack is a pack of the chat's Claude session that teamBase stored, as class session: the
 * hourly pack the host ships on its own, the answer of `aichat.files` pack_session, and a
 * deactivation's pack. Session is the Claude session's uuid, SHA256 the stored blob's sha, Bytes its
 * size, and TurnUUID the newest turn the pack holds — what tells a reactivation whether the resumed
 * session lacks turns teamBase's record holds.
 */
export interface SessionPack {
	session: string;
	sha256: string;
	bytes: number /* int64 */;
	turnUuid: string;
}
/**
 * CmdResult is `aichat.cmd`: how one command ended. Seq is the command's down seq; Data is the
 * command's own done data (a reshape's heads, an adopt's result).
 */
export interface CmdResult {
	seq: number /* int64 */;
	outcome: string;
	reason?: string;
	data?: unknown;
}
/**
 * The outcomes of a command.
 */
export const CmdDone = "done";
/**
 * The outcomes of a command.
 */
export const CmdRefused = "refused";
/**
 * The outcomes of a command.
 */
export const CmdFailed = "failed";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonBusyMachine = "busy_machine";
/**
 * ReasonNftMissing refuses a delivery while the machine's network table is not loaded: without
 * it a chat could reach another chat's ports, so the machine starts nothing (it fails closed).
 */
export const ReasonNftMissing = "nft_missing";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonLimited = "limited";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonLoginRefused = "login_refused";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonLoginNoCredential = "login_no_credential";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonLoginNoGrant = "login_no_grant";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonLoginKindMismatch = "login_kind_mismatch";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonLoginGrantMismatch = "login_grant_mismatch";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonLoginCutoff = "login_cutoff";
/**
 * ReasonLoginUnknown refuses a delivery whose chat names a further login the machine no longer
 * holds (an operator removed it): only the chat's owner can fix it, by choosing another login.
 */
export const ReasonLoginUnknown = "login_unknown";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonDiskFloor = "disk_floor";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonCLIUnsupported = "cli_unsupported";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonBlobMissing = "blob_missing";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonSessionMissing = "session_missing";
/**
 * ReasonCopyMissing fails a delivery whose chat has no copy on the machine any more (its src is
 * gone: a rebuilt home, a lost disk): teamBase lays the copy out again from its record.
 */
export const ReasonCopyMissing = "copy_missing";
/**
 * ReasonEnvBroken refuses a delivery, a check or a platform start while the chat's container is
 * broken: teamBase keeps the head in line until the host's next try or a reset.
 */
export const ReasonEnvBroken = "env_broken";
/**
 * ReasonEnvAbsent refuses a command because the chat has no container: teamBase closes the live
 * session, so the next attach creates one, and lays the copy out on the new session.
 */
export const ReasonEnvAbsent = "env_absent";
/**
 * ReasonEnvLost refuses a command because the running container is not the one the copy was made
 * in (its creation stamp differs): teamBase lays the copy out again on the live session.
 */
export const ReasonEnvLost = "env_lost";
/**
 * ReasonPackFailed fails a deactivation whose session or keep pack could not be made.
 */
export const ReasonPackFailed = "pack_failed";
/**
 * ReasonUploadRefused fails a deactivation whose pack teamBase refused for good, or whose upload
 * kept failing.
 */
export const ReasonUploadRefused = "upload_refused";
/**
 * ReasonServerFull fails a deactivation whose pack did not fit teamBase's budget for kept packs.
 */
export const ReasonServerFull = "server_full";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonAlreadyInTranscript = "already_in_transcript";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonNotRunning = "not_running";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonAlreadyStarted = "already_started";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonCardGone = "card_gone";
/**
 * The reasons a host refuses or fails a delivery, a steer, a withdraw or an answer (S01 §6.8). The
 * login's reasons are the broker's, prefixed where they are not the login's own state.
 */
export const ReasonStale = "stale";
/**
 * ReasonClosing refuses a command sent after the session's close: the host ends the session
 * with the commands up to sess.close's downLast and takes no other.
 */
export const ReasonClosing = "closing";
/**
 * ReasonUnsupported refuses a command type this host does not run.
 */
export const ReasonUnsupported = "unsupported";
/**
 * ReasonBadCommand refuses a command whose data does not decode.
 */
export const ReasonBadCommand = "bad_command";
/**
 * ReasonDiskFull fails a command the chat's disk had no room for.
 */
export const ReasonDiskFull = "disk_full";
/**
 * ReasonUnsaved fails a modifying chat's deactivation while its copy holds work no revision holds:
 * the host sent a capture of it instead, and the container stays until the work is in a revision.
 */
export const ReasonUnsaved = "unsaved";
/**
 * ReasonAnswerTooLarge fails a command whose answer's data would be over the frame's bound; the
 * command ran, and teamBase reads its effects from the frames that followed it.
 */
export const ReasonAnswerTooLarge = "answer_too_large";
/**
 * ReasonSlashText refuses a prompt, template or steer whose text starts with "/" (after white
 * space): the CLI would run it as one of its commands. teamBase escapes a slash it means as text
 * with U+2060; only a command delivery of a row the CLI runs as text may start with one.
 */
export const ReasonSlashText = "slash_text";
/**
 * ReasonCLITurnRunning refuses a delivery while a turn typed in the terminal runs, or while the
 * terminal still works after its turn's record ended: the message waits behind it.
 */
export const ReasonCLITurnRunning = "cli_turn_running";
/**
 * ReasonTurnRunning refuses a driver press that cannot wait for the running turn.
 */
export const ReasonTurnRunning = "turn_running";
/**
 * ReasonDriverPending refuses a second driver press while one waits for the session's quiet point.
 */
export const ReasonDriverPending = "driver_pending";
/**
 * ReasonNoTmux refuses the terminal in a container whose image has no tmux it can run.
 */
export const ReasonNoTmux = "no_tmux";
/**
 * ReasonTerminalUnsupported refuses the terminal under a Claude Code whose transcript this build
 * cannot read (TerminalCLI).
 */
export const ReasonTerminalUnsupported = "terminal_unsupported";
/**
 * ReasonNoSessionStart fails a terminal whose Claude Code never said its session started.
 */
export const ReasonNoSessionStart = "no_session_start";
/**
 * ReasonUpdating refuses the terminal while the worker is being updated.
 */
export const ReasonUpdating = "updating";
/**
 * ReasonInTerminal refuses a control the terminal answers itself (the context: /context there).
 */
export const ReasonInTerminal = "in_terminal";
/**
 * ReasonTurnInTerminal refuses adding to a turn typed in the terminal: it is typed there.
 */
export const ReasonTurnInTerminal = "turn_in_terminal";
/**
 * ReasonAnswerInTerminal refuses an answer to a question or plan Claude asked in the terminal.
 */
export const ReasonAnswerInTerminal = "answer_in_terminal";
/**
 * ReasonNativeLoginGone refuses what needed the chat's own Claude login after it was signed out.
 */
export const ReasonNativeLoginGone = "native_login_gone";
/**
 * ReasonNativeLoginPresent refuses what a chat holding its own Claude login cannot do.
 */
export const ReasonNativeLoginPresent = "native_login_present";
/**
 * AnswerCommand is `aichat.answer`: teamBase's answer to the CLI's question or plan, which the host
 * maps to its permission answer. Answers are a question's labels by the question's text; Message is
 * what the CLI reads with a denial (a revised plan's feedback, a skipped question's note).
 */
export interface AnswerCommand {
	requestId: string;
	decision: string;
	answers?: { [key: string]: string};
	message?: string;
}
/**
 * The decisions of an AnswerCommand.
 */
export const AnswerAllow = "allow";
/**
 * The decisions of an AnswerCommand.
 */
export const AnswerDeny = "deny";
/**
 * CardFrame is `aichat.card`: the host's word on the CLI's request a question or plan card stands
 * for, keyed by the card's tool use. The card's content is its item; the frame can arrive before the
 * item's own put says the same.
 */
export interface CardFrame {
	requestId: string;
	state: string;
	cardKind: CardType;
	turnId?: string;
	toolUseId: string;
	agentId?: string;
}
/**
 * The states of a CardFrame: the CLI asks, it withdrew the ask, or the host's keepalive answered it
 * because nobody did.
 */
export const CardFrameOpen = "open";
/**
 * The states of a CardFrame: the CLI asks, it withdrew the ask, or the host's keepalive answered it
 * because nobody did.
 */
export const CardFrameCancelled = "cancelled";
/**
 * The states of a CardFrame: the CLI asks, it withdrew the ask, or the host's keepalive answered it
 * because nobody did.
 */
export const CardFrameExpired = "expired";
/**
 * TurnFrame is `aichat.turn`: a turn began running (State running) or ended. A delivered turn names
 * its TurnID and echoes the asker and the texts it was handed, so a teamBase restored from an older
 * backup rebuilds the turn and its prompts; a turn the CLI began by itself (Cause auto) has no
 * delivery behind it, and a turn typed in the terminal (Cause cli) is named by Claude Code's own
 * prompt id. An ended turn says how, which of its messages never started, the capture that
 * precedes it in a modifying chat, and what it cost the login it ran on.
 * Driver is the process kind the turn ran in, and Auth the credential it ran on (Auths) — for the
 * chat's own login with the member who signed it in (AuthByUserID). Kind is a typed turn's kind
 * (TurnKinds), Permission the permission mode it began in, and NotesPaid the owed notes it was
 * handed.
 */
export interface TurnFrame {
	turnId: string;
	state: string;
	cause?: string;
	uuids?: string[];
	askerUserId?: number /* int64 */;
	texts?: string[];
	unstarted?: string[];
	outcome?: string;
	reason?: string;
	resetsAt?: number /* int64 */; // epoch seconds
	scope?: string; // a limit's model family, or all
	window?: string; // a limit's window
	cap?: string;
	usageFinal?: unknown;
	windowsBind?: unknown;
	windowsUnbind?: unknown;
	cliVersion?: string;
	launchId?: string;
	/**
	 * Lifecycle is each delivered message's last command_lifecycle state, by uuid.
	 */
	lifecycle?: { [key: string]: string};
	chatMode?: ChatMode;
	driver?: Driver;
	auth?: string;
	authByUserId?: number /* int64 */;
	promptId?: string;
	kind?: string;
	permission?: PermissionMode;
	notesPaid?: string[];
}
/**
 * The states and causes of a TurnFrame.
 */
export const TurnRunning = "running";
/**
 * The states and causes of a TurnFrame.
 */
export const TurnEnded = "ended";
/**
 * The states and causes of a TurnFrame.
 */
export const TurnCauseDeliver = "deliver";
/**
 * The states and causes of a TurnFrame.
 */
export const TurnCauseAuto = "auto";
/**
 * The states and causes of a TurnFrame.
 */
export const TurnCauseCLI = "cli";
/**
 * TypedFrame is `aichat.typed`: a line a person typed in the terminal, as the session's transcript
 * holds it, masked by the host. As says where it belongs (TypedAs): the prompt of a turn, a line added
 * to the running turn, or a shell command (`!`) and its output, which are shown and are never a turn.
 * By is the typist; ByUnknown says no Enter mark named one, and then nobody is named.
 */
export interface TypedFrame {
	turnId?: string;
	uuid: string;
	text: string;
	as: string;
	by?: number /* int64 */;
	byUnknown?: boolean;
	at: number /* int64 */;
}
/**
 * Where a typed line belongs.
 */
export const TypedPrompt = "prompt";
/**
 * Where a typed line belongs.
 */
export const TypedSteer = "steer";
/**
 * Where a typed line belongs.
 */
export const TypedShell = "shell";
/**
 * The outcomes of a turn (S01 §5.3).
 */
export const OutcomeCompleted = "completed";
/**
 * The outcomes of a turn (S01 §5.3).
 */
export const OutcomeStopped = "stopped";
/**
 * The outcomes of a turn (S01 §5.3).
 */
export const OutcomeInterrupted = "interrupted";
/**
 * The outcomes of a turn (S01 §5.3).
 */
export const OutcomeLimit = "limit";
/**
 * The outcomes of a turn (S01 §5.3).
 */
export const OutcomeLogin = "login";
/**
 * The outcomes of a turn (S01 §5.3).
 */
export const OutcomeTooLong = "too_long";
/**
 * The outcomes of a turn (S01 §5.3).
 */
export const OutcomeCeiling = "ceiling";
/**
 * The outcomes of a turn (S01 §5.3).
 */
export const OutcomeDiskFull = "disk_full";
/**
 * The outcomes of a turn (S01 §5.3).
 */
export const OutcomeFailed = "failed";
/**
 * The outcomes of a turn (S01 §5.3).
 */
export const OutcomeNotStarted = "not_started";
/**
 * CLIFrame is `aichat.cli`: the CLI's own state on every change. teamBase reads the Claude session
 * it runs — a session the CLI minted itself is a reset of the conversation — and its version; the
 * rest is what the status bar and the doctor show of the process: what it was started with, what it
 * offers (its commands and models), how it ended and why the host holds it broken.
 * Kind is the process kind (the worker's CLI kinds: stream or terminal); Native the chat's own Claude
 * login while it holds one (nil: none); RestartDue the restart the terminal owes; SessionEnd why the
 * Claude session ended in the terminal (SessionEnds); Notice a notice the host raised about the
 * session (a second writer, a terminal that left the chat's session); MCPServers the members' MCP
 * servers the process was started with, sorted; every frame of a live process names all of them, so
 * a ready frame without any says the start named none (the server reads them from ready frames
 * only).
 */
export interface CLIFrame {
	state: string;
	chatMode?: ChatMode;
	launchId?: string;
	cliVersion?: string;
	sessionUuid?: string;
	mintedBy?: string;
	model?: string;
	effort?: string;
	permissionMode?: PermissionMode;
	digestSha256?: string;
	capabilities?: string[];
	commands?: CLICommand[];
	models?: CLIModel[];
	notes?: string[];
	exit?: CLIExit;
	code?: string;
	since?: number /* int64 */;
	/**
	 * SessionPack is set on the frame after the host stored a pack of the session (the hourly pack):
	 * teamBase records it as the session's newest.
	 */
	sessionPack?: SessionPack;
	kind?: string;
	native?: NativeLogin;
	restartDue?: string;
	sessionEnd?: string;
	notice?: NoticeCode;
	mcpServers?: string[];
	/**
	 * TerminalModel is set on the frame of a /model typed in the terminal (AD20, PostModelSwitch): the
	 * chat's model follows it, so the terminal's next start and a chat-view turn after a hand-over run
	 * on the model the person chose there.
	 */
	terminalModel?: TerminalModel;
}
/**
 * TerminalModel is a /model typed in the terminal: the model id Claude Code runs from its next
 * request on, and the owner who pressed the Enter that chose it (0: not known).
 */
export interface TerminalModel {
	model: string;
	by?: number /* int64 */;
}
/**
 * NativeLogin is the chat's own Claude login as Claude Code reports it: the account, the member who
 * signed it in, since when, and, on the frame that reports it gone after a failed request, why
 * (Ended). teamBase never reads the login itself.
 */
export interface NativeLogin {
	account: string;
	byUserId: number /* int64 */;
	since: number /* int64 */;
	ended?: string;
}
/**
 * NativeExpired is NativeLogin.Ended for a login Anthropic no longer takes.
 */
export const NativeExpired = "expired";
/**
 * Why a Claude session ended in the terminal: somebody started a new conversation there (/clear), or
 * branched it (/branch).
 */
export const SessionEndCLIReset = "cli_reset";
/**
 * Why a Claude session ended in the terminal: somebody started a new conversation there (/clear), or
 * branched it (/branch).
 */
export const SessionEndFork = "fork";
/**
 * The bounds of CLIFrame.MCPServers: how many servers it names, and how long each name may be.
 */
export const MCPServersMax = 32;
/**
 * The bounds of CLIFrame.MCPServers: how many servers it names, and how long each name may be.
 */
export const MCPServerNameMax = 64;
/**
 * The states of a CLIFrame.
 */
export const CLINone = "none";
/**
 * The states of a CLIFrame.
 */
export const CLISpawning = "spawning";
/**
 * The states of a CLIFrame.
 */
export const CLIReady = "ready";
/**
 * The states of a CLIFrame.
 */
export const CLIBusy = "busy";
/**
 * The states of a CLIFrame.
 */
export const CLIStopping = "stopping";
/**
 * The states of a CLIFrame.
 */
export const CLIBroken = "broken";
/**
 * BrokenLaunch holds a chat's CLI broken because the launcher refused the start (one of its checks)
 * or never dialled back: the container, its home or the host is wrong, a retry would fail again, and
 * an admin looks (runbook). The other broken codes are in health.go beside the doctor's reading of
 * them.
 */
export const BrokenLaunch = "launch";
/**
 * CLICommand is one command the CLI's initialize lists, its builtin ones left out.
 */
export interface CLICommand {
	name: string;
	description?: string;
}
/**
 * CLIModel is one model the CLI's list_models offers: its value (what --model and a chat take), the
 * model id it resolves to, the CLI's name for it, whether it runs auto mode, whether the CLI lists it
 * without letting it be chosen (the login cannot select it), and its effort levels. models.go says
 * which rows teamBase offers.
 */
export interface CLIModel {
	value: string;
	resolved?: string;
	displayName?: string;
	autoMode?: boolean;
	disabled?: boolean;
	effortLevels?: string[];
}
/**
 * CLIExit is how the last CLI process ended.
 */
export interface CLIExit {
	code: number /* int */;
	signal?: number /* int */;
}
/**
 * Who minted the Claude session a CLI runs.
 */
export const MintedByTeamBase = "teambase";
/**
 * Who minted the Claude session a CLI runs.
 */
export const MintedByCLI = "cli";
/**
 * HostPicture is `aichat.host`, the session host's picture of one chat, sent every half minute and
 * whenever its run, its mode, its driver, its terminal, its container's state, step or place in line,
 * its additional container or its full disk changes. teamBase reads a chat's run from it — whether
 * the CLI is busy outside a turn (a background task keeps it from being idle), the mode the host runs
 * it in and which process holds the session — and the container's state, from which it derives the
 * word people see. The rest is the doctor's and the
 * admin's: the CLI's process, the outbox's backlog, the disk, the guard's counters and the calls of
 * teamBase's tool sets the host relayed.
 */
export interface HostPicture {
	run: string;
	chatMode?: ChatMode;
	since?: number /* int64 */;
	tasks?: number /* int */;
	/**
	 * Driver is the kind of the process that holds the chat's session (driver.go); Waits says Claude
	 * Code waits for a person in the terminal (HostWaits); Terminal is the terminal while one runs or
	 * lately ended.
	 */
	driver?: Driver;
	waits?: string;
	terminal?: TerminalState;
	/**
	 * LoginAlert names the trouble the running turn met with its login (the first 401 of a turn).
	 */
	loginAlert?: HostAlert;
	cli: HostCLI;
	outbox: HostOutbox;
	diskFree: number /* int64 */;
	reserveOk: boolean;
	canary?: HostCanary;
	/**
	 * GuardDenials24h and ValidateFailures24h count the PreToolUse guard's denials and the items
	 * the host could not validate, over the last day.
	 */
	guardDenials24h?: number /* int */;
	validateFailures24h?: number /* int */;
	/**
	 * MCPTeamBaseDown24h and MCPUnexpected24h count the start canary's MCP warnings over the last day:
	 * teamBase's own MCP server absent or not connected, and a server the start did not name.
	 */
	mcpTeamBaseDown24h?: number /* int */;
	mcpUnexpected24h?: number /* int */;
	/**
	 * Env is the chat's container, Extra its additional container.
	 */
	env: HostEnv;
	extra: HostExtra;
	/**
	 * SetCalls counts the calls of teamBase's tool sets the host relayed; nil before the first.
	 */
	setCalls?: HostSetCalls;
}
/**
 * HostSetCalls are the calls of teamBase's tool sets (`tb-chat <set> …`) the host relayed for the
 * chat since it started: counters only, never a word of a call or of its answer. Each call ends in one
 * outcome — answered by teamBase; or answered by the host itself: busy (teamBase could not be asked),
 * no turn, past the turn's calls, unknown (no answer came in time), or a request no front end of this
 * release sends. Ms is the time teamBase took over the answered calls together, FileBytes the bytes
 * of the files that crossed either way. Hour and HourUnknown count the calls sent to teamBase over the
 * last hour and those of them that no answer came for, which the worker's doctor row aichat_tools
 * weighs.
 */
export interface HostSetCalls {
	answered?: number /* int */;
	busy?: number /* int */;
	noTurn?: number /* int */;
	turnCalls?: number /* int */;
	unknown?: number /* int */;
	badRequest?: number /* int */;
	ms?: number /* int64 */;
	fileBytes?: number /* int64 */;
	hour?: number /* int */;
	hourUnknown?: number /* int */;
}
/**
 * HostEnv is the chat's container as the host sees it: its state (ContainerStates) and since when;
 * its creation stamp (user.teambase.created, unix ns), which tells a container the copy was made in
 * from a new one; its disk use and quota, and whether the full-quota way out is in force; the image it
 * was made from (chat-<yyyymmdd-hhmm>); the step running now while it is created, laid out, unpacked
 * or saved (EnvSteps) and since when; and its place in the host's start line (1-based, 0 when not in
 * line) with the reason it waits (LineWhys).
 */
export interface HostEnv {
	state: string;
	since: number /* int64 */;
	created?: number /* int64 */;
	diskUsed?: number /* int64 */;
	diskQuota?: number /* int64 */;
	diskFull?: boolean;
	image?: string;
	step?: string;
	stepSince?: number /* int64 */;
	line?: number /* int */;
	lineWhy?: string;
}
/**
 * HostExtra is the chat's additional container: its state (ExtraStates) and since when.
 */
export interface HostExtra {
	state: string;
	since?: number /* int64 */;
}
/**
 * The run words of a HostPicture: the live picture's (LiveRun), and the two only the host knows —
 * no CLI process at all, and one the host holds broken until a person resets it.
 */
export const HostRunNone = "none";
/**
 * The run words of a HostPicture: the live picture's (LiveRun), and the two only the host knows —
 * no CLI process at all, and one the host holds broken until a person resets it.
 */
export const HostRunBroken = "broken";
/**
 * HostAlert is a code the host raises about the running turn's login.
 */
export interface HostAlert {
	code: string;
}
/**
 * HostCLI is the CLI process as the host sees it.
 */
export interface HostCLI {
	rss?: number /* int64 */;
	oomKills?: number /* int */;
	restarts10m?: number /* int */;
	launchAgeS?: number /* int64 */;
}
/**
 * HostOutbox is the outbox's backlog: frames written and not yet committed by teamBase, their bytes,
 * the age of the oldest, and whether the host has stopped reading the CLI because of it (Full).
 */
export interface HostOutbox {
	unacked: number /* int64 */;
	bytes: number /* int64 */;
	oldestS?: number /* int64 */;
	full?: boolean;
}
/**
 * HostCanary is the start canary's last verdict: when it last passed, and the field that failed.
 */
export interface HostCanary {
	okAt?: number /* int64 */;
	code?: string;
}

//////////
// source: hosttexts.go

/**
 * AichatDirName is teamBase's directory in the chat's working directory, beside the repositories
 * and inside none of them: the capture never takes it, the gate refuses a path through it, and the
 * CLI's plans land in it.
 */
export const AichatDirName = ".aichat";
/**
 * The two directories under AichatDirName in a chat's container: the owners' uploads, which the host
 * writes and the AI system only reads, and the keep folder, the one place a deactivation keeps.
 */
export const KeepDirName = "keep";
/**
 * The two directories under AichatDirName in a chat's container: the owners' uploads, which the host
 * writes and the AI system only reads, and the keep folder, the one place a deactivation keeps.
 */
export const UploadsDirName = "uploads";
/**
 * PlansDir is Claude Code's plansDirectory, relative to src: inside keep, so a plan outlives a
 * deactivation.
 */
export const PlansDir = AichatDirName + "/" + KeepDirName + "/plans";
/**
 * KeepLimitBytes is the keep folder's strict limit: the files' bytes, before compression, that a
 * deactivation takes. KeepSoftBytes is the goal the AI system is told.
 */
export const KeepLimitBytes = 1 << 30;
/**
 * The two directories under AichatDirName in a chat's container: the owners' uploads, which the host
 * writes and the AI system only reads, and the keep folder, the one place a deactivation keeps.
 */
export const KeepSoftBytes = 100 << 20;
/**
 * AichatDir is one directory under AichatDirName.
 */
export interface AichatDir {
	name: string;
	/**
	 * Writable says Claude may write there, in both switch states: the guard lets a write through
	 * only inside such a directory, and everything else under AichatDirName is the host's.
	 */
	writable: boolean;
}
/**
 * ToolAnswerSeconds bounds every call of teamBase's tools the host answers: a start or stop still running is
 * answered by then and goes on by itself. It stays under Claude Code's default Bash timeout of two
 * minutes, so a call is never killed before its answer. The worker's host keeps its own copy
 * (wire.ToolAnswerWithin, a test of the worker's wire holds the two equal); the rules tell Claude
 * this number.
 */
export const ToolAnswerSeconds = 90;
/**
 * DenyCode names the host's answer to a CLI request it refuses outright — a permission ask no
 * owner is shown, or a question card that outlived its keepalive. Guard codes are the host's own
 * rules; these are the CLI asking and the host saying no.
 */
export type DenyCode = string;
/**
 * DenyProtected answers the CLI's safety check: a protected path it wants approved.
 */
export const DenyProtected: DenyCode = "guard.protected";
/**
 * DenyClassifierStop answers the fallback ask the CLI makes after several classifier denials
 * in a row. No owner card: an allow from the host would not reset the CLI's count.
 */
export const DenyClassifierStop: DenyCode = "guard.classifier_stop";
/**
 * DenyNotAllowed answers any other permission ask.
 */
export const DenyNotAllowed: DenyCode = "guard.not_allowed";
/**
 * DenyCardExpired answers a question card nobody answered within the host's keepalive, which
 * is reached only while teamBase's own watchdog is off.
 */
export const DenyCardExpired: DenyCode = "card_expired";
/**
 * MaxHostText bounds every text here, in characters: the host answers inside a hook or a tool
 * result, where a long reason would crowd out what Claude was doing.
 */
export const MaxHostText = 400;

//////////
// source: item.go

/**
 * ItemVersion is the envelope's version, `v`.
 */
export const ItemVersion = 1;
/**
 * Item is one row of a chat's transcript, as a whole-state put: a change is the whole item again
 * with a higher Rev. teamBase stores it by (chat, Src): the first put allocates the item's seq, a
 * later put replaces the row only if its Rev is higher and the row is not yet closed, and anything
 * else is acknowledged and ignored — so a host that replays its journal after a restart can never
 * move an item backwards.
 */
export interface Item {
	v: number /* int */;
	src: string;
	/**
	 * Rev rises with every put of the item. A host item's rev is the journal seq of the line that
	 * caused the put; teamBase's own items count 1, 2, ….
	 */
	rev: number /* int64 */;
	kind: Kind;
	/**
	 * State is one of the kind's states (a card's by its type).
	 */
	state: string;
	/**
	 * Closed is set on the item's last put; nothing changes it afterwards.
	 */
	closed?: boolean;
	scope: Scope;
	/**
	 * Parent is the src of the agent or workflow an item belongs to.
	 */
	parent?: string;
	/**
	 * Turn is the turn's ref: the uuid of the message that started it, or the followup's src.
	 */
	turn?: string;
	at: number /* int64 */;
	/**
	 * CLI is the frame an item came from (`assistant/tool_use`, …), kept so the item can be
	 * projected again by a newer reducer.
	 */
	cli?: string;
	body?: string;
	data?: unknown;
	blobs?: BlobRef[];
	/**
	 * Author is the person who wrote a teamBase item; teamBase sets it, never the host.
	 */
	author?: string;
}
/**
 * BlobRef names a blob an item carries: a whole tool output, an agent's steps, or the JSON of an
 * item teamBase could not validate.
 */
export interface BlobRef {
	role: string;
	sha256: string;
	bytes: number /* int64 */;
}

//////////
// source: kinds.go

/**
 * Kind names what an item is. Every item has exactly one writer: the session host on the worker
 * machine (its reducer turns Claude Code's output into items), or teamBase (people's messages, the
 * answers to cards, the shared acts). Nothing else writes an item, and no item names the Claude
 * login that paid for it — the module has one (S01 §8).
 */
export type Kind = string;
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindProse: Kind = "prose";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindThinking: Kind = "thinking";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindTool: Kind = "tool";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindDenial: Kind = "denial";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindAgent: Kind = "agent";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindWorkflow: Kind = "workflow";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindWfAgent: Kind = "wfagent";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindTask: Kind = "task";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindTodo: Kind = "todo";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindCard: Kind = "card";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindCompact: Kind = "compact";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindReset: Kind = "reset";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindFollowup: Kind = "followup";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindTurnEnd: Kind = "turn_end";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindError: Kind = "error";
/**
 * The kinds the host writes, all sixteen from its reducer.
 */
export const KindUnknown: Kind = "unknown";
/**
 * The kinds teamBase writes itself.
 */
export const KindTurn: Kind = "turn";
/**
 * The kinds teamBase writes itself.
 */
export const KindPrompt: Kind = "prompt";
/**
 * The kinds teamBase writes itself.
 */
export const KindSteer: Kind = "steer";
/**
 * The kinds teamBase writes itself.
 */
export const KindNote: Kind = "note";
/**
 * The kinds teamBase writes itself.
 */
export const KindAnswer: Kind = "answer";
/**
 * The kinds teamBase writes itself.
 */
export const KindCommand: Kind = "command";
/**
 * The kinds teamBase writes itself.
 */
export const KindNotice: Kind = "notice";
/**
 * The kinds teamBase writes itself.
 */
export const KindEvent: Kind = "event";
/**
 * The kinds teamBase writes itself.
 */
export const KindRevision: Kind = "revision";
/**
 * The kinds teamBase writes itself.
 */
export const KindBase: Kind = "base";
/**
 * The kinds teamBase writes itself.
 */
export const KindLanding: Kind = "landing";
/**
 * The kinds teamBase writes itself.
 */
export const KindCall: Kind = "call";
/**
 * Writer is the one side that may put an item of a kind.
 */
export type Writer = string;
export const WriterHost: Writer = "host";
export const WriterTeamBase: Writer = "teambase";
/**
 * Scope says where an item is drawn. Main items are the transcript. A workflow agent is a row inside
 * its workflow's panel and has no event of its own. A step is one call inside a subagent or a
 * workflow agent: it exists only inside that agent's steps blob, never as a row (steps.go).
 */
export type Scope = string;
export const ScopeMain: Scope = "main";
export const ScopeWorkflow: Scope = "workflow";
export const ScopeSteps: Scope = "steps";
/**
 * Evented says when an item gets a durable event on insert and on change (S03 §3's rule): always,
 * never (a working chat's prose and tools reach the browser through the live picture and the item
 * fetch instead), or — for a notice — only when its code is one the Summary density shows.
 */
export type Evented = string;
export const EventedNo: Evented = "no";
export const EventedYes: Evented = "yes";
export const EventedSummary: Evented = "summary";
/**
 * Countable says whether an item moves a chat's unread dot: always, never, by the notice's code, or
 * by the event's kind. Countable is a subset of Evented, so every change of the dot arrives as an
 * event (TestCountableIsEvented).
 */
export type Countable = string;
export const CountableNo: Countable = "no";
export const CountableYes: Countable = "yes";
export const CountableByCode: Countable = "by_code";
export const CountableByEvent: Countable = "by_event";
/**
 * State words. A final kind has one state, done: it is complete at its first put.
 */
export const StateDone = "done";
/**
 * KindSpec is one row of the item catalogue.
 */
export interface KindSpec {
	kind: Kind;
	writer: Writer;
	/**
	 * Prefix is the src prefix every item of the kind carries (S06 §2's scheme): "t:" + a tool use
	 * id for a tool, "tb:" + a uuid for everything teamBase writes.
	 */
	prefix: string;
	/**
	 * Scopes are the scopes an item of the kind may have.
	 */
	scopes: Scope[];
	/**
	 * States are the item's states in the order they are reached; Terminal those after which the
	 * state never changes again (later puts may still add data). A card's states depend on its
	 * type and are CardStates'.
	 */
	states: string[];
	terminal: string[];
	/**
	 * Body is true for the kinds whose text is markdown in the envelope's body.
	 */
	body: boolean;
	evented: Evented;
	countable: Countable;
}
/**
 * CardType is what a card asks of the owners.
 */
export type CardType = string;
/**
 * CardQuestion is Claude's AskUserQuestion: up to four questions, each with options.
 */
export const CardQuestion: CardType = "question";
/**
 * CardPlan is Claude's ExitPlanMode in a plan-first turn: start the plan, or change it.
 */
export const CardPlan: CardType = "plan";
/**
 * CardModify is Claude's request_modify in a read-only chat. It never holds the turn
 * open: the host closes it at the tool's result, and the owners' decision is teamBase's answer
 * item.
 */
export const CardModify: CardType = "modify";

//////////
// source: limits.go

/**
 * Unit says what a limit counts.
 */
export type Unit = string;
/**
 * Bytes counts the UTF-8 bytes of a string, or the JSON encoding of anything else.
 */
export const Bytes: Unit = "bytes";
/**
 * Runes counts Unicode code points: a bound people read in characters.
 */
export const Runes: Unit = "runes";
/**
 * Items counts the elements of a list.
 */
export const Items: Unit = "items";
/**
 * Limit is one named bound.
 */
export interface Limit {
	name: string;
	max: number /* int */;
	unit: Unit;
}
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxSrc = 128;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxBody = 65536;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxData = 65536;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxLabel = 200;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxDetail = 400;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxToolInput = 8192;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxSetCallArgs = 2048;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxPatch = 24576;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxExcerpt = 16384;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const ExcerptHalf = MaxExcerpt / 2;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxPlan = 32768;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxQuestion = 2000;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxQuestions = 4;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxOptions = 6;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxAgentPrompt = 2048;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxActivity = 200;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxAgentResult = 4096;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxErrorText = 1024;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxWorkflowScript = 16384;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxThinking = 16384;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxCompactSummary = 16384;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxUnknownSample = 2048;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxUnknownKeys = 20;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxTail = 4096;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxTaskCommand = 400;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxSummaryLine = 400;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxPreview = 400;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxToolSummary = 120;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxTodoTasks = 50;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxStepsPerAgent = 2000;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxLivePicture = 8192;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxWorkflowFrame = 8192;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxAgentTail = 8192;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxAgentTailRows = 30;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxLiveActivity = 8;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxOpenTail = 4096;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxLiveBlock = 65536;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxFrameLabel = 40;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxFrameLastTool = 60;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxTailExcerpt = 200;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxName = 200;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxShortWord = 64;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxList = 64;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxTaskEvents = 20;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxWorkflowPhases = 64;
/**
 * Item and data bounds (S06 §2). Excerpts keep a head and a tail of ExcerptHalf each, so the start
 * of an output and its end — where the error usually is — both survive.
 */
export const MaxWorkflowAgentRow = 200;
/**
 * MaxPreviewPicture holds every preview's picture at once: PreviewMax of them, each with a 4 KiB
 * tail and a 200-character newest line beside its words, title and numbers (about 5 KiB each).
 */
export const MaxPreviewPicture = 64 << 10;
/**
 * MaxPanelPicture holds every open panel at once: per preview 20 logins of four bounded fields and
 * 10 mails (about 26 KiB each at their bounds; usually a few hundred bytes).
 */
export const MaxPanelPicture = 64 << 10;
/**
 * MaxLoginPicture holds the login broker's picture: every login of a full machine with its plan
 * windows and limit (about 350 bytes each, 64 of them), the connects' and the adoptions' answers
 * and the doctor's facts.
 */
export const MaxLoginPicture = 64 << 10;
/**
 * MaxItemJSON bounds one item's JSON as it travels, envelope and escaping included; the decoded
 * body and data have their own, tighter bounds.
 */
export const MaxItemJSON = 512 << 10;
/**
 * MaxBlobsPerItem bounds the blobs one item names.
 */
export const MaxBlobsPerItem = 8;
/**
 * Workflow thresholds, one set for every reader: the reducer marks a workflow large, the composer
 * and the workflow card warn, and the agent instructions tell Claude the cap. A workflow is large —
 * drawn with its cost up front — above WorkflowLargeAgents agents or WorkflowLargeTokens tokens;
 * the card warns from WorkflowWarnAgents agents with the machine's own estimate; and no run is
 * asked for with more than WorkflowAgentCap agents.
 */
export const WorkflowWarnAgents = 10;
/**
 * Workflow thresholds, one set for every reader: the reducer marks a workflow large, the composer
 * and the workflow card warn, and the agent instructions tell Claude the cap. A workflow is large —
 * drawn with its cost up front — above WorkflowLargeAgents agents or WorkflowLargeTokens tokens;
 * the card warns from WorkflowWarnAgents agents with the machine's own estimate; and no run is
 * asked for with more than WorkflowAgentCap agents.
 */
export const WorkflowLargeAgents = 25;
/**
 * Workflow thresholds, one set for every reader: the reducer marks a workflow large, the composer
 * and the workflow card warn, and the agent instructions tell Claude the cap. A workflow is large —
 * drawn with its cost up front — above WorkflowLargeAgents agents or WorkflowLargeTokens tokens;
 * the card warns from WorkflowWarnAgents agents with the machine's own estimate; and no run is
 * asked for with more than WorkflowAgentCap agents.
 */
export const WorkflowLargeTokens = 1_500_000;
/**
 * Workflow thresholds, one set for every reader: the reducer marks a workflow large, the composer
 * and the workflow card warn, and the agent instructions tell Claude the cap. A workflow is large —
 * drawn with its cost up front — above WorkflowLargeAgents agents or WorkflowLargeTokens tokens;
 * the card warns from WorkflowWarnAgents agents with the machine's own estimate; and no run is
 * asked for with more than WorkflowAgentCap agents.
 */
export const WorkflowAgentCap = 25;

//////////
// source: live.go

/**
 * LiveRun is the live state of a chat's CLI.
 */
export type LiveRun = string;
export const RunStarting: LiveRun = "starting";
export const RunIdle: LiveRun = "idle";
export const RunRunning: LiveRun = "running";
export const RunWaiting: LiveRun = "waiting";
export const RunCompacting: LiveRun = "compacting";
export const RunStopping: LiveRun = "stopping";
export const RunSwitching: LiveRun = "switching"; // the host is between the two CLI units of a mode switch
/**
 * LivePicture is a chat's live state (frame aichat.live), at most MaxLivePicture bytes.
 */
export interface LivePicture {
	v: number /* int */;
	/**
	 * Gen rises with every picture of one CLI process.
	 */
	gen: number /* int64 */;
	/**
	 * UpSeq is the host's last reliable up seq before this picture; teamBase holds the picture
	 * until that frame has committed.
	 */
	upSeq: number /* int64 */;
	/**
	 * AfterSeq is stamped by teamBase: the chat's last item seq when it relayed the picture.
	 */
	afterSeq?: number /* int64 */;
	at: number /* int64 */;
	run: LiveRun;
	turn?: LiveTurn;
	open?: OpenBlock;
	activity?: Activity[];
	more?: number /* int */;
	lastEventAt?: number /* int64 */;
	counts: LiveCounts;
	meters: Meters;
	model?: string;
	effort?: string;
	permissionMode?: PermissionMode;
	/**
	 * ChatMode is the running process's mode; the browser says "Switching…" while it differs from
	 * the chat's.
	 */
	chatMode?: ChatMode;
	caps: Caps;
	todos?: TodoCount;
}
/**
 * LiveTurn is the running turn.
 */
export interface LiveTurn {
	ref: string;
	origin?: string;
	startedAt: number /* int64 */;
}
/**
 * OpenBlock is the block Claude is writing now. Offset and Chars count UTF-16 code units, the
 * browser's string length: the browser keeps the block in a buffer B and joins a picture's tail as
 * B[:Offset] + Tail when Offset ≤ len(B), else as "…" + Tail.
 */
export interface OpenBlock {
	src: string;
	parent?: string;
	kind: string;
	offset: number /* int */;
	tail: string;
	chars: number /* int */;
	label?: string;
	tokens?: number /* int64 */;
}
/**
 * Activity is one thing under way, newest first.
 */
export interface Activity {
	src: string;
	kind: string;
	verb?: Verb;
	label?: string;
	startedAt?: number /* int64 */;
	/**
	 * Checking is set on a call auto mode's classifier has been judging for over 1.5 s.
	 */
	checking?: boolean;
	detail?: string;
	usage?: Usage;
}
/**
 * LiveCounts count this turn's calls so far.
 */
export interface LiveCounts {
	tools?: number /* int */;
	failed?: number /* int */;
	denied?: number /* int */;
	readOnly?: number /* int */;
}
/**
 * TodoCount is the running turn's task list, as a chip.
 */
export interface TodoCount {
	done: number /* int */;
	total: number /* int */;
	current?: string;
}
/**
 * Meters are the two gauges of the status bar.
 */
export interface Meters {
	context?: ContextMeter;
	plan?: PlanMeter;
}
/**
 * ContextMeter is how full the conversation's context is: Used of Window, with a tick at the
 * auto-compaction Threshold.
 */
export interface ContextMeter {
	used: number /* int64 */;
	window?: number /* int64 */;
	threshold?: number /* int64 */;
	source: string;
}
/**
 * PlanMeter is one Claude login's usage windows: the login a chat's turn runs on.
 */
export interface PlanMeter {
	fiveHour?: UsageWindow;
	sevenDay?: UsageWindow;
	status?: string;
	source: string;
	at: number /* int64 */;
}
/**
 * UsageWindow is one window's use, 0–100, and when it resets (epoch seconds).
 */
export interface UsageWindow {
	pct: number /* int */;
	resetsAt?: number /* int64 */;
}
/**
 * CapValue is what is known of a capability of the running CLI.
 */
export type CapValue = string;
export const CapUnknown: CapValue = "unknown";
export const CapYes: CapValue = "yes";
export const CapNo: CapValue = "no";
export const CapDegraded: CapValue = "degraded"; // the transcript mirror only
/**
 * Caps are the CLI's capabilities, set at init and on first observation and carried across
 * processes. Features gate on these and on the presence of fields, never on a version number.
 */
export interface Caps {
	lifecycle?: CapValue;
	interruptReceipt?: CapValue;
	cancelQueued?: CapValue;
	sessionState?: CapValue;
	mirror?: CapValue;
	workflowProgress?: CapValue;
	unifiedWindows?: CapValue;
	userMessageUuids?: CapValue;
	subagentText?: CapValue;
	todoTools?: CapValue;
	cliVersion?: string;
}
/**
 * WorkflowFrame is a running workflow's agents (frame aichat.workflow), at most MaxWorkflowFrame
 * bytes. Over the bound the agents' last tools go first, then the agents of finished phases fold
 * into Folded.
 */
export interface WorkflowFrame {
	src: string;
	runId?: string;
	state: string;
	phases?: WorkflowPhase[];
	agents?: FrameAgent[];
	folded?: PhaseCounts[];
	usage?: Usage;
}
/**
 * FrameAgent is one workflow agent in a frame.
 */
export interface FrameAgent {
	index: number /* int */;
	label?: string;
	phaseIndex: number /* int */;
	state: string;
	attempt?: number /* int */;
	cached?: boolean;
	tokens?: number /* int64 */;
	toolCalls?: number /* int */;
	durationMs?: number /* int64 */;
	startedAt?: number /* int64 */;
	lastTool?: string;
}
/**
 * PhaseCounts are the agents of one finished phase, folded into their counts.
 */
export interface PhaseCounts {
	phaseIndex: number /* int */;
	agents: AgentCounts;
}
/**
 * AgentTail is the newest steps of one agent a reader follows (frame aichat.agent, R1b), at most
 * MaxAgentTail bytes and MaxAgentTailRows rows. I is the step's line in the agent's steps blob, so
 * the tail joins the blob without a gap.
 */
export interface AgentTail {
	src: string;
	state: string;
	rows: TailRow[];
}
/**
 * TailRow is one step of an agent's tail.
 */
export interface TailRow {
	i: number /* int */;
	kind: Kind;
	verb?: Verb;
	label?: string;
	status?: string;
	startedAt?: number /* int64 */;
	endedAt?: number /* int64 */;
	excerpt?: string;
}
/**
 * SignalKind is something the reducer tells the host to act on; a signal never leaves the worker
 * machine.
 */
export type SignalKind = string;
export const SignalTurnStarted: SignalKind = "turnStarted";
export const SignalPermissionDrift: SignalKind = "permissionDrift";
export const SignalSessionChanged: SignalKind = "sessionChanged";
export const SignalUnknownType: SignalKind = "unknownType";
export const SignalSpilled: SignalKind = "spilled";
export const SignalTaskEnded: SignalKind = "taskEnded";
export const SignalCommandsChanged: SignalKind = "commandsChanged";
/**
 * Signal is one signal. Which fields are set depends on the kind: a turn's Ref and Origin, a
 * spilled or ended task's Src and Path, an unknown frame's CLIType.
 */
export interface Signal {
	kind: SignalKind;
	ref?: string;
	origin?: string;
	src?: string;
	path?: string;
	cliType?: string;
}

//////////
// source: machine.go

/**
 * ChatsRoot holds the chat's home in its container.
 */
export const ChatsRoot = "/srv/ai";
/**
 * CwdName is the home's directory that holds every repository: the CLI's working directory.
 */
export const CwdName = "src";
/**
 * ScratchName is the home's scratch directory: writable in both modes, never captured, gone at a
 * deactivation.
 */
export const ScratchName = "tmp";
/**
 * ConfigName is the CLI's configuration directory (CLAUDE_CONFIG_DIR), with the transcript.
 */
export const ConfigName = ".claude";
/**
 * CacheName is the home's caches: the toolchains' and teamBase's own operations folder.
 */
export const CacheName = ".cache";
/**
 * EduRunName and TeamRunName hold the run data of the two platforms, the education platform's and
 * teamBase's: what each puts beside its repositories while it runs (data, logs, the logins file).
 */
export const EduRunName = "education-platform";
/**
 * The chat's home inside its container, the AI system's own: the copy under src/ (where the CLI
 * starts), the CLI's configuration, scratch, caches and the platforms' run data. The paths name the
 * key, so Claude Code's project folder is the same in every container the chat ever has; texts
 * written for Claude name them relative to the home (HomeRel), so a text is the same for every chat
 * and the prompt cache holds.
 */
export const TeamRunName = "teambase-platform";
/**
 * Strays are the changes the switch check found in a read chat's copy and put back to teamBase's
 * record (S08 verify with discard): per repository the paths with git's status letter, how many
 * there were, whether the branch had moved and an operation was open. They are named, never shown:
 * no file content crosses.
 */
export interface Strays {
	repos: StrayRepo[];
}
/**
 * StrayRepo is one repository's stray changes.
 */
export interface StrayRepo {
	repo: string;
	paths?: StrayPath[];
	total: number /* int */;
	/**
	 * Moved counts the commits the branch had moved by, which the check reset.
	 */
	moved?: number /* int */;
	/**
	 * Op names a git operation the check found open (a merge, a rebase) and aborted.
	 */
	op?: string;
}
/**
 * StrayPath is one stray path and git's status letter for it: M changed, A added (untracked
 * included), D removed, R renamed.
 */
export interface StrayPath {
	path: string;
	status: string;
}
/**
 * MaxStrayPaths bounds the paths one repository's report names.
 */
export const MaxStrayPaths = 200;
/**
 * The moments at which the switch check can find stray changes, as the notice names them. A read
 * chat's strays are discarded once, at the switch to code edits on.
 */
export const StrayMomentSwitch = "switch";

//////////
// source: models.go

/**
 * CLIDefaultRow is list_models' row for the CLI's own recommended model.
 */
export const CLIDefaultRow = "default";
/**
 * The bounds of what a health picture carries of the models (HealthCLIPin): the rows (2.1.282 lists
 * 11) and launch.toml's words, and the bytes of one value or id.
 */
export const MaxMachineModels = 16;
/**
 * The bounds of what a health picture carries of the models (HealthCLIPin): the rows (2.1.282 lists
 * 11) and launch.toml's words, and the bytes of one value or id.
 */
export const MaxModelBytes = 64;
/**
 * The bounds of one model row teamBase keeps: its effort levels, and the bytes of one.
 */
export const MaxRowEfforts = 8;
/**
 * The bounds of one model row teamBase keeps: its effort levels, and the bytes of one.
 */
export const MaxRowEffortBytes = 16;

//////////
// source: modes.go

/**
 * ChatMode is what an AI chat may do to its copy of the code: answer questions about it, or change
 * it. teamBase decides it; the session host learns it from the session's open and from each switch.
 * A read chat is read only by rules, not by a wall: the host's guard refuses Claude's edits and
 * git's writing commands there, and the switch check puts back whatever another route changed
 * before the copy moves or code changes are turned on (S01 §3a).
 * The word "mode" alone never names it in a payload, because the CLI has a permission mode too and
 * both appear in the same status bar: payloads say chatMode and permissionMode.
 */
export type ChatMode = string;
/**
 * ChatRead is the default: the copy is not changed, there are no captures, revisions, checks,
 * review or Publish. Claude may ask for more with the MCP tool request_modify.
 */
export const ChatRead: ChatMode = "read";
/**
 * ChatModify lets Claude change its own copy; what it changes is captured, reviewed and
 * published by people.
 */
export const ChatModify: ChatMode = "modify";
/**
 * ModeSet names the chat modes a command row is offered in.
 */
export type ModeSet = string;
export const ModesRead: ModeSet = "read";
export const ModesModify: ModeSet = "modify";
export const ModesBoth: ModeSet = "both";
/**
 * PermissionMode is the CLI's own permission mode, which teamBase sets per delivery: auto for an
 * ordinary turn, plan for a plan-first one.
 */
export type PermissionMode = string;
export const PermissionAuto: PermissionMode = "auto";
export const PermissionPlan: PermissionMode = "plan";
/**
 * A codebase part is a named set of repositories a chat works on — the education platform, or
 * teamBase itself. Which parts exist, and their repositories, checks and protected paths, are
 * teamBase's configuration ([[modules.aichat.part]]), a grouping of repositories: every chat's
 * container holds every repository, and what crosses the machines is the repositories by their ids.
 */
/**
 * PartIDMaxLen bounds a part id: a lowercase letter, then letters, digits or hyphens.
 */
export const PartIDMaxLen = 24;

//////////
// source: naming.go

/**
 * KeyAlphabet has 31 symbols and none that looks like another: no 0, 1, i, l or o. It holds no
 * hyphen, which is what lets ParseLabel cut a preview's label into its key and its name.
 */
export const KeyAlphabet = "23456789abcdefghjkmnpqrstuvwxyz";
/**
 * KeyLength is the number of symbols in a key: 31^8 ≈ 8.5·10^11 keys.
 */
export const KeyLength = 8;
/**
 * TitleMax bounds a chat's title, in characters: one line, whoever set it.
 */
export const TitleMax = 120;
/**
 * ClaudeTitleMax bounds the title Claude sets with the MCP tool set_title; the host refuses a
 * longer one (bad_title) and teamBase cuts at a word to it again.
 */
export const ClaudeTitleMax = 80;
/**
 * ReasonMax bounds the reason Claude gives with the MCP tool request_modify, in characters.
 */
export const ReasonMax = 500;
/**
 * PreviewName names one of a chat's previews, and is the second half of its host's first label,
 * <key>-<name>. A name is 2 to 12 lowercase letters and digits starting with a letter: never all
 * digits, never a hyphen, so the label cuts at its one hyphen, and never "canary" or "status" as a
 * whole label, since those carry no hyphen. Which names a chat has is data — the defaults its
 * configured parts name, and whatever Claude declares in the chat's previews file — never a list in
 * code. The worker keeps its own copy of the grammar (its wire package imports the standard library
 * alone); internal/arch holds the two patterns equal.
 */
export type PreviewName = string;
/**
 * The grammar of a preview's name, and how many a chat may have.
 */
export const PreviewNameMin = 2;
/**
 * The grammar of a preview's name, and how many a chat may have.
 */
export const PreviewNameMax = 12;
/**
 * PreviewMax bounds a chat's previews: the launcher refuses a ninth at a save, the host takes the
 * first eight a file declares, and teamBase refuses a picture of more.
 */
export const PreviewMax = 8;
/**
 * CanaryLabel is the preview edge's canary label: it holds no hyphen, so it is never a preview's.
 */
export const CanaryLabel = "canary";
/**
 * MaxReturnURI bounds the deep link that travels through teamBase's pages back to a preview.
 */
export const MaxReturnURI = 256;

//////////
// source: preview.go

/**
 * PreviewsFile is the chat's previews file, relative to src: beside keep, never in it, so that keep
 * starts empty; a deactivation carries it as a member of the keep pack of its own. The worker spells
 * the same file from its own names; a test of the worker's wire holds the two equal.
 */
export const PreviewsFile = AichatDirName + "/previews.toml";
/**
 * PreviewKind is what a preview shows: a web page, or a running system.
 */
export type PreviewKind = string;
/**
 * PreviewPage is a folder of the chat's files with an index.html, served by teamBase's router.
 */
export const PreviewPage: PreviewKind = "page";
/**
 * PreviewSystem is a project run by its ./dev.sh contract, in a unit of its own.
 */
export const PreviewSystem: PreviewKind = "system";
/**
 * The off causes of a preview that may not run now: its chat is closed or archived, or it is a
 * running system and its chat cannot change code.
 */
export const PreviewOffLife = "life";
/**
 * The off causes of a preview that may not run now: its chat is closed or archived, or it is a
 * running system and its chat cannot change code.
 */
export const PreviewOffMode = "mode";
/**
 * PreviewTitleMax bounds a preview's title, in characters: one line Claude gives it.
 */
export const PreviewTitleMax = 60;
/**
 * PreviewWant is `aichat.preview.want`, level-triggered: sent whole after every attach and every
 * change. Open and Modify are the chat's life and mode, from which the host derives whether each
 * preview may run (PreviewAllowed), a name Claude just declared included; Defaults are the names the
 * chat's configured parts give it, in part order, which the host seeds the previews file with once;
 * Previews is one row per preview teamBase holds a row of.
 */
export interface PreviewWant {
	open: boolean;
	modify: boolean;
	defaults: PreviewName[];
	previews: PreviewWantRow[];
}
/**
 * PreviewWantRow is one preview's want: whether an owner made it public, and the presses.
 * The four seqs are presses. teamBase draws each press's seq from one counter per chat and preview —
 * a press sets its own column to one above the highest of the three — so the press with the highest
 * seq is the newest. The host keeps, durably, the highest press it carried out per preview, and when
 * a want's highest press is above it, carries out that press alone (an older one is superseded).
 * CutSeq counts apart: above the one carried out, the host asks the gateway to cut the preview's open
 * streams.
 */
export interface PreviewWantRow {
	name: PreviewName;
	public: boolean;
	startSeq: number /* int */;
	stopSeq: number /* int */;
	restartSeq: number /* int */;
	cutSeq: number /* int */;
}
/**
 * PreviewPictures is `aichat.preview`: every declared preview, in the file's order, in one picture.
 * Declared is when the host last read the declaration the names come from (unix ms; 0 before any
 * read, and teamBase then changes no row set). The host keeps the newest picture per frame type and
 * sends it again at a resume, so a frame per preview would keep only the last one's.
 */
export interface PreviewPictures {
	declared: number /* int64 */;
	previews: PreviewPicture[];
}
/**
 * PreviewPicture is one preview as the host sees it inside the chat's container.
 * The declaration's facts: Kind; Title, Claude's one line for it; Folder, a page's folder from the
 * chat's home (src/…), which the owners' public switch names in its confirm; Default, a default name
 * whose own table sets no field (the seed, which draws no card); Logins and Mail, whether its
 * declaration names a sign-in accounts file and a mail folder; and Digest, the host's hash of the
 * chat's own table for the name (16 hex), which moves when Claude changes it and never when the
 * worker's defaults do.
 * The machine's facts: State is starting while the prepare or start command runs (or the start waits
 * for a place on the machine), running when it answers, not_answering when it does not answer after
 * the start ended, stopped, and failed with a Failure word. Line is the newest output line of a
 * command running now, Last the last command that ended, ActivityAt the gateway's newest request to
 * the preview, and Done the presses the host carried out — a press above Done is still on its way.
 */
export interface PreviewPicture {
	name: PreviewName;
	kind: PreviewKind;
	title?: string;
	folder?: string;
	default?: boolean;
	logins?: boolean;
	mail?: boolean;
	digest?: string;
	state: string;
	since: number /* int64 */;
	failure?: string;
	startMs?: number /* int64 */;
	line?: string;
	last?: PreviewLast;
	activityAt?: number /* int64 */;
	done: PreviewDone;
}
/**
 * PreviewLast is the last of a preview's commands that ended: which one, its exit code, how long it
 * ran, when it ended, and the tail of its output, masked.
 */
export interface PreviewLast {
	command: string;
	exit: number /* int */;
	ms: number /* int64 */;
	at: number /* int64 */;
	tail?: string;
}
/**
 * PreviewDone are the seqs of the presses the host carried out, by the want's column.
 */
export interface PreviewDone {
	start: number /* int */;
	stop: number /* int */;
	restart: number /* int */;
	cut: number /* int */;
}
/**
 * The states of a preview as the machine reports them.
 */
export const PreviewStopped = "stopped";
/**
 * The states of a preview as the machine reports them.
 */
export const PreviewStarting = "starting";
/**
 * The states of a preview as the machine reports them.
 */
export const PreviewRunning = "running";
/**
 * The states of a preview as the machine reports them.
 */
export const PreviewNotAnswering = "not_answering";
/**
 * The states of a preview as the machine reports them.
 */
export const PreviewFailed = "failed";
/**
 * The words of a failed preview, also the stored failure code of its row. The worker's runner maps
 * its own codes onto these; no other word reaches the wire.
 */
export const PreviewFailDescriptor = "descriptor"; // the preview's settings are incomplete
/**
 * The words of a failed preview, also the stored failure code of its row. The worker's runner maps
 * its own codes onto these; no other word reaches the wire.
 */
export const PreviewFailPrepare = "prepare"; // the one-time prepare command failed
/**
 * The words of a failed preview, also the stored failure code of its row. The worker's runner maps
 * its own codes onto these; no other word reaches the wire.
 */
export const PreviewFailStart = "start"; // the start command exited non-zero
/**
 * The words of a failed preview, also the stored failure code of its row. The worker's runner maps
 * its own codes onto these; no other word reaches the wire.
 */
export const PreviewFailTimeout = "timeout"; // the start passed its time
/**
 * The words of a failed preview, also the stored failure code of its row. The worker's runner maps
 * its own codes onto these; no other word reaches the wire.
 */
export const PreviewFailExited = "exited"; // a running system stopped by itself
/**
 * The words of a failed preview, also the stored failure code of its row. The worker's runner maps
 * its own codes onto these; no other word reaches the wire.
 */
export const PreviewFailDiskFull = "disk_full"; // the chat's disk was full
/**
 * The words of a failed preview, also the stored failure code of its row. The worker's runner maps
 * its own codes onto these; no other word reaches the wire.
 */
export const PreviewFailUnreachable = "unreachable"; // it answers, but on another port than the preview's
/**
 * The words of a failed preview, also the stored failure code of its row. The worker's runner maps
 * its own codes onto these; no other word reaches the wire.
 */
export const PreviewFailNoRoom = "no_room"; // the machine had no place for it in time
/**
 * The words of a failed preview, also the stored failure code of its row. The worker's runner maps
 * its own codes onto these; no other word reaches the wire.
 */
export const PreviewFailNoPage = "no_page"; // a page's folder is missing or holds no index.html
/**
 * The words of a failed preview, also the stored failure code of its row. The worker's runner maps
 * its own codes onto these; no other word reaches the wire.
 */
export const PreviewFailNoDevsh = "no_devsh"; // a system's folder is missing, or the dev.sh its default command runs
/**
 * The commands of a running system, as PreviewLast names them.
 */
export const PreviewCmdPrepare = "prepare";
/**
 * The commands of a running system, as PreviewLast names them.
 */
export const PreviewCmdStart = "start";
/**
 * The commands of a running system, as PreviewLast names them.
 */
export const PreviewCmdStatus = "status";
/**
 * The commands of a running system, as PreviewLast names them.
 */
export const PreviewCmdStop = "stop";
/**
 * The presses an owner or the AI system makes on a preview: the routes' and the doors' words.
 */
export const PreviewActStart = "start";
/**
 * The presses an owner or the AI system makes on a preview: the routes' and the doors' words.
 */
export const PreviewActStop = "stop";
/**
 * The presses an owner or the AI system makes on a preview: the routes' and the doors' words.
 */
export const PreviewActRestart = "restart";
/**
 * PreviewFolderMax bounds a page's folder in a picture: the worker's bound on a declared path.
 */
export const PreviewFolderMax = 200;
/**
 * PreviewPanels is `aichat.preview.panel`: every preview panel the presence names. It is memory only
 * on both sides — teamBase keeps it as a core.Secret, never in a row, event, log or audit entry — and
 * never masked: its purpose is to show fixture passwords and login codes.
 */
export interface PreviewPanels {
	panels: PreviewPanel[];
}
/**
 * PreviewPanel is one preview's panel: when the worker read the files, the sign-in accounts from the
 * logins file its declaration names (or why there are none), and the mail its sink holds, newest
 * first.
 */
export interface PreviewPanel {
	name: PreviewName;
	at: number /* int64 */;
	logins: PanelLogin[];
	loginsProblem?: string;
	mail: PanelMail[];
}
/**
 * PanelLogin is one test account of a preview.
 */
export interface PanelLogin {
	role: string;
	login: string;
	password: string;
	name?: string;
}
/**
 * PanelMail is one mail the previewed system sent: Kind comes from the sink's file name, and Link is
 * the first https link to this chat's own preview of the panel's name.
 */
export interface PanelMail {
	at: number /* int64 */;
	to: string;
	kind: string;
	subject: string;
	link?: string;
}
/**
 * Why a panel has no logins: the declaration names no file or the file is missing, it does not read,
 * or it holds more than the panel takes.
 */
export const LoginsMissing = "missing";
/**
 * Why a panel has no logins: the declaration names no file or the file is missing, it does not read,
 * or it holds more than the panel takes.
 */
export const LoginsInvalid = "invalid";
/**
 * Why a panel has no logins: the declaration names no file or the file is missing, it does not read,
 * or it holds more than the panel takes.
 */
export const LoginsTooLarge = "too_large";
/**
 * The panel's bounds: how many accounts and mails one panel holds, and each field's bytes. The worker's
 * reader applies the same bounds (a longer value makes the file invalid), so a valid file never yields
 * a picture teamBase drops.
 */
export const MaxPanelLogins = 20;
/**
 * The panel's bounds: how many accounts and mails one panel holds, and each field's bytes. The worker's
 * reader applies the same bounds (a longer value makes the file invalid), so a valid file never yields
 * a picture teamBase drops.
 */
export const MaxPanelMail = 10;
/**
 * The panel's bounds: how many accounts and mails one panel holds, and each field's bytes. The worker's
 * reader applies the same bounds (a longer value makes the file invalid), so a valid file never yields
 * a picture teamBase drops.
 */
export const MaxPanelField = 200; // role, login, name, a mail's subject
/**
 * The panel's bounds: how many accounts and mails one panel holds, and each field's bytes. The worker's
 * reader applies the same bounds (a longer value makes the file invalid), so a valid file never yields
 * a picture teamBase drops.
 */
export const MaxPanelPassword = 128;
/**
 * The panel's bounds: how many accounts and mails one panel holds, and each field's bytes. The worker's
 * reader applies the same bounds (a longer value makes the file invalid), so a valid file never yields
 * a picture teamBase drops.
 */
export const MaxPanelTo = 254;
/**
 * The panel's bounds: how many accounts and mails one panel holds, and each field's bytes. The worker's
 * reader applies the same bounds (a longer value makes the file invalid), so a valid file never yields
 * a picture teamBase drops.
 */
export const MaxPanelKind = 32;
/**
 * The panel's bounds: how many accounts and mails one panel holds, and each field's bytes. The worker's
 * reader applies the same bounds (a longer value makes the file invalid), so a valid file never yields
 * a picture teamBase drops.
 */
export const MaxPanelLink = 512;

//////////
// source: reshape.go

/**
 * RepoHead names a repository and a head: where the host found it, or where it is to be.
 */
export interface RepoHead {
	repo: string;
	head: string;
}
/**
 * ModeCommand is `aichat.mode`: switch the chat to To. Heads are teamBase's record of every repo:
 * the pins or the latest revision's from read to modify, the latest revision's agent head from
 * modify to read. The host records the mode, so every later spawn runs under the new mode's rules
 * (its guard, the note Claude reads). From read to modify it first runs the switch check against
 * Heads: whatever Claude changed in the read copy by a route the guard does not parse is named and
 * put back, so the first revision is teamBase's record and never the tree.
 */
export interface ModeCommand {
	to: ChatMode;
	heads: ModeHead[];
}
/**
 * ModeHead is teamBase's record of one repository at a switch: the head it expects, the main that
 * head sits on, and, where the latest revision holds uncommitted work, the work tree teamBase last
 * saw on dev — the dev-side tree of the capture it came from, withheld files included — or, for work
 * a materialise or restore put there, the revision's commit of it. Wip is that commit beside a seen
 * tree: a copy rebuilt since the capture (a bring-back) holds only the commit, and the switch check
 * takes whichever of the two the copy holds.
 */
export interface ModeHead {
	repo: string;
	expect: string;
	main: string;
	wipTree?: string;
	wip?: string;
}
/**
 * ModeDone is the data of a done `aichat.mode`: the mode now in force, each repo's head, and the
 * stray changes the switch check discarded.
 */
export interface ModeDone {
	chatMode: ChatMode;
	heads: RepoHead[];
	strays?: Strays;
}
/**
 * The reasons a reshape is refused or fails, as the host names them in `aichat.cmd`. They leave the
 * old mode in force; the chat offers Retry, which sends a new command.
 */
export const ReshapeReadOnly = "read_only"; // a writing command (capture, export, check) in a read chat
/**
 * The reasons a reshape is refused or fails, as the host names them in `aichat.cmd`. They leave the
 * old mode in force; the chat offers Retry, which sends a new command.
 */
export const ReshapeExpectMismatch = "expect_mismatch"; // a repository was not at its expected head
/**
 * The reasons a reshape is refused or fails, as the host names them in `aichat.cmd`. They leave the
 * old mode in force; the chat offers Retry, which sends a new command.
 */
export const ReshapeCheck = "check"; // the switch check could not put the copy back to the record
/**
 * The reasons a reshape is refused or fails, as the host names them in `aichat.cmd`. They leave the
 * old mode in force; the chat offers Retry, which sends a new command.
 */
export const ReshapeGit = "git";
/**
 * The reasons a reshape is refused or fails, as the host names them in `aichat.cmd`. They leave the
 * old mode in force; the chat offers Retry, which sends a new command.
 */
export const ReshapeDiskFloor = "disk_floor";
/**
 * The reasons a reshape is refused or fails, as the host names them in `aichat.cmd`. They leave the
 * old mode in force; the chat offers Retry, which sends a new command.
 */
export const ReshapeMaterialise = "materialise_failed";
/**
 * The reasons a reshape is refused or fails, as the host names them in `aichat.cmd`. They leave the
 * old mode in force; the chat offers Retry, which sends a new command.
 */
export const ReshapeBlobMissing = "blob_missing";
/**
 * ReshapeNotARepo is a repository of the copy that is gone or no repository any more; with
 * ReshapeBlobMissing it is a copy teamBase lays out again from its record (S08 §4a step 2).
 */
export const ReshapeNotARepo = "not_a_repo";

//////////
// source: steps.go

/**
 * StepsVersion is the header's `steps` value.
 */
export const StepsVersion = 1;
/**
 * MaxStepLine bounds one line of a steps blob: one step item.
 */
export const MaxStepLine = MaxItemJSON;
/**
 * StepsHeader is the first line of a steps blob.
 */
export interface StepsHeader {
	steps: number /* int */;
	/**
	 * Agent is the src of the agent row the steps belong to.
	 */
	agent: string;
	/**
	 * Count is the number of step lines that follow; Truncated says the agent made more than
	 * MaxStepsPerAgent and the rest were counted, not kept.
	 */
	count: number /* int */;
	truncated?: boolean;
}
/**
 * StepsWriter writes one steps blob. The host hands it the header and the spooled lines as they
 * are; each line must already be one step item's JSON.
 */
export interface StepsWriter {
}

//////////
// source: suites.go

/**
 * CheckKind is what a step checks, and so how its outcome is compared with the base's.
 */
export type CheckKind = string;
/**
 * CheckBuild is worse when it passed at the base and does not at the head.
 */
export const CheckBuild: CheckKind = "build";
/**
 * CheckDiagnostics is worse when a touched path has more lines per message at the head.
 */
export const CheckDiagnostics: CheckKind = "diagnostics";
/**
 * CheckTests is worse when a package that passed (or did not exist) at the base fails (R1b).
 */
export const CheckTests: CheckKind = "tests";
/**
 * The tokens a step's argv may carry, replaced by the runner with what the revision touched.
 */
export const TokenTouchedPackages = "{touched_packages}";
/**
 * The tokens a step's argv may carry, replaced by the runner with what the revision touched.
 */
export const TokenTouchedGroups = "{touched_groups}";
/**
 * CheckStep is one step of a suite.
 */
export interface CheckStep {
	id: string;
	kind: CheckKind;
	/**
	 * Place is the directory the step runs in, relative to the chat's src directory.
	 */
	place: string;
	/**
	 * Run are the commands of the step, in order; the first that fails fails the step.
	 */
	run: string[][];
	/**
	 * Env is added to the suite's environment for this step.
	 */
	env?: { [key: string]: string};
	/**
	 * TimeoutSec bounds the step.
	 */
	timeoutSec: number /* int */;
}
/**
 * Suite is one part's checks.
 */
export interface Suite {
	id: string;
	steps: CheckStep[];
	/**
	 * Previous is the digest of the suite this one replaced, "" for the first. The worker reports
	 * the digest of what it rendered; teamBase compares runs only under one digest and accepts the
	 * current one and Previous, so either machine may be upgraded first.
	 */
	previous?: string;
}
/**
 * Timeouts of a check run.
 */
export const CheckStepTimeoutSec = 600;
/**
 * Timeouts of a check run.
 */
export const CheckRunTimeoutSec = 1200;

//////////
// source: terminal.go

/**
 * TerminalOutput is the flow frame `aichat.terminal.output`: B64 is the standard base64 of the bytes
 * the terminal wrote at Off of generation Gen, drawn at Cols × Rows. A keyframe (Key) is a capture of
 * the history and the screen taken at Off; it does not advance the offset.
 */
export interface TerminalOutput {
	gen: number /* int64 */;
	off: number /* int64 */;
	cols: number /* int */;
	rows: number /* int */;
	key?: boolean;
	b64: string;
}
/**
 * TerminalInput is the secret want `aichat.terminal.input`: keys an owner typed (B64, the standard
 * base64 of at most TermChunkMax bytes) against generation Gen. teamBase stamps who typed them (By)
 * and what that owner may not do (Refuse): the keys always reach Claude Code — Esc and /logout must
 * work for everyone — and the host blocks a prompt the refusal names when it is submitted.
 */
export interface TerminalInput {
	gen: number /* int64 */;
	by: number /* int64 */;
	refuse?: HookBlock;
	b64: string;
}
/**
 * TerminalWant is what the presence want says about the terminal while somebody has it open: the size
 * teamBase chose for it, the newest redraw nonce (a new one asks for a keyframe), and whether any open
 * page shows it (Pump; a hidden tab watches without bytes). Nil in the presence want: nobody watches,
 * and the host sends no output.
 */
export interface TerminalWant {
	cols: number /* int */;
	rows: number /* int */;
	redraw?: string;
	pump: boolean;
}
/**
 * TerminalState is the terminal as the host's picture reports it: its state (TerminalStates) and
 * since when, its generation and size and who chose the size, the restart it owes
 * (RestartDueReasons), and its code — while broken why, while off why it last ended (TerminalEnds).
 * LinePending says a line was typed and not yet submitted under an attached writer: the hand-over to
 * the chat view waits for it, and nothing restarts the terminal under it. HoldSince is when something
 * that ends the terminal — a switch, a restart, the idle stop — began to wait for that line (0: none
 * waits): at HoldSince + TerminalHoldMax the host clears it, and the bar warns a minute before.
 */
export interface TerminalState {
	state: string;
	gen?: number /* int64 */;
	cols?: number /* int */;
	rows?: number /* int */;
	sizeBy?: number /* int64 */;
	restartDue?: string;
	code?: string;
	since?: number /* int64 */;
	linePending?: boolean;
	holdSince?: number /* int64 */;
}
/**
 * The states of the terminal.
 */
export const TerminalOff = "off"; // no terminal process
/**
 * The states of the terminal.
 */
export const TerminalStarting = "starting"; // the launcher is starting it; input is taken, for a dialog before Claude is ready
/**
 * The states of the terminal.
 */
export const TerminalReady = "ready"; // Claude Code waits for a prompt
/**
 * The states of the terminal.
 */
export const TerminalTurn = "turn"; // a turn typed in the terminal runs
/**
 * The states of the terminal.
 */
export const TerminalEnding = "ending"; // the host is ending it quietly (Claude Code's own exit)
/**
 * The states of the terminal.
 */
export const TerminalBroken = "broken"; // the host holds it broken until a person starts it again
/**
 * Why a terminal last ended, its code while off; a chat's row keeps it for TerminalEndShowFor.
 */
export const TerminalEndIdle = "idle"; // nothing happened in it for the idle stop
/**
 * Why a terminal last ended, its code while off; a chat's row keeps it for TerminalEndShowFor.
 */
export const TerminalEndHandover = "handover"; // the chat view took the session over
/**
 * Why a terminal last ended, its code while off; a chat's row keeps it for TerminalEndShowFor.
 */
export const TerminalEndExit = "exit"; // somebody quit Claude Code in it
/**
 * Why a terminal last ended, its code while off; a chat's row keeps it for TerminalEndShowFor.
 */
export const TerminalEndEnded = "ended"; // an owner ended it
/**
 * Why a terminal last ended, its code while off; a chat's row keeps it for TerminalEndShowFor.
 */
export const TerminalEndCrash = "crash"; // the process died
/**
 * Why a terminal last ended, its code while off; a chat's row keeps it for TerminalEndShowFor.
 */
export const TerminalEndOOM = "oom"; // the container's memory ran out
/**
 * Why a terminal last ended, its code while off; a chat's row keeps it for TerminalEndShowFor.
 */
export const TerminalEndStopped = "stopped"; // the container stopped
/**
 * Why a terminal owes a restart: what it was started with has moved — the worker's build, the pinned
 * Claude Code, Claude's digest, the login it runs on, the Claude session, the chat's mode, its
 * owners, or the members' MCP servers. The host restarts it at its next quiet point, never under a
 * running turn or a pending line.
 */
export const RestartDueBuild = "build";
/**
 * Why a terminal owes a restart: what it was started with has moved — the worker's build, the pinned
 * Claude Code, Claude's digest, the login it runs on, the Claude session, the chat's mode, its
 * owners, or the members' MCP servers. The host restarts it at its next quiet point, never under a
 * running turn or a pending line.
 */
export const RestartDuePin = "pin";
/**
 * Why a terminal owes a restart: what it was started with has moved — the worker's build, the pinned
 * Claude Code, Claude's digest, the login it runs on, the Claude session, the chat's mode, its
 * owners, or the members' MCP servers. The host restarts it at its next quiet point, never under a
 * running turn or a pending line.
 */
export const RestartDueDigest = "digest";
/**
 * Why a terminal owes a restart: what it was started with has moved — the worker's build, the pinned
 * Claude Code, Claude's digest, the login it runs on, the Claude session, the chat's mode, its
 * owners, or the members' MCP servers. The host restarts it at its next quiet point, never under a
 * running turn or a pending line.
 */
export const RestartDueLogin = "login";
/**
 * Why a terminal owes a restart: what it was started with has moved — the worker's build, the pinned
 * Claude Code, Claude's digest, the login it runs on, the Claude session, the chat's mode, its
 * owners, or the members' MCP servers. The host restarts it at its next quiet point, never under a
 * running turn or a pending line.
 */
export const RestartDueSession = "session";
/**
 * Why a terminal owes a restart: what it was started with has moved — the worker's build, the pinned
 * Claude Code, Claude's digest, the login it runs on, the Claude session, the chat's mode, its
 * owners, or the members' MCP servers. The host restarts it at its next quiet point, never under a
 * running turn or a pending line.
 */
export const RestartDueMode = "mode";
/**
 * Why a terminal owes a restart: what it was started with has moved — the worker's build, the pinned
 * Claude Code, Claude's digest, the login it runs on, the Claude session, the chat's mode, its
 * owners, or the members' MCP servers. The host restarts it at its next quiet point, never under a
 * running turn or a pending line.
 */
export const RestartDueOwner = "owner";
/**
 * Why a terminal owes a restart: what it was started with has moved — the worker's build, the pinned
 * Claude Code, Claude's digest, the login it runs on, the Claude session, the chat's mode, its
 * owners, or the members' MCP servers. The host restarts it at its next quiet point, never under a
 * running turn or a pending line.
 */
export const RestartDueMCP = "mcp";
/**
 * HookBlock is why the host blocked a prompt typed in the terminal (the UserPromptSubmit hook's
 * answer). The sentence Claude Code shows for each is the browser's copy, `aichat.hook.block.<code>`,
 * generated into the worker's hook words.
 */
export type HookBlock = string;
export const HookBlockHostAway: HookBlock = "host_away"; // the session host does not answer
export const HookBlockHandover: HookBlock = "handover"; // the chat view is taking the session over
export const HookBlockUpdating: HookBlock = "updating"; // the worker is being updated
export const HookBlockRestartDue: HookBlock = "restart_due"; // the terminal restarts first
export const HookBlockGUITurn: HookBlock = "gui_turn"; // a turn of the chat view runs
export const HookBlockEnding: HookBlock = "ending"; // the terminal is ending
export const HookBlockLaneBusy: HookBlock = "lane_busy"; // the host's hook slots are all taken
export const HookBlockTurnEnding: HookBlock = "turn_ending"; // the previous turn is still ending
export const HookBlockNoTypist: HookBlock = "no_typist"; // nobody typed the prompt in the terminal
export const HookBlockLoginNone: HookBlock = "login_none"; // the typist has no active Claude token
export const HookBlockLoginUnusable: HookBlock = "login_unusable"; // the typist's active token cannot be used
export const HookBlockCutOff: HookBlock = "cut_off"; // an admin cut the chat off
export const HookBlockNoGrant: HookBlock = "no_grant"; // the login broker granted the turn nothing
/**
 * Why a message of the chat view waits for the terminal (a chat's terminal hold): somebody typed in
 * the terminal within the quiet window or holds a typed line there, or the terminal was started
 * moments ago and gets the window once.
 */
export const HoldTyping = "typing";
/**
 * Why a message of the chat view waits for the terminal (a chat's terminal hold): somebody typed in
 * the terminal within the quiet window or holds a typed line there, or the terminal was started
 * moments ago and gets the window once.
 */
export const HoldStarted = "started";
/**
 * WaitsTerminalPrompt says Claude Code waits for a person in the terminal (a permission prompt).
 */
export const WaitsTerminalPrompt = "terminal_prompt";
/**
 * The hand-over's times: a message of the chat view waits TerminalQuietWindow (a minute) after the
 * last key in the terminal, and never more than TerminalHoldMax (five minutes) in all; a chat's row
 * says why the terminal ended for TerminalEndShowFor (ten minutes).
 */
export const TerminalQuietWindow: any /* time.Duration */ = 60_000_000_000;
/**
 * The hand-over's times: a message of the chat view waits TerminalQuietWindow (a minute) after the
 * last key in the terminal, and never more than TerminalHoldMax (five minutes) in all; a chat's row
 * says why the terminal ended for TerminalEndShowFor (ten minutes).
 */
export const TerminalHoldMax: any /* time.Duration */ = 300_000_000_000;
/**
 * The hand-over's times: a message of the chat view waits TerminalQuietWindow (a minute) after the
 * last key in the terminal, and never more than TerminalHoldMax (five minutes) in all; a chat's row
 * says why the terminal ended for TerminalEndShowFor (ten minutes).
 */
export const TerminalEndShowFor: any /* time.Duration */ = 600_000_000_000;
/**
 * The screen's bounds and pace. The host flushes output at TermChunkMax bytes or after TermFlush
 * (30 ms), whichever comes first; a keyframe holds at most KeyframeMax bytes of history and screen,
 * cut from the top, and goes up at most once per KeyframeEvery (5 s); teamBase forwards at most one
 * new redraw nonce per RedrawEvery (2 s). A frame's bound, MaxTerminalOutput, holds a keyframe's
 * base64 and the frame's fields. A person's typing in the terminal is told to the others at most once
 * per TypingEveryMs.
 */
export const KeyframeMax = 256 << 10;
/**
 * The screen's bounds and pace. The host flushes output at TermChunkMax bytes or after TermFlush
 * (30 ms), whichever comes first; a keyframe holds at most KeyframeMax bytes of history and screen,
 * cut from the top, and goes up at most once per KeyframeEvery (5 s); teamBase forwards at most one
 * new redraw nonce per RedrawEvery (2 s). A frame's bound, MaxTerminalOutput, holds a keyframe's
 * base64 and the frame's fields. A person's typing in the terminal is told to the others at most once
 * per TypingEveryMs.
 */
export const TermChunkMax = 16 << 10;
/**
 * The screen's bounds and pace. The host flushes output at TermChunkMax bytes or after TermFlush
 * (30 ms), whichever comes first; a keyframe holds at most KeyframeMax bytes of history and screen,
 * cut from the top, and goes up at most once per KeyframeEvery (5 s); teamBase forwards at most one
 * new redraw nonce per RedrawEvery (2 s). A frame's bound, MaxTerminalOutput, holds a keyframe's
 * base64 and the frame's fields. A person's typing in the terminal is told to the others at most once
 * per TypingEveryMs.
 */
export const MaxTerminalOutput = 384 << 10;
/**
 * The screen's bounds and pace. The host flushes output at TermChunkMax bytes or after TermFlush
 * (30 ms), whichever comes first; a keyframe holds at most KeyframeMax bytes of history and screen,
 * cut from the top, and goes up at most once per KeyframeEvery (5 s); teamBase forwards at most one
 * new redraw nonce per RedrawEvery (2 s). A frame's bound, MaxTerminalOutput, holds a keyframe's
 * base64 and the frame's fields. A person's typing in the terminal is told to the others at most once
 * per TypingEveryMs.
 */
export const TermFlush: any /* time.Duration */ = 30_000_000;
/**
 * The screen's bounds and pace. The host flushes output at TermChunkMax bytes or after TermFlush
 * (30 ms), whichever comes first; a keyframe holds at most KeyframeMax bytes of history and screen,
 * cut from the top, and goes up at most once per KeyframeEvery (5 s); teamBase forwards at most one
 * new redraw nonce per RedrawEvery (2 s). A frame's bound, MaxTerminalOutput, holds a keyframe's
 * base64 and the frame's fields. A person's typing in the terminal is told to the others at most once
 * per TypingEveryMs.
 */
export const KeyframeEvery: any /* time.Duration */ = 5_000_000_000;
/**
 * The screen's bounds and pace. The host flushes output at TermChunkMax bytes or after TermFlush
 * (30 ms), whichever comes first; a keyframe holds at most KeyframeMax bytes of history and screen,
 * cut from the top, and goes up at most once per KeyframeEvery (5 s); teamBase forwards at most one
 * new redraw nonce per RedrawEvery (2 s). A frame's bound, MaxTerminalOutput, holds a keyframe's
 * base64 and the frame's fields. A person's typing in the terminal is told to the others at most once
 * per TypingEveryMs.
 */
export const RedrawEvery: any /* time.Duration */ = 2_000_000_000;
/**
 * The screen's bounds and pace. The host flushes output at TermChunkMax bytes or after TermFlush
 * (30 ms), whichever comes first; a keyframe holds at most KeyframeMax bytes of history and screen,
 * cut from the top, and goes up at most once per KeyframeEvery (5 s); teamBase forwards at most one
 * new redraw nonce per RedrawEvery (2 s). A frame's bound, MaxTerminalOutput, holds a keyframe's
 * base64 and the frame's fields. A person's typing in the terminal is told to the others at most once
 * per TypingEveryMs.
 */
export const TypingEveryMs = 3000;
/**
 * TermRange is an inclusive bound of a terminal's size.
 */
export interface TermRange {
	min: number /* int */;
	max: number /* int */;
}
/**
 * The terminal's size, in columns and rows: within TermCols × TermRows, and TermDefaultCols ×
 * TermDefaultRows until a viewer says otherwise. The bounds are constants so that the page, which
 * sizes its screen before it asks, reads the same numbers the server checks.
 */
export const TermColsMin = 20;
/**
 * The terminal's size, in columns and rows: within TermCols × TermRows, and TermDefaultCols ×
 * TermDefaultRows until a viewer says otherwise. The bounds are constants so that the page, which
 * sizes its screen before it asks, reads the same numbers the server checks.
 */
export const TermColsMax = 500;
/**
 * The terminal's size, in columns and rows: within TermCols × TermRows, and TermDefaultCols ×
 * TermDefaultRows until a viewer says otherwise. The bounds are constants so that the page, which
 * sizes its screen before it asks, reads the same numbers the server checks.
 */
export const TermRowsMin = 5;
/**
 * The terminal's size, in columns and rows: within TermCols × TermRows, and TermDefaultCols ×
 * TermDefaultRows until a viewer says otherwise. The bounds are constants so that the page, which
 * sizes its screen before it asks, reads the same numbers the server checks.
 */
export const TermRowsMax = 200;
/**
 * The terminal's size, in columns and rows: within TermCols × TermRows, and TermDefaultCols ×
 * TermDefaultRows until a viewer says otherwise. The bounds are constants so that the page, which
 * sizes its screen before it asks, reads the same numbers the server checks.
 */
export const TermDefaultCols = 120;
/**
 * The terminal's size, in columns and rows: within TermCols × TermRows, and TermDefaultCols ×
 * TermDefaultRows until a viewer says otherwise. The bounds are constants so that the page, which
 * sizes its screen before it asks, reads the same numbers the server checks.
 */
export const TermDefaultRows = 40;
/**
 * The tags that open the text of a user line a `!` command wrote in the terminal — its command, its
 * output, its errors — as Claude Code writes them to the session's transcript. The container's tail
 * masks such a line before it leaves the container, and the reducer shows it as shell lines; both
 * tell it by IsShellText over UserText, so what the tail masks is what the reducer shows.
 */
export const ShellInputTag = "<bash-input>";
/**
 * The tags that open the text of a user line a `!` command wrote in the terminal — its command, its
 * output, its errors — as Claude Code writes them to the session's transcript. The container's tail
 * masks such a line before it leaves the container, and the reducer shows it as shell lines; both
 * tell it by IsShellText over UserText, so what the tail masks is what the reducer shows.
 */
export const ShellStdoutTag = "<bash-stdout>";
/**
 * The tags that open the text of a user line a `!` command wrote in the terminal — its command, its
 * output, its errors — as Claude Code writes them to the session's transcript. The container's tail
 * masks such a line before it leaves the container, and the reducer shows it as shell lines; both
 * tell it by IsShellText over UserText, so what the tail masks is what the reducer shows.
 */
export const ShellStderrTag = "<bash-stderr>";
/**
 * The prompts Claude Code submits by itself in the terminal, told by how their text starts: a
 * background task's end, and a background agent's hand-back (2.1.288 runs an Agent call typed in the
 * terminal in the background and hands its result back so). tb-hook reports them as kinds of their
 * own — a block would lose the result for good —, and the reducer reads them as Claude Code's own
 * line, never a person's prompt.
 */
export const TaskNotificationPrefix = "<task-notification>";
/**
 * The prompts Claude Code submits by itself in the terminal, told by how their text starts: a
 * background task's end, and a background agent's hand-back (2.1.288 runs an Agent call typed in the
 * terminal in the background and hands its result back so). tb-hook reports them as kinds of their
 * own — a block would lose the result for good —, and the reducer reads them as Claude Code's own
 * line, never a person's prompt.
 */
export const AgentMessagePrefix = "<agent-message";
/**
 * OwnTaskIDMax bounds a task id OwnPromptTask reads.
 */
export const OwnTaskIDMax = 64;

//////////
// source: tools.go

/**
 * AgentTool is one operation of teamBase's tools: what one request on the chat's tools socket asks
 * the host for. Claude reaches an operation through one of two front ends, both the launcher binary
 * under another name, each call one connection to the socket, which names the chat (a container
 * holds one chat): the MCP server `teambase` (`tb-mcp`, started by Claude Code itself, whose tools
 * are MCPTools), and `tb-chat`, the command for Bash and for scripts (AgentToolCommands). The two
 * paired operations are MCP tools alone, so that the host pairs each call with the tool use Claude
 * Code reported for it; the previews' and the additional container's are offered by both, the
 * branches by `tb-chat` alone (Claude runs git in Bash anyway). This list, worker wire's ToolVerbs
 * (each operation's arguments) and the host's answers are one contract (S12 §8): an operation is
 * added here first.
 */
export type AgentTool = string;
/**
 * ToolSetTitle is the MCP tool set_title: Claude names the chat once, after its first turn,
 * while no person has named it. Both modes.
 */
export const ToolSetTitle: AgentTool = "set_title";
/**
 * ToolRequestModify is the MCP tool request_modify: a read-only chat asks its owners for code
 * changes. It raises a card; people answer it.
 */
export const ToolRequestModify: AgentTool = "request_modify";
/**
 * ToolPreviewList lists the chat's previews — name, kind, title, address, state, public — and with
 * a name also that preview's settings beside the worker's and its last command's lines; then the
 * previews file's problems.
 */
export const ToolPreviewList: AgentTool = "preview_list";
/**
 * ToolPreviewSave adds a preview or changes one: a field given changes, a field given empty
 * returns to its default, a field not given stays. A new name needs its kind. It never starts
 * anything.
 */
export const ToolPreviewSave: AgentTool = "preview_save";
/**
 * ToolPreviewRemove removes a preview from the file; a running system is stopped first.
 */
export const ToolPreviewRemove: AgentTool = "preview_remove";
/**
 * ToolPreviewStart starts a preview: a running system by its contract, a page by waking the
 * container and its router. A start the running budget cannot hold yet waits for a place, as an
 * owner's press does.
 */
export const ToolPreviewStart: AgentTool = "preview_start";
/**
 * ToolPreviewStop stops a running system: its stop command, then its unit.
 */
export const ToolPreviewStop: AgentTool = "preview_stop";
/**
 * ToolPreviewRestart stops a running system, then starts it.
 */
export const ToolPreviewRestart: AgentTool = "preview_restart";
/**
 * ToolPreviewStatus runs a running system's status command now, or reads a page's state.
 */
export const ToolPreviewStatus: AgentTool = "preview_status";
/**
 * ToolContainerStart starts it, and makes it at the first start, which needs the SSH public key
 * Claude reaches it with (`--key` to tb-chat, `key` to the MCP tool).
 */
export const ToolContainerStart: AgentTool = "container_start";
/**
 * ToolContainerStatus says whether it runs, and its address.
 */
export const ToolContainerStatus: AgentTool = "container_status";
/**
 * ToolContainerDelete deletes it and everything in it.
 */
export const ToolContainerDelete: AgentTool = "container_delete";
/**
 * ToolBranches is `tb-chat branches`: bring every repository's upstream/<branch> refs level with
 * the machine's copy of GitHub and list them. Local: the client refreshes the copy itself.
 */
export const ToolBranches: AgentTool = "branches";
/**
 * MCPServerName is teamBase's own MCP server as Claude Code names it: its tools reach Claude as
 * `mcp__teambase__<tool>`, and a server the members connect under this name is left out, so the name
 * always means teamBase's.
 */
export const MCPServerName = "teambase";
/**
 * MCPTool is one tool of the MCP server `teambase`. A tool carries one operation, or several told
 * apart by its `action` argument (MCPToolOps).
 */
export type MCPTool = string;
/**
 * The tools of `teambase`.
 */
export const MCPSetTitle: MCPTool = "set_title";
/**
 * The tools of `teambase`.
 */
export const MCPRequestModify: MCPTool = "request_modify";
/**
 * The tools of `teambase`.
 */
export const MCPPreviewList: MCPTool = "preview_list";
/**
 * The tools of `teambase`.
 */
export const MCPPreviewSave: MCPTool = "preview_save";
/**
 * The tools of `teambase`.
 */
export const MCPPreviewRemove: MCPTool = "preview_remove";
/**
 * The tools of `teambase`.
 */
export const MCPPreviewRun: MCPTool = "preview_run";
/**
 * The tools of `teambase`.
 */
export const MCPContainer: MCPTool = "container";
/**
 * ToolCode is the host's refusal of a call of teamBase's tools. Both front ends answer it as
 * `refused:<code>: <text>` — `tb-chat` on stdout with exit status 1, `tb-mcp` as the tool's result
 * with isError — so the transcript carries the code in the one form the reducer reads.
 */
export type ToolCode = string;
export const ToolBadTitle: ToolCode = "bad_title"; // empty, over ClaudeTitleMax, a line break or a control character
export const ToolBadReason: ToolCode = "bad_reason"; // empty, over ReasonMax, more than one paragraph or a control character
export const ToolAlreadyModify: ToolCode = "already_modify"; // a request in a chat that can already change code
export const ToolAlreadyAsked: ToolCode = "already_asked"; // a second request in the same turn
export const ToolNotMain: ToolCode = "not_main"; // a request from a subagent or a workflow agent
export const ToolLimit: ToolCode = "limit"; // more than ToolCallsPerTurn paired calls in one turn
export const ToolBusy: ToolCode = "busy"; // no tool use to pair with, or the host is stopping
export const ToolBadArgs: ToolCode = "bad_args"; // arguments that do not fit the operation's schema, refused by the front end
export const ToolReadOnly: ToolCode = "read_only"; // a system's start or restart, or container start, in a read-only chat
export const ToolUnavailable: ToolCode = "unavailable"; // teamBase does not run it for this chat now (closed or archived)
export const ToolBadName: ToolCode = "bad_name"; // a preview name outside the grammar (PreviewNamePattern)
export const ToolTooMany: ToolCode = "too_many"; // preview save: a new name while PreviewMax are declared
export const ToolNoPreview: ToolCode = "no_preview"; // the previews file declares no preview of the name
export const ToolBadSetting: ToolCode = "bad_setting"; // preview save: a field or its value is refused
export const ToolNoPage: ToolCode = "no_page"; // a page's folder is not under src, or holds no index.html
export const ToolNoDevsh: ToolCode = "no_devsh"; // a system's folder is missing, or the default start finds no dev.sh
export const ToolPortTaken: ToolCode = "port_taken"; // a system's port another preview of the chat names
export const ToolBadKey: ToolCode = "bad_key"; // container start: no usable OpenSSH public key line at creation
export const ToolNoRoom: ToolCode = "no_room"; // container start: the running budget is full
export const ToolDescriptor: ToolCode = "descriptor"; // the preview's settings are incomplete
export const ToolStartFailed: ToolCode = "start_failed"; // a system's start or restart ended failed, in any step but prepare
export const ToolPrepareFailed: ToolCode = "prepare_failed"; // a system's start or restart ended failed in its prepare step
export const ToolContainerFailed: ToolCode = "container_failed"; // container start: the root helper could not make or start it
/**
 * ToolCallsPerTurn bounds the paired calls of one turn, across operations.
 */
export const ToolCallsPerTurn = 20;
/**
 * RefusedPrefix starts the answer to a refused call, from either front end.
 */
export const RefusedPrefix = "refused:";
/**
 * GuardCode is the rule by which the host's PreToolUse guard denied a call. It sits beside the
 * walls, never instead of them: the guard gives Claude a sentence it can act on, the walls make the
 * call fail anyway.
 */
export type GuardCode = string;
export const GuardPush: GuardCode = "guard.push"; // git push, send-pack
export const GuardRemote: GuardCode = "guard.remote"; // git remote add, set-url, …
export const GuardConfig: GuardCode = "guard.config"; // any git config write
export const GuardCleanIgnored: GuardCode = "guard.clean_ignored"; // git clean -x or -X: deletes build caches
export const GuardSubmodule: GuardCode = "guard.submodule"; // git submodule add
export const GuardWorktree: GuardCode = "guard.worktree"; // git worktree but list; an agent with isolation
export const GuardReadOnly: GuardCode = "guard.read_only"; // Edit, Write or NotebookEdit in a read chat
export const GuardProtectedPath: GuardCode = "guard.protected_path"; // .git, .claude/, .mcp.json, .aichat/ outside keep
export const GuardSecondCLI: GuardCode = "guard.second_cli"; // claude but claude mcp: a second writer of the chat's session
export const GuardUpstream: GuardCode = "guard.upstream"; // merge, rebase, reset or pull onto upstream/<branch>; cherry-pick --ff

//////////
// source: validate.go

/**
 * ValidationError says what is wrong with an item: the field and the rule it broke, never the value,
 * because the value is model output and the error is logged (by src and kind only, S06 §2).
 */
export interface ValidationError {
	Field: string;
	Rule: string;
}

//////////
// source: vocab.go

/**
 * Verb is what a tool call does, in the words the transcript groups by. The reducer maps tool names
 * onto verbs (reduce/tools.go, the only file naming tools); the browser draws by verb, with a
 * generic fallback for `other`.
 */
export type Verb = string;
export const VerbRead: Verb = "read"; // Read
export const VerbList: Verb = "list"; // Glob
export const VerbSearch: Verb = "search"; // Grep
export const VerbWeb: Verb = "web"; // WebSearch, WebFetch
export const VerbWrite: Verb = "write"; // Write
export const VerbEdit: Verb = "edit"; // Edit, MultiEdit, NotebookEdit
export const VerbRun: Verb = "run"; // Bash
export const VerbMonitor: Verb = "monitor"; // Monitor
export const VerbDelegate: Verb = "delegate"; // Agent, Task
export const VerbWorkflow: Verb = "workflow"; // Workflow
export const VerbTodo: Verb = "todo"; // TaskCreate, TaskUpdate, TaskList, TaskGet, TodoWrite
export const VerbAsk: Verb = "ask"; // AskUserQuestion
export const VerbPlan: Verb = "plan"; // ExitPlanMode, EnterPlanMode
export const VerbTitle: Verb = "title"; // the set_title tool
export const VerbPreview: Verb = "preview"; // a teamBase preview or container tool
export const VerbTeamBase: Verb = "teambase"; // a Bash command that is one call of teamBase's tool sets (tb-chat <set> <tool>)
export const VerbPlumbing: Verb = "plumbing"; // ToolSearch, Skill, a helper's hand-back, a request for changes inside an agent's steps
export const VerbOther: Verb = "other"; // anything else, labelled by its name; never dropped
/**
 * ErrorCode classifies an error item (S06 §4.3). It is read from the CLI's structured fields — the
 * typed api_error first, then is_error, the error kind and compact_result — never from a subtype,
 * and the CLI's own sentence travels only as the Full-density text. A read-only chat's refused write
 * is not an error: it is a tool's readOnly flag. Two codes name a plan's missing usage credits, which
 * the CLI reports under its rate-limit kind though no plan window ran out: long_context (a request
 * past 200,000 tokens; Claude Code compacts and goes on below that size) and model_credits (a model
 * the plan runs only on credits). One names teamBase's own refusal: broker_refused, a call the login
 * broker stopped before it left the machine (a request outside a turn, or of a shape it does not
 * forward), which Claude Code reads as a failed login although the login is fine.
 */
export type ErrorCode = string;
export const ErrLimitSession: ErrorCode = "limit_session";
export const ErrLimitWeekly: ErrorCode = "limit_weekly";
export const ErrAuthFailed: ErrorCode = "auth_failed";
export const ErrAccount: ErrorCode = "account";
export const ErrOverloaded: ErrorCode = "overloaded";
export const ErrServer: ErrorCode = "server";
export const ErrConnection: ErrorCode = "connection";
export const ErrPromptTooLong: ErrorCode = "prompt_too_long";
export const ErrCompactFailed: ErrorCode = "compact_failed";
export const ErrMaxOutput: ErrorCode = "max_output";
export const ErrModelNotFound: ErrorCode = "model_not_found";
export const ErrLongContext: ErrorCode = "long_context";
export const ErrModelCredits: ErrorCode = "model_credits";
export const ErrMaxTurns: ErrorCode = "max_turns";
export const ErrBudget: ErrorCode = "budget";
export const ErrRefusal: ErrorCode = "refusal";
export const ErrRefusalFallback: ErrorCode = "refusal_fallback";
export const ErrMirrorLost: ErrorCode = "mirror_lost";
export const ErrCLIWarning: ErrorCode = "cli_warning";
export const ErrStream: ErrorCode = "stream_error";
export const ErrCLIExit: ErrorCode = "cli_exit";
export const ErrBrokerRefused: ErrorCode = "broker_refused";
export const ErrOther: ErrorCode = "other";
/**
 * DenialReason says who refused a tool call.
 */
export type DenialReason = string;
export const DenialClassifier: DenialReason = "classifier"; // auto mode's classifier
export const DenialRestricted: DenialReason = "restricted"; // the CLI's restricted mode
export const DenialSafety: DenialReason = "safety";
export const DenialRule: DenialReason = "rule"; // a permission rule of the settings file
export const DenialGuard: DenialReason = "guard"; // the host's PreToolUse guard; its rule is the denial's code
export const DenialAskDenied: DenialReason = "ask_denied"; // a can_use_tool the host answered with a deny
export const DenialOther: DenialReason = "other";
/**
 * AnswerHow is how a card's answer came about: a person chose it; the watchdog took the
 * recommended option or parked the card; it was set aside at close, archive or a new conversation;
 * a newer request superseded it; or an owner's own switch to modify answered a modify card.
 */
export type AnswerHow = string;
export const HowPerson: AnswerHow = "person";
export const HowAuto: AnswerHow = "auto";
export const HowParked: AnswerHow = "parked";
export const HowSetAside: AnswerHow = "set_aside";
export const HowSuperseded: AnswerHow = "superseded";
export const HowSwitch: AnswerHow = "switch";
/**
 * AnswerChoice is the decision an answer records: a modify card's allow or keep, a plan card's
 * start or revise, a question card's answer or skip.
 */
export type AnswerChoice = string;
export const ChoiceAllow: AnswerChoice = "allow";
export const ChoiceKeep: AnswerChoice = "keep";
export const ChoiceStart: AnswerChoice = "start";
export const ChoiceRevise: AnswerChoice = "revise";
export const ChoiceAnswer: AnswerChoice = "answer";
export const ChoiceSkip: AnswerChoice = "skip";
/**
 * Marker says how the transcript draws a shared act: as a row of its own (a divider the history
 * turns on: the mode, the parts), joined to the marker item written beside it (a compaction, a
 * landing), or as an ordinary event row.
 */
export type Marker = string;
export const MarkerNone: Marker = "none";
export const MarkerPaired: Marker = "paired";
export const MarkerOwn: Marker = "own";
/**
 * EventKind is a shared act recorded as an `event` item: ids and names only, never a prompt, a
 * reason or a title.
 */
export type EventKind = string;
/**
 * EventSpec is one row of the event catalogue.
 */
export interface EventSpec {
	kind: EventKind;
	marker: Marker;
	countable: boolean;
}
/**
 * NoticeCode is what a notice item says. The set is declared here and each owner of a notice adds
 * its codes (additively, like every word here): the domain its pauses and refused reshapes, the git
 * flow its import and adopt notices, operations its CLI rollback.
 */
export type NoticeCode = string;
/**
 * NoticeSpec is one row of the notice catalogue. Summary notices are drawn at every density and get
 * a durable event; the others are Work and Full detail. Countable ones — the attention notices —
 * move the unread dot, and are always Summary ones.
 */
export interface NoticeSpec {
	code: NoticeCode;
	summary: boolean;
	countable: boolean;
}
/**
 * The terminal's notice codes, which the worker's relay counts too (HealthTerminals.SecondWriters7d).
 */
export const NoticeSecondWriter: NoticeCode = "second_writer";
/**
 * The terminal's notice codes, which the worker's relay counts too (HealthTerminals.SecondWriters7d).
 */
export const NoticeTerminalLeftSession: NoticeCode = "terminal_left_session";
/**
 * Enum is one named word set, as a tag names it and vocab.json prints it.
 */
export interface Enum {
	name: string;
	values: string[];
}
